//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getActivity(activityId: number): Promise<ActivityItem> {
        let url_ = this.baseUrl + "/api/activities/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivity(_response);
        });
    }

    protected processGetActivity(response: Response): Promise<ActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityItem>(null as any);
    }

    deleteActivity(activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/activities/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteActivity(_response);
        });
    }

    protected processDeleteActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateActivity(model: ActivityUpdateItem): Promise<ActivityItem> {
        let url_ = this.baseUrl + "/api/activities/updateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateActivity(_response);
        });
    }

    protected processUpdateActivity(response: Response): Promise<ActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityItem>(null as any);
    }

    deleteActivityByPlannedActivityRow(plannedActivityRowId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/activities/byPlannedActivityRow/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteActivityByPlannedActivityRow(_response);
        });
    }

    protected processDeleteActivityByPlannedActivityRow(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(model: ActivityCreateItem): Promise<ActivityItem> {
        let url_ = this.baseUrl + "/api/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityItem>(null as any);
    }

    createOneTimeActivity(oneTimeActivityRouteId: number, model: ActivityCreateItem): Promise<ActivityItem> {
        let url_ = this.baseUrl + "/api/activities/createOneTimeActivity/{oneTimeActivityRouteId}";
        if (oneTimeActivityRouteId === undefined || oneTimeActivityRouteId === null)
            throw new Error("The parameter 'oneTimeActivityRouteId' must be defined.");
        url_ = url_.replace("{oneTimeActivityRouteId}", encodeURIComponent("" + oneTimeActivityRouteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOneTimeActivity(_response);
        });
    }

    protected processCreateOneTimeActivity(response: Response): Promise<ActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityItem>(null as any);
    }

    isTemporaryActivityCreatedToday(plannedActivityRowId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/activities/isTemporaryActivityCreatedToday/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsTemporaryActivityCreatedToday(_response);
        });
    }

    protected processIsTemporaryActivityCreatedToday(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    listCustomerActivities(customerId: number): Promise<ActivityListItem[]> {
        let url_ = this.baseUrl + "/api/activities/listCustomerActivities/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListCustomerActivities(_response);
        });
    }

    protected processListCustomerActivities(response: Response): Promise<ActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityListItem[]>(null as any);
    }

    listAreaActivities(areaId: number): Promise<ActivityListItem[]> {
        let url_ = this.baseUrl + "/api/activities/listAreaActivities/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAreaActivities(_response);
        });
    }

    protected processListAreaActivities(response: Response): Promise<ActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityListItem[]>(null as any);
    }

    listFuturePenMarkedActivities(plannedActivityRowId: number, onlyTodaysSeries: boolean): Promise<PlannedActivityRowPlanningViewItem[]> {
        let url_ = this.baseUrl + "/api/activities/listFuturePenMarkedActivities/{plannedActivityRowId}/{onlyTodaysSeries}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        if (onlyTodaysSeries === undefined || onlyTodaysSeries === null)
            throw new Error("The parameter 'onlyTodaysSeries' must be defined.");
        url_ = url_.replace("{onlyTodaysSeries}", encodeURIComponent("" + onlyTodaysSeries));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFuturePenMarkedActivities(_response);
        });
    }

    protected processListFuturePenMarkedActivities(response: Response): Promise<PlannedActivityRowPlanningViewItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedActivityRowPlanningViewItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowPlanningViewItem[]>(null as any);
    }

    listFutureChangedActivities(plannedActivityRowId: number, onlyTodaysSeries: boolean): Promise<FutureRouteActivityRowItem[]> {
        let url_ = this.baseUrl + "/api/activities/listFutureChangedActivities/{plannedActivityRowId}/{onlyTodaysSeries}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        if (onlyTodaysSeries === undefined || onlyTodaysSeries === null)
            throw new Error("The parameter 'onlyTodaysSeries' must be defined.");
        url_ = url_.replace("{onlyTodaysSeries}", encodeURIComponent("" + onlyTodaysSeries));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFutureChangedActivities(_response);
        });
    }

    protected processListFutureChangedActivities(response: Response): Promise<FutureRouteActivityRowItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FutureRouteActivityRowItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FutureRouteActivityRowItem[]>(null as any);
    }

    listRecentPerformedActivitiesOnCustomer(customerId: number): Promise<RecentPerformedSigningItem[]> {
        let url_ = this.baseUrl + "/api/activities/listRecentActivities/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListRecentPerformedActivitiesOnCustomer(_response);
        });
    }

    protected processListRecentPerformedActivitiesOnCustomer(response: Response): Promise<RecentPerformedSigningItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentPerformedSigningItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentPerformedSigningItem[]>(null as any);
    }

    listFuturePlannedActivitiesOnCustomer(customerId: number): Promise<FuturePlannedActivityItem[]> {
        let url_ = this.baseUrl + "/api/activities/listFuturePlannedActivities/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFuturePlannedActivitiesOnCustomer(_response);
        });
    }

    protected processListFuturePlannedActivitiesOnCustomer(response: Response): Promise<FuturePlannedActivityItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuturePlannedActivityItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FuturePlannedActivityItem[]>(null as any);
    }

    unplanAllPlannedActivityRowSeries(model: UnplanAllPlannedActivityRowSeriesItem): Promise<RoutePlanningViewItem> {
        let url_ = this.baseUrl + "/api/activities/unplanAllPlannedActivityRowSeriesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnplanAllPlannedActivityRowSeries(_response);
        });
    }

    protected processUnplanAllPlannedActivityRowSeries(response: Response): Promise<RoutePlanningViewItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutePlanningViewItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoutePlanningViewItem>(null as any);
    }

    movePlannedActivityRowSeries(model: MovePlannedActivityRowSeriesItem): Promise<RoutePlanningViewItem> {
        let url_ = this.baseUrl + "/api/activities/movePlannedActivityRowSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMovePlannedActivityRowSeries(_response);
        });
    }

    protected processMovePlannedActivityRowSeries(response: Response): Promise<RoutePlanningViewItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutePlanningViewItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoutePlanningViewItem>(null as any);
    }

    updatePlannedActivityRow(newRouteId: number | null | undefined, model: PlannedActivityRowUpdateItem): Promise<PlannedActivityRowItem> {
        let url_ = this.baseUrl + "/api/activities/updatePlannedActivityRow?";
        if (newRouteId !== undefined && newRouteId !== null)
            url_ += "newRouteId=" + encodeURIComponent("" + newRouteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePlannedActivityRow(_response);
        });
    }

    protected processUpdatePlannedActivityRow(response: Response): Promise<PlannedActivityRowItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedActivityRowItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowItem>(null as any);
    }

    getPlannedActivityRow(plannedActivityRowId: number): Promise<PlannedActivityRowItem> {
        let url_ = this.baseUrl + "/api/activities/getPlannedActivityRow/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlannedActivityRow(_response);
        });
    }

    protected processGetPlannedActivityRow(response: Response): Promise<PlannedActivityRowItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedActivityRowItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowItem>(null as any);
    }

    signPlannedActivityRow(model: PlannedActivityRowSigningCreateItem): Promise<PlannedActivityRowItem> {
        let url_ = this.baseUrl + "/api/activities/signPlannedActivityRow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignPlannedActivityRow(_response);
        });
    }

    protected processSignPlannedActivityRow(response: Response): Promise<PlannedActivityRowItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedActivityRowItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowItem>(null as any);
    }

    signDelayedActivityRow(model: PlannedActivityRowSigningCreateItem): Promise<PlannedActivityRowItem> {
        let url_ = this.baseUrl + "/api/activities/signDelayedActivityRow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignDelayedActivityRow(_response);
        });
    }

    protected processSignDelayedActivityRow(response: Response): Promise<PlannedActivityRowItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedActivityRowItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowItem>(null as any);
    }

    multiSignPlannedActivities(model: MultiSignItem): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/activities/multiSignPlannedActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiSignPlannedActivities(_response);
        });
    }

    protected processMultiSignPlannedActivities(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listActivitiesToMultiSign(plannedActivityIds: number[]): Promise<MultiSignActivityItem[]> {
        let url_ = this.baseUrl + "/api/activities/listActivitiesToMultiSign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedActivityIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListActivitiesToMultiSign(_response);
        });
    }

    protected processListActivitiesToMultiSign(response: Response): Promise<MultiSignActivityItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiSignActivityItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiSignActivityItem[]>(null as any);
    }

    getAreasPlannedActivityRowSignings(areaId: number, fromDate: Date, toDate: Date): Promise<PlannedActivityRowSigningItem[]> {
        let url_ = this.baseUrl + "/api/activities/getAreasPlannedActivityRowSignings/{areaId}/{fromDate}/{toDate}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAreasPlannedActivityRowSignings(_response);
        });
    }

    protected processGetAreasPlannedActivityRowSignings(response: Response): Promise<PlannedActivityRowSigningItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedActivityRowSigningItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowSigningItem[]>(null as any);
    }

    getPlannedActivityRowDelaySignings(plannedActivityRowId: number): Promise<PlannedActivityRowSigningItem[]> {
        let url_ = this.baseUrl + "/api/activities/getPlannedActivityRowDelaySignings/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlannedActivityRowDelaySignings(_response);
        });
    }

    protected processGetPlannedActivityRowDelaySignings(response: Response): Promise<PlannedActivityRowSigningItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedActivityRowSigningItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowSigningItem[]>(null as any);
    }

    getActiveDelayedSignings(plannedActivityRowId: number): Promise<PlannedActivityRowSigningItem[]> {
        let url_ = this.baseUrl + "/api/activities/getActiveDelayedSignings/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveDelayedSignings(_response);
        });
    }

    protected processGetActiveDelayedSignings(response: Response): Promise<PlannedActivityRowSigningItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedActivityRowSigningItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRowSigningItem[]>(null as any);
    }

    getRecentActivitySignings(plannedActivityRowId: number): Promise<RecentPerformedSigningItem[]> {
        let url_ = this.baseUrl + "/api/activities/getRecentActivitySignings/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentActivitySignings(_response);
        });
    }

    protected processGetRecentActivitySignings(response: Response): Promise<RecentPerformedSigningItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentPerformedSigningItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentPerformedSigningItem[]>(null as any);
    }

    listNotFulfilledDelegations(plannedActivityRowId: number): Promise<FulfilledDelegationItem[]> {
        let url_ = this.baseUrl + "/api/activities/listNotFulfilledDelegations/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNotFulfilledDelegations(_response);
        });
    }

    protected processListNotFulfilledDelegations(response: Response): Promise<FulfilledDelegationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FulfilledDelegationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FulfilledDelegationItem[]>(null as any);
    }

    getDelayedActivityShouldOccurToday(plannedActivityRowId: number, kioskGuid: string, start: Date, end: Date): Promise<boolean> {
        let url_ = this.baseUrl + "/api/activities/getDelayedActivityShouldOccurToday/{plannedActivityRowId}/{kioskGuid}/{start}/{end}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        if (kioskGuid === undefined || kioskGuid === null)
            throw new Error("The parameter 'kioskGuid' must be defined.");
        url_ = url_.replace("{kioskGuid}", encodeURIComponent("" + kioskGuid));
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined.");
        url_ = url_.replace("{start}", encodeURIComponent(start ? "" + start.toISOString() : "null"));
        if (end === undefined || end === null)
            throw new Error("The parameter 'end' must be defined.");
        url_ = url_.replace("{end}", encodeURIComponent(end ? "" + end.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDelayedActivityShouldOccurToday(_response);
        });
    }

    protected processGetDelayedActivityShouldOccurToday(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDelayedActivityShouldOccurTodayOnArea(plannedActivityRowId: number, areaId: number, start: Date, end: Date): Promise<boolean> {
        let url_ = this.baseUrl + "/api/activities/getDelayedActivityShouldOccurTodayOnArea/{plannedActivityRowId}/{areaId}/{start}/{end}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined.");
        url_ = url_.replace("{start}", encodeURIComponent(start ? "" + start.toISOString() : "null"));
        if (end === undefined || end === null)
            throw new Error("The parameter 'end' must be defined.");
        url_ = url_.replace("{end}", encodeURIComponent(end ? "" + end.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDelayedActivityShouldOccurTodayOnArea(_response);
        });
    }

    protected processGetDelayedActivityShouldOccurTodayOnArea(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getActivityHasActiveDelayedOccurance(plannedActivityRowId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/activities/getActivityHasActiveDelayedOccurance/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivityHasActiveDelayedOccurance(_response);
        });
    }

    protected processGetActivityHasActiveDelayedOccurance(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPlannedDailyActivity(plannedActivityRowId: number): Promise<DailyActivityItem> {
        let url_ = this.baseUrl + "/api/activities/getPlannedDailyActivity/{plannedActivityRowId}";
        if (plannedActivityRowId === undefined || plannedActivityRowId === null)
            throw new Error("The parameter 'plannedActivityRowId' must be defined.");
        url_ = url_.replace("{plannedActivityRowId}", encodeURIComponent("" + plannedActivityRowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlannedDailyActivity(_response);
        });
    }

    protected processGetPlannedDailyActivity(response: Response): Promise<DailyActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DailyActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyActivityItem>(null as any);
    }
}

export class BatchJobClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    generateOrganizationsPlannedActivitiesAndPlannedRoutesBatchJob(organizationId: number, generateUntilDate: Date): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/activities/BatchJob_GenerateOrganizationsPlannedActivitiesAndPlannedRoutesBatchJob/{organizationId}/{generateUntilDate}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (generateUntilDate === undefined || generateUntilDate === null)
            throw new Error("The parameter 'generateUntilDate' must be defined.");
        url_ = url_.replace("{generateUntilDate}", encodeURIComponent(generateUntilDate ? "" + generateUntilDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateOrganizationsPlannedActivitiesAndPlannedRoutesBatchJob(_response);
        });
    }

    protected processGenerateOrganizationsPlannedActivitiesAndPlannedRoutesBatchJob(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AreaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAreaById(areaId: number): Promise<AreaItem> {
        let url_ = this.baseUrl + "/api/areas/getArea/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAreaById(_response);
        });
    }

    protected processGetAreaById(response: Response): Promise<AreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaItem>(null as any);
    }

    getAllAreas(userId: number): Promise<AreaForUserListItem[]> {
        let url_ = this.baseUrl + "/api/areas/getAllAreas/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAreas(_response);
        });
    }

    protected processGetAllAreas(response: Response): Promise<AreaForUserListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaForUserListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaForUserListItem[]>(null as any);
    }

    listAreasOnKiosk(kioskGuid: string): Promise<AreaDropListItem[]> {
        let url_ = this.baseUrl + "/api/areas/kiosk/{kioskGuid}";
        if (kioskGuid === undefined || kioskGuid === null)
            throw new Error("The parameter 'kioskGuid' must be defined.");
        url_ = url_.replace("{kioskGuid}", encodeURIComponent("" + kioskGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAreasOnKiosk(_response);
        });
    }

    protected processListAreasOnKiosk(response: Response): Promise<AreaDropListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDropListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDropListItem[]>(null as any);
    }

    update(model: AreaUpdateItem): Promise<AreaItem> {
        let url_ = this.baseUrl + "/api/areas/updateArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<AreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaItem>(null as any);
    }
}

export class AuthenticationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    generateJwtTokenFromLogin(model: LoginAppModel): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/authentication/generateJwtTokenFromLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJwtTokenFromLogin(_response);
        });
    }

    protected processGenerateJwtTokenFromLogin(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    generateJwtTokenFromPin(model: LoginWithPinAppModel): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/authentication/generateJwtTokenFromPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJwtTokenFromPin(_response);
        });
    }

    protected processGenerateJwtTokenFromPin(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    generateJwtTokenFromRefreshToken(model: AuthWithRefreshTokenAppModel): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/authentication/generateJwtTokenFromRefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJwtTokenFromRefreshToken(_response);
        });
    }

    protected processGenerateJwtTokenFromRefreshToken(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    revokeRefreshToken(model: RevokeRefreshTokenAppModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/authentication/revokeRefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRevokeRefreshToken(_response);
        });
    }

    protected processRevokeRefreshToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    forgotPassword(email: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/authentication/forgotPassword/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    initiateGidsFrejaeId(organization: string): Promise<FederatedLoginResponse> {
        let url_ = this.baseUrl + "/api/authentication/initiateGidsFrejaeId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitiateGidsFrejaeId(_response);
        });
    }

    protected processInitiateGidsFrejaeId(response: Response): Promise<FederatedLoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederatedLoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederatedLoginResponse>(null as any);
    }

    initiateGidsSaml(organization: string): Promise<FederatedLoginResponse> {
        let url_ = this.baseUrl + "/api/authentication/initiateGidsSaml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitiateGidsSaml(_response);
        });
    }

    protected processInitiateGidsSaml(response: Response): Promise<FederatedLoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederatedLoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederatedLoginResponse>(null as any);
    }

    logutFromGids(model: GrandIdRequestModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/authentication/logoutFromGids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogutFromGids(_response);
        });
    }

    protected processLogutFromGids(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateJwtTokenFromGidsSession(model: GrandIdRequestModel): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/authentication/generateJwtTokenFromGidsSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJwtTokenFromGidsSession(_response);
        });
    }

    protected processGenerateJwtTokenFromGidsSession(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    isRequestorValid(deviceGuid: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/authentication/{deviceGuid}/requestorValid";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsRequestorValid(_response);
        });
    }

    protected processIsRequestorValid(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRequestorKioskTokenByGuid(deviceGuid: string): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/authentication/{deviceGuid}/requestorKioskTokenByGuid";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestorKioskTokenByGuid(_response);
        });
    }

    protected processGetRequestorKioskTokenByGuid(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    getRequestorValidity(deviceGuid: string): Promise<RequestorValidityItem> {
        let url_ = this.baseUrl + "/api/authentication/{deviceGuid}/requestorValidity";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestorValidity(_response);
        });
    }

    protected processGetRequestorValidity(response: Response): Promise<RequestorValidityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestorValidityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestorValidityItem>(null as any);
    }
}

export class CustomerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(customerId: number): Promise<CustomerItem> {
        let url_ = this.baseUrl + "/api/customers/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CustomerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerItem>(null as any);
    }

    remove(customerId: number, onlyInactivate: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customers/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (onlyInactivate === null)
            throw new Error("The parameter 'onlyInactivate' cannot be null.");
        else if (onlyInactivate !== undefined)
            url_ += "onlyInactivate=" + encodeURIComponent("" + onlyInactivate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCustomerWithActivitiesAndPausedPeriods(customerId: number): Promise<CustomerItem> {
        let url_ = this.baseUrl + "/api/customers/getcustomerwithactivitiesandpausedperiods/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerWithActivitiesAndPausedPeriods(_response);
        });
    }

    protected processGetCustomerWithActivitiesAndPausedPeriods(response: Response): Promise<CustomerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerItem>(null as any);
    }

    getHistoricalById(customerId: number, time: Date): Promise<CustomerItem> {
        let url_ = this.baseUrl + "/api/customers/GetHistoricalById/{customerId}/{time}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (time === undefined || time === null)
            throw new Error("The parameter 'time' must be defined.");
        url_ = url_.replace("{time}", encodeURIComponent(time ? "" + time.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoricalById(_response);
        });
    }

    protected processGetHistoricalById(response: Response): Promise<CustomerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerItem>(null as any);
    }

    list(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfCustomerListItem> {
        let url_ = this.baseUrl + "/api/customers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PageResultOfCustomerListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfCustomerListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfCustomerListItem>(null as any);
    }

    create(model: CustomerCreateItem): Promise<CustomerItem> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CustomerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerItem>(null as any);
    }

    update(model: CustomerUpdateItem): Promise<CustomerItem> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CustomerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerItem>(null as any);
    }

    listCustomersOnKiosk(kioskGuid: string, clientNowTicks: number | undefined): Promise<CustomerListItem[]> {
        let url_ = this.baseUrl + "/api/customers/kiosk/{kioskGuid}?";
        if (kioskGuid === undefined || kioskGuid === null)
            throw new Error("The parameter 'kioskGuid' must be defined.");
        url_ = url_.replace("{kioskGuid}", encodeURIComponent("" + kioskGuid));
        if (clientNowTicks === null)
            throw new Error("The parameter 'clientNowTicks' cannot be null.");
        else if (clientNowTicks !== undefined)
            url_ += "clientNowTicks=" + encodeURIComponent("" + clientNowTicks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListCustomersOnKiosk(_response);
        });
    }

    protected processListCustomersOnKiosk(response: Response): Promise<CustomerListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerListItem[]>(null as any);
    }

    listActiveCustomersOnArea(areaId: number): Promise<CustomerListItem[]> {
        let url_ = this.baseUrl + "/api/customers/area/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListActiveCustomersOnArea(_response);
        });
    }

    protected processListActiveCustomersOnArea(response: Response): Promise<CustomerListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerListItem[]>(null as any);
    }

    createCustomerPausedPeriod(model: CustomerPausedPeriodCreateItem): Promise<CustomerPausedPeriodItem> {
        let url_ = this.baseUrl + "/api/customers/createCustomerPausedPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomerPausedPeriod(_response);
        });
    }

    protected processCreateCustomerPausedPeriod(response: Response): Promise<CustomerPausedPeriodItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPausedPeriodItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerPausedPeriodItem>(null as any);
    }

    updateCustomerPausedPeriod(model: CustomerPausedPeriodItem): Promise<CustomerPausedPeriodItem> {
        let url_ = this.baseUrl + "/api/customers/updateCustomerPausedPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerPausedPeriod(_response);
        });
    }

    protected processUpdateCustomerPausedPeriod(response: Response): Promise<CustomerPausedPeriodItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPausedPeriodItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerPausedPeriodItem>(null as any);
    }

    listCustomerPausedPeriods(customerId: number): Promise<CustomerPausedPeriodItem[]> {
        let url_ = this.baseUrl + "/api/customers/listCustomerPausedPeriods/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListCustomerPausedPeriods(_response);
        });
    }

    protected processListCustomerPausedPeriods(response: Response): Promise<CustomerPausedPeriodItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerPausedPeriodItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerPausedPeriodItem[]>(null as any);
    }

    hasAreaTemplateActivityUsage(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customers/{id}/hasAreaTemplateActivityUsage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasAreaTemplateActivityUsage(_response);
        });
    }

    protected processHasAreaTemplateActivityUsage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DelegationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createDelegation(model: DelegationCreateItem): Promise<DelegationItem> {
        let url_ = this.baseUrl + "/api/delegations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDelegation(_response);
        });
    }

    protected processCreateDelegation(response: Response): Promise<DelegationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationItem>(null as any);
    }

    updateDelegation(model: DelegationUpdateItem): Promise<DelegationItem> {
        let url_ = this.baseUrl + "/api/delegations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDelegation(_response);
        });
    }

    protected processUpdateDelegation(response: Response): Promise<DelegationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationItem>(null as any);
    }

    getDelegation(id: number): Promise<DelegationItem> {
        let url_ = this.baseUrl + "/api/delegations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDelegation(_response);
        });
    }

    protected processGetDelegation(response: Response): Promise<DelegationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationItem>(null as any);
    }

    deleteDelegation(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/delegations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDelegation(_response);
        });
    }

    protected processDeleteDelegation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listOrganizationDelegations(organizationId: number): Promise<DelegationListItem[]> {
        let url_ = this.baseUrl + "/api/delegations/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationDelegations(_response);
        });
    }

    protected processListOrganizationDelegations(response: Response): Promise<DelegationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationListItem[]>(null as any);
    }

    listExpiringDelegations(organizationId: number, fromDate: Date, toDate: Date): Promise<ExpiringDelegationItem[]> {
        let url_ = this.baseUrl + "/api/delegations/list/organization/{organizationId}/expiring/{fromDate}/{toDate}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListExpiringDelegations(_response);
        });
    }

    protected processListExpiringDelegations(response: Response): Promise<ExpiringDelegationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpiringDelegationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpiringDelegationItem[]>(null as any);
    }

    listOrganizationDelegationCategories(organizationId: number): Promise<DelegationCategoryListItem[]> {
        let url_ = this.baseUrl + "/api/delegations/category/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationDelegationCategories(_response);
        });
    }

    protected processListOrganizationDelegationCategories(response: Response): Promise<DelegationCategoryListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationCategoryListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationCategoryListItem[]>(null as any);
    }

    getAvailableDelegationsForUser(userId: number): Promise<DelegationAvailableItem[]> {
        let url_ = this.baseUrl + "/api/delegations/list/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableDelegationsForUser(_response);
        });
    }

    protected processGetAvailableDelegationsForUser(response: Response): Promise<DelegationAvailableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationAvailableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationAvailableItem[]>(null as any);
    }

    getAvailableDelegationPlacementsForUser(userId: number, delegationId: number): Promise<UserDelegationAvailablePlacementsItem> {
        let url_ = this.baseUrl + "/api/delegations/list/user/{userId}/delegation/{delegationId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (delegationId === undefined || delegationId === null)
            throw new Error("The parameter 'delegationId' must be defined.");
        url_ = url_.replace("{delegationId}", encodeURIComponent("" + delegationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableDelegationPlacementsForUser(_response);
        });
    }

    protected processGetAvailableDelegationPlacementsForUser(response: Response): Promise<UserDelegationAvailablePlacementsItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDelegationAvailablePlacementsItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDelegationAvailablePlacementsItem>(null as any);
    }

    createDelegationCategory(model: DelegationCategoryCreateItem): Promise<DelegationCategoryItem> {
        let url_ = this.baseUrl + "/api/delegations/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDelegationCategory(_response);
        });
    }

    protected processCreateDelegationCategory(response: Response): Promise<DelegationCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationCategoryItem>(null as any);
    }

    updateDelegationCategory(model: DelegationCategoryUpdateItem): Promise<DelegationCategoryItem> {
        let url_ = this.baseUrl + "/api/delegations/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDelegationCategory(_response);
        });
    }

    protected processUpdateDelegationCategory(response: Response): Promise<DelegationCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationCategoryItem>(null as any);
    }

    getSingleDelegationCategory(id: number): Promise<DelegationCategoryItem> {
        let url_ = this.baseUrl + "/api/delegations/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleDelegationCategory(_response);
        });
    }

    protected processGetSingleDelegationCategory(response: Response): Promise<DelegationCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DelegationCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationCategoryItem>(null as any);
    }

    deleteDelegationCategory(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/delegations/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDelegationCategory(_response);
        });
    }

    protected processDeleteDelegationCategory(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hasDelegationCategoryConnectedToDelegation(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/delegations/{id}/category/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasDelegationCategoryConnectedToDelegation(_response);
        });
    }

    protected processHasDelegationCategoryConnectedToDelegation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    hasDelegationConnectedToTemplateActivity(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/delegations/{id}/templateActivity/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasDelegationConnectedToTemplateActivity(_response);
        });
    }

    protected processHasDelegationConnectedToTemplateActivity(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRequiredDelegationsForCalendarDay(areaId: number, startTime: Date | undefined, endTime: Date | undefined): Promise<PlannedActivityRequiredDelegationsItem[]> {
        let url_ = this.baseUrl + "/api/delegations/getRequiredDelegationsForCalendarDay/{areaId}?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequiredDelegationsForCalendarDay(_response);
        });
    }

    protected processGetRequiredDelegationsForCalendarDay(response: Response): Promise<PlannedActivityRequiredDelegationsItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedActivityRequiredDelegationsItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityRequiredDelegationsItem[]>(null as any);
    }
}

export class DrugListClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createUnit(model: UnitCreateItem): Promise<UnitItem> {
        let url_ = this.baseUrl + "/api/druglists/unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUnit(_response);
        });
    }

    protected processCreateUnit(response: Response): Promise<UnitItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitItem>(null as any);
    }

    updateUnit(model: UnitUpdateItem): Promise<UnitItem> {
        let url_ = this.baseUrl + "/api/druglists/unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUnit(_response);
        });
    }

    protected processUpdateUnit(response: Response): Promise<UnitItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitItem>(null as any);
    }

    getUnit(id: number): Promise<UnitItem> {
        let url_ = this.baseUrl + "/api/druglists/unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnit(_response);
        });
    }

    protected processGetUnit(response: Response): Promise<UnitItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitItem>(null as any);
    }

    deleteUnit(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/druglists/unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnit(_response);
        });
    }

    protected processDeleteUnit(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listOrganizationUnits(organizationId: number): Promise<UnitListItem[]> {
        let url_ = this.baseUrl + "/api/druglists/unit/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationUnits(_response);
        });
    }

    protected processListOrganizationUnits(response: Response): Promise<UnitListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitListItem[]>(null as any);
    }

    hasTemplateActivityConnectedToUnit(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/druglists/unit/{id}/templateactivity/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasTemplateActivityConnectedToUnit(_response);
        });
    }

    protected processHasTemplateActivityConnectedToUnit(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createOrganizationPlannedActivityStatus(model: OrganizationPlannedActivityStatusCreateItem): Promise<OrganizationPlannedActivityStatusItem> {
        let url_ = this.baseUrl + "/api/druglists/organizationPlannedActivityStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrganizationPlannedActivityStatus(_response);
        });
    }

    protected processCreateOrganizationPlannedActivityStatus(response: Response): Promise<OrganizationPlannedActivityStatusItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationPlannedActivityStatusItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationPlannedActivityStatusItem>(null as any);
    }

    updateOrganizationPlannedActivityStatus(model: OrganizationPlannedActivityStatusUpdateItem): Promise<OrganizationPlannedActivityStatusItem> {
        let url_ = this.baseUrl + "/api/druglists/organizationPlannedActivityStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrganizationPlannedActivityStatus(_response);
        });
    }

    protected processUpdateOrganizationPlannedActivityStatus(response: Response): Promise<OrganizationPlannedActivityStatusItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationPlannedActivityStatusItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationPlannedActivityStatusItem>(null as any);
    }

    getOrganizationPlannedActivityStatus(id: number): Promise<OrganizationPlannedActivityStatusItem> {
        let url_ = this.baseUrl + "/api/druglists/organizationPlannedActivityStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrganizationPlannedActivityStatus(_response);
        });
    }

    protected processGetOrganizationPlannedActivityStatus(response: Response): Promise<OrganizationPlannedActivityStatusItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationPlannedActivityStatusItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationPlannedActivityStatusItem>(null as any);
    }

    deleteOrganizationPlannedActivityStatus(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/druglists/organizationPlannedActivityStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOrganizationPlannedActivityStatus(_response);
        });
    }

    protected processDeleteOrganizationPlannedActivityStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listOrganizationSigningStatuses(organizationId: number): Promise<OrganizationSigningStatusesItem> {
        let url_ = this.baseUrl + "/api/druglists/organizationPlannedActivityStatus/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationSigningStatuses(_response);
        });
    }

    protected processListOrganizationSigningStatuses(response: Response): Promise<OrganizationSigningStatusesItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationSigningStatusesItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationSigningStatusesItem>(null as any);
    }
}

export class KioskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    requestKioskActivation(model: KioskRequestItem): Promise<string> {
        let url_ = this.baseUrl + "/api/kiosks/requestKioskActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestKioskActivation(_response);
        });
    }

    protected processRequestKioskActivation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getKiosks(): Promise<KioskListItem[]> {
        let url_ = this.baseUrl + "/api/kiosks/getKiosks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKiosks(_response);
        });
    }

    protected processGetKiosks(response: Response): Promise<KioskListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KioskListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskListItem[]>(null as any);
    }

    getKiosksUsers(deviceGuid: string, clientNowTicks: number | undefined): Promise<UserListItem[]> {
        let url_ = this.baseUrl + "/api/kiosks/getKiosksUsers/{deviceGuid}?";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        if (clientNowTicks === null)
            throw new Error("The parameter 'clientNowTicks' cannot be null.");
        else if (clientNowTicks !== undefined)
            url_ += "clientNowTicks=" + encodeURIComponent("" + clientNowTicks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKiosksUsers(_response);
        });
    }

    protected processGetKiosksUsers(response: Response): Promise<UserListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserListItem[]>(null as any);
    }

    getRecentLoginsOnKiosk(deviceGuid: string): Promise<number[]> {
        let url_ = this.baseUrl + "/api/kiosks/getRecentLogins/{deviceGuid}";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentLoginsOnKiosk(_response);
        });
    }

    protected processGetRecentLoginsOnKiosk(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getKiosk(kioskId: number): Promise<KioskItem> {
        let url_ = this.baseUrl + "/api/kiosks/getKiosk/{kioskId}";
        if (kioskId === undefined || kioskId === null)
            throw new Error("The parameter 'kioskId' must be defined.");
        url_ = url_.replace("{kioskId}", encodeURIComponent("" + kioskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKiosk(_response);
        });
    }

    protected processGetKiosk(response: Response): Promise<KioskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KioskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskItem>(null as any);
    }

    getManageKiosk(kioskId: number): Promise<ManageKioskItem> {
        let url_ = this.baseUrl + "/api/kiosks/getManageKiosk/{kioskId}";
        if (kioskId === undefined || kioskId === null)
            throw new Error("The parameter 'kioskId' must be defined.");
        url_ = url_.replace("{kioskId}", encodeURIComponent("" + kioskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetManageKiosk(_response);
        });
    }

    protected processGetManageKiosk(response: Response): Promise<ManageKioskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageKioskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManageKioskItem>(null as any);
    }

    getKioskByGuid(deviceGuid: string): Promise<KioskItem> {
        let url_ = this.baseUrl + "/api/kiosks/getKioskByGuid/{deviceGuid}";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKioskByGuid(_response);
        });
    }

    protected processGetKioskByGuid(response: Response): Promise<KioskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KioskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskItem>(null as any);
    }

    getKioskTokenByGuid(deviceGuid: string): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/api/kiosks/getKioskTokenByGuid/{deviceGuid}";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKioskTokenByGuid(_response);
        });
    }

    protected processGetKioskTokenByGuid(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }

    manageKiosk(model: ManageKioskItem): Promise<KioskItem> {
        let url_ = this.baseUrl + "/api/kiosks/manageKiosk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManageKiosk(_response);
        });
    }

    protected processManageKiosk(response: Response): Promise<KioskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KioskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskItem>(null as any);
    }

    deactivateKiosk(model: DeactivateKioskItem): Promise<KioskItem> {
        let url_ = this.baseUrl + "/api/kiosks/deactivateKiosk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateKiosk(_response);
        });
    }

    protected processDeactivateKiosk(response: Response): Promise<KioskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KioskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskItem>(null as any);
    }

    createOrUpdateKioskRouteContainers(model: KioskRouteContainerCreateUpdateItem): Promise<KioskRouteContainerItem> {
        let url_ = this.baseUrl + "/api/kiosks/createOrUpdateKioskRouteContainers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateKioskRouteContainers(_response);
        });
    }

    protected processCreateOrUpdateKioskRouteContainers(response: Response): Promise<KioskRouteContainerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KioskRouteContainerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KioskRouteContainerItem>(null as any);
    }

    getDailyActivitiesForKioskModeForInterval(kioskGuid: string, start: Date | undefined, end: Date | undefined): Promise<RouteKioskDailyActivitiesContainerItem> {
        let url_ = this.baseUrl + "/api/kiosks/{kioskGuid}/dailyActivities?";
        if (kioskGuid === undefined || kioskGuid === null)
            throw new Error("The parameter 'kioskGuid' must be defined.");
        url_ = url_.replace("{kioskGuid}", encodeURIComponent("" + kioskGuid));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDailyActivitiesForKioskModeForInterval(_response);
        });
    }

    protected processGetDailyActivitiesForKioskModeForInterval(response: Response): Promise<RouteKioskDailyActivitiesContainerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteKioskDailyActivitiesContainerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteKioskDailyActivitiesContainerItem>(null as any);
    }

    getDailyActivitiesForKioskAndArea(kioskGuid: string, areaId: number, start: Date | undefined, end: Date | undefined): Promise<RouteKioskDailyActivitiesContainerItem> {
        let url_ = this.baseUrl + "/api/kiosks/{kioskGuid}/dailyActivities/{areaId}?";
        if (kioskGuid === undefined || kioskGuid === null)
            throw new Error("The parameter 'kioskGuid' must be defined.");
        url_ = url_.replace("{kioskGuid}", encodeURIComponent("" + kioskGuid));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDailyActivitiesForKioskAndArea(_response);
        });
    }

    protected processGetDailyActivitiesForKioskAndArea(response: Response): Promise<RouteKioskDailyActivitiesContainerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteKioskDailyActivitiesContainerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteKioskDailyActivitiesContainerItem>(null as any);
    }

    getPlanningViewForKioskForCalendarDay(kioskId: number, startTime: Date | undefined, endTime: Date | undefined): Promise<RoutePlanningViewItem> {
        let url_ = this.baseUrl + "/api/kiosks/getPlanningViewForKioskForCalendarDay/{kioskId}?";
        if (kioskId === undefined || kioskId === null)
            throw new Error("The parameter 'kioskId' must be defined.");
        url_ = url_.replace("{kioskId}", encodeURIComponent("" + kioskId));
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlanningViewForKioskForCalendarDay(_response);
        });
    }

    protected processGetPlanningViewForKioskForCalendarDay(response: Response): Promise<RoutePlanningViewItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutePlanningViewItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoutePlanningViewItem>(null as any);
    }

    hasMultipleAreasConnected(deviceGuid: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/kiosks/{deviceGuid}/multipleAreas";
        if (deviceGuid === undefined || deviceGuid === null)
            throw new Error("The parameter 'deviceGuid' must be defined.");
        url_ = url_.replace("{deviceGuid}", encodeURIComponent("" + deviceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasMultipleAreasConnected(_response);
        });
    }

    protected processHasMultipleAreasConnected(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LegislationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listOrganizationLegislations(organizationId: number): Promise<LegislationListItem[]> {
        let url_ = this.baseUrl + "/api/legislations/list/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationLegislations(_response);
        });
    }

    protected processListOrganizationLegislations(response: Response): Promise<LegislationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegislationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegislationListItem[]>(null as any);
    }

    getLegislation(id: number): Promise<LegislationItem> {
        let url_ = this.baseUrl + "/api/legislations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLegislation(_response);
        });
    }

    protected processGetLegislation(response: Response): Promise<LegislationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegislationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegislationItem>(null as any);
    }

    deleteLegislation(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/legislations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLegislation(_response);
        });
    }

    protected processDeleteLegislation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createLegislation(model: LegislationCreateItem): Promise<LegislationItem> {
        let url_ = this.baseUrl + "/api/legislations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLegislation(_response);
        });
    }

    protected processCreateLegislation(response: Response): Promise<LegislationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegislationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegislationItem>(null as any);
    }

    updateLegislation(model: LegislationUpdateItem): Promise<LegislationItem> {
        let url_ = this.baseUrl + "/api/legislations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLegislation(_response);
        });
    }

    protected processUpdateLegislation(response: Response): Promise<LegislationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegislationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegislationItem>(null as any);
    }

    hasTemplateActivityCategoryConnectedToLegislation(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/legislations/{id}/category/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasTemplateActivityCategoryConnectedToLegislation(_response);
        });
    }

    protected processHasTemplateActivityCategoryConnectedToLegislation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<UserItem> {
        let url_ = this.baseUrl + "/api/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }
}

export class OpenSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getActiveLoginMethods(): Promise<LoginMethodsItem[]> {
        let url_ = this.baseUrl + "/api/opensettings/activeLoginMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveLoginMethods(_response);
        });
    }

    protected processGetActiveLoginMethods(response: Response): Promise<LoginMethodsItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoginMethodsItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginMethodsItem[]>(null as any);
    }
}

export class OrganizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createArea(model: AreaCreateItem): Promise<CreatedNewAreaItem> {
        let url_ = this.baseUrl + "/api/organizations/createArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateArea(_response);
        });
    }

    protected processCreateArea(response: Response): Promise<CreatedNewAreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatedNewAreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedNewAreaItem>(null as any);
    }

    getOrganizationTreeArea(areaId: number): Promise<AreaOrgTreeItem> {
        let url_ = this.baseUrl + "/api/organizations/getOrganizationTreeArea/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrganizationTreeArea(_response);
        });
    }

    protected processGetOrganizationTreeArea(response: Response): Promise<AreaOrgTreeItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOrgTreeItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaOrgTreeItem>(null as any);
    }

    listChildAreasOrRoutesOfArea(areaId: number): Promise<ChildAreaOrRoutesForParentAreaItem> {
        let url_ = this.baseUrl + "/api/organizations/listChildAreasOrRoutesOfArea/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListChildAreasOrRoutesOfArea(_response);
        });
    }

    protected processListChildAreasOrRoutesOfArea(response: Response): Promise<ChildAreaOrRoutesForParentAreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildAreaOrRoutesForParentAreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildAreaOrRoutesForParentAreaItem>(null as any);
    }

    listAllAreas(organizationId: number): Promise<AreaListItem[]> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/areas";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAllAreas(_response);
        });
    }

    protected processListAllAreas(response: Response): Promise<AreaListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaListItem[]>(null as any);
    }

    getOrganization(orgId: number): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/api/organizations/GetOrganization/{orgId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrganization(_response);
        });
    }

    protected processGetOrganization(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    getOrganizations(): Promise<OrganizationListItem[]> {
        let url_ = this.baseUrl + "/api/organizations/getOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: Response): Promise<OrganizationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationListItem[]>(null as any);
    }

    createOrganization(model: OrganizationCreateItem): Promise<OrganizationListItem[]> {
        let url_ = this.baseUrl + "/api/organizations/createOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrganization(_response);
        });
    }

    protected processCreateOrganization(response: Response): Promise<OrganizationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationListItem[]>(null as any);
    }

    updateOrganizationinternalInformation(model: OrganizationUpdateinternalInformationItem): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/api/organizations/UpdateOrganizationinternalInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrganizationinternalInformation(_response);
        });
    }

    protected processUpdateOrganizationinternalInformation(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    generateOrganizationCustomerReport(organizationId: number, periodStartDate: Date, periodEndDate: Date | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations/generateOrganizationCustomerReport/{organizationId}/{periodStartDate}/{periodEndDate}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (periodStartDate === undefined || periodStartDate === null)
            throw new Error("The parameter 'periodStartDate' must be defined.");
        url_ = url_.replace("{periodStartDate}", encodeURIComponent(periodStartDate ? "" + periodStartDate.toISOString() : "null"));
        if (periodEndDate === undefined || periodEndDate === null)
            throw new Error("The parameter 'periodEndDate' must be defined.");
        url_ = url_.replace("{periodEndDate}", encodeURIComponent(periodEndDate ? "" + periodEndDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateOrganizationCustomerReport(_response);
        });
    }

    protected processGenerateOrganizationCustomerReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateCsvReport(organizationId: number, periodStartDate: Date, periodEndDate: Date | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations/generateCustomerReport/{organizationId}/{periodStartDate}/{periodEndDate}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (periodStartDate === undefined || periodStartDate === null)
            throw new Error("The parameter 'periodStartDate' must be defined.");
        url_ = url_.replace("{periodStartDate}", encodeURIComponent(periodStartDate ? "" + periodStartDate.toISOString() : "null"));
        if (periodEndDate === undefined || periodEndDate === null)
            throw new Error("The parameter 'periodEndDate' must be defined.");
        url_ = url_.replace("{periodEndDate}", encodeURIComponent(periodEndDate ? "" + periodEndDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateCsvReport(_response);
        });
    }

    protected processGenerateCsvReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PwaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDailyActivitiesForArea(areaId: number, start: Date | undefined, end: Date | undefined): Promise<RoutePwaDailyActivitiesContainerItem> {
        let url_ = this.baseUrl + "/api/pwa/dailyActivities/{areaId}?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDailyActivitiesForArea(_response);
        });
    }

    protected processGetDailyActivitiesForArea(response: Response): Promise<RoutePwaDailyActivitiesContainerItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutePwaDailyActivitiesContainerItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoutePwaDailyActivitiesContainerItem>(null as any);
    }
}

export class RoutesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createRoute(model: RouteCreateItem): Promise<RouteItem> {
        let url_ = this.baseUrl + "/api/routes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRoute(_response);
        });
    }

    protected processCreateRoute(response: Response): Promise<RouteItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteItem>(null as any);
    }

    getRoute(routeId: number): Promise<RouteItem> {
        let url_ = this.baseUrl + "/api/routes/{routeId}";
        if (routeId === undefined || routeId === null)
            throw new Error("The parameter 'routeId' must be defined.");
        url_ = url_.replace("{routeId}", encodeURIComponent("" + routeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoute(_response);
        });
    }

    protected processGetRoute(response: Response): Promise<RouteItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteItem>(null as any);
    }

    editRoute(model: RouteUpdateItem): Promise<RouteItem> {
        let url_ = this.baseUrl + "/api/routes/editRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditRoute(_response);
        });
    }

    protected processEditRoute(response: Response): Promise<RouteItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteItem>(null as any);
    }

    editTimeBasedRouteContainer(routeId: number, newName: string, newColor: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/routes/editTimeBasedRouteContainer/{routeId}/{newName}/{newColor}";
        if (routeId === undefined || routeId === null)
            throw new Error("The parameter 'routeId' must be defined.");
        url_ = url_.replace("{routeId}", encodeURIComponent("" + routeId));
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined.");
        url_ = url_.replace("{newName}", encodeURIComponent("" + newName));
        if (newColor === undefined || newColor === null)
            throw new Error("The parameter 'newColor' must be defined.");
        url_ = url_.replace("{newColor}", encodeURIComponent("" + newColor));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditTimeBasedRouteContainer(_response);
        });
    }

    protected processEditTimeBasedRouteContainer(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPlannedRoute(plannedRouteId: number): Promise<PlannedRouteItem> {
        let url_ = this.baseUrl + "/api/routes/getPlannedRoute/{plannedRouteId}";
        if (plannedRouteId === undefined || plannedRouteId === null)
            throw new Error("The parameter 'plannedRouteId' must be defined.");
        url_ = url_.replace("{plannedRouteId}", encodeURIComponent("" + plannedRouteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlannedRoute(_response);
        });
    }

    protected processGetPlannedRoute(response: Response): Promise<PlannedRouteItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedRouteItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedRouteItem>(null as any);
    }

    removeRoute(routeId: number, endDate: Date): Promise<RouteItem> {
        let url_ = this.baseUrl + "/api/routes/removeRoute/{routeId}/{endDate}";
        if (routeId === undefined || routeId === null)
            throw new Error("The parameter 'routeId' must be defined.");
        url_ = url_.replace("{routeId}", encodeURIComponent("" + routeId));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveRoute(_response);
        });
    }

    protected processRemoveRoute(response: Response): Promise<RouteItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteItem>(null as any);
    }

    removeTimeBasedRouteContainer(routeId: number, endDate: Date): Promise<boolean> {
        let url_ = this.baseUrl + "/api/routes/removeTimeBasedRouteContainer/{routeId}/{endDate}";
        if (routeId === undefined || routeId === null)
            throw new Error("The parameter 'routeId' must be defined.");
        url_ = url_.replace("{routeId}", encodeURIComponent("" + routeId));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveTimeBasedRouteContainer(_response);
        });
    }

    protected processRemoveTimeBasedRouteContainer(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPlanningViewForCalendarDay(areaId: number, startTime: Date | undefined, endTime: Date | undefined): Promise<RoutePlanningViewItem> {
        let url_ = this.baseUrl + "/api/routes/getPlanningViewForCalendarDay/{areaId}?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlanningViewForCalendarDay(_response);
        });
    }

    protected processGetPlanningViewForCalendarDay(response: Response): Promise<RoutePlanningViewItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutePlanningViewItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoutePlanningViewItem>(null as any);
    }
}

export class TemplateActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listOrganizationTemplateActivities(organizationId: number): Promise<TemplateActivityListItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationTemplateActivities(_response);
        });
    }

    protected processListOrganizationTemplateActivities(response: Response): Promise<TemplateActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityListItem[]>(null as any);
    }

    listAreaTemplateActivities(organizationId: number): Promise<TemplateActivityListItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/list/area/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAreaTemplateActivities(_response);
        });
    }

    protected processListAreaTemplateActivities(response: Response): Promise<TemplateActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityListItem[]>(null as any);
    }

    listActiveTemplateActivitiesOnArea(areaId: number, templateActivityTypeId: TemplateActivityTypeEnum): Promise<TemplateActivityListItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/list/inherited/area/{areaId}/type/{templateActivityTypeId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (templateActivityTypeId === undefined || templateActivityTypeId === null)
            throw new Error("The parameter 'templateActivityTypeId' must be defined.");
        url_ = url_.replace("{templateActivityTypeId}", encodeURIComponent("" + templateActivityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListActiveTemplateActivitiesOnArea(_response);
        });
    }

    protected processListActiveTemplateActivitiesOnArea(response: Response): Promise<TemplateActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityListItem[]>(null as any);
    }

    getTemplateActivity(id: number): Promise<TemplateActivityItem> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateActivity(_response);
        });
    }

    protected processGetTemplateActivity(response: Response): Promise<TemplateActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityItem>(null as any);
    }

    deleteTemplateActivity(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateActivity(_response);
        });
    }

    protected processDeleteTemplateActivity(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hasTemplateActivityConnectedToActivity(id: number, areaId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}/activity/area/{areaId}/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasTemplateActivityConnectedToActivity(_response);
        });
    }

    protected processHasTemplateActivityConnectedToActivity(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    hasInheritanceOnTemplateActivity(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}/inheritance/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasInheritanceOnTemplateActivity(_response);
        });
    }

    protected processHasInheritanceOnTemplateActivity(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createTemplateActivity(model: TemplateActivityCreateItem): Promise<TemplateActivityItem> {
        let url_ = this.baseUrl + "/api/templateActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateActivity(_response);
        });
    }

    protected processCreateTemplateActivity(response: Response): Promise<TemplateActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityItem>(null as any);
    }

    updateTemplateActivity(model: TemplateActivityUpdateItem): Promise<TemplateActivityItem> {
        let url_ = this.baseUrl + "/api/templateActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateActivity(_response);
        });
    }

    protected processUpdateTemplateActivity(response: Response): Promise<TemplateActivityItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityItem>(null as any);
    }

    connectTemplateActivitiesToAreas(model: TemplateActivitiesToAreasItem): Promise<boolean> {
        let url_ = this.baseUrl + "/api/templateActivities/connectTemplateActivitiesToAreas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectTemplateActivitiesToAreas(_response);
        });
    }

    protected processConnectTemplateActivitiesToAreas(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    moveAreaTemplateActivityToOrganization(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}/moveToOrganization";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAreaTemplateActivityToOrganization(_response);
        });
    }

    protected processMoveAreaTemplateActivityToOrganization(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplateActivityInheritance(id: number): Promise<TemplateActivityInheritanceItem> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateActivityInheritance(_response);
        });
    }

    protected processGetTemplateActivityInheritance(response: Response): Promise<TemplateActivityInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityInheritanceItem>(null as any);
    }

    deleteTemplateActivityInheritance(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateActivityInheritance(_response);
        });
    }

    protected processDeleteTemplateActivityInheritance(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplateActivityInheritanceOnArea(templateActivityId: number, areaId: number): Promise<TemplateActivityInheritanceItem> {
        let url_ = this.baseUrl + "/api/templateActivities/{templateActivityId}/inheritance/area/{areaId}";
        if (templateActivityId === undefined || templateActivityId === null)
            throw new Error("The parameter 'templateActivityId' must be defined.");
        url_ = url_.replace("{templateActivityId}", encodeURIComponent("" + templateActivityId));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateActivityInheritanceOnArea(_response);
        });
    }

    protected processGetTemplateActivityInheritanceOnArea(response: Response): Promise<TemplateActivityInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityInheritanceItem>(null as any);
    }

    createTemplateActivityInheritance(model: TemplateActivityInheritanceCreateItem): Promise<TemplateActivityInheritanceItem> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateActivityInheritance(_response);
        });
    }

    protected processCreateTemplateActivityInheritance(response: Response): Promise<TemplateActivityInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityInheritanceItem>(null as any);
    }

    updateTemplateActivityInheritance(model: TemplateActivityInheritanceUpdateItem): Promise<TemplateActivityInheritanceItem> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateActivityInheritance(_response);
        });
    }

    protected processUpdateTemplateActivityInheritance(response: Response): Promise<TemplateActivityInheritanceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityInheritanceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityInheritanceItem>(null as any);
    }

    hasTemplateConnectedToArea(id: number, areaId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}/inheritance/area/{areaId}/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasTemplateConnectedToArea(_response);
        });
    }

    protected processHasTemplateConnectedToArea(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    listInheritedTemplateActivities(organizationId: number): Promise<TemplateActivityInheritanceItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListInheritedTemplateActivities(_response);
        });
    }

    protected processListInheritedTemplateActivities(response: Response): Promise<TemplateActivityInheritanceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityInheritanceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityInheritanceItem[]>(null as any);
    }

    listNonInheritedTemplateActivitiesOnArea(areaId: number): Promise<TemplateActivityListItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/inheritance/list/area/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNonInheritedTemplateActivitiesOnArea(_response);
        });
    }

    protected processListNonInheritedTemplateActivitiesOnArea(response: Response): Promise<TemplateActivityListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityListItem[]>(null as any);
    }

    listOrganizationTemplateActivityCategories(organizationId: number): Promise<TemplateActivityCategoryListItem[]> {
        let url_ = this.baseUrl + "/api/templateActivities/category/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrganizationTemplateActivityCategories(_response);
        });
    }

    protected processListOrganizationTemplateActivityCategories(response: Response): Promise<TemplateActivityCategoryListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateActivityCategoryListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityCategoryListItem[]>(null as any);
    }

    createTemplateActivityCategory(model: TemplateActivityCategoryCreateItem): Promise<TemplateActivityCategoryItem> {
        let url_ = this.baseUrl + "/api/templateActivities/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateActivityCategory(_response);
        });
    }

    protected processCreateTemplateActivityCategory(response: Response): Promise<TemplateActivityCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityCategoryItem>(null as any);
    }

    updateTemplateActivityCategory(model: TemplateActivityCategoryUpdateItem): Promise<TemplateActivityCategoryItem> {
        let url_ = this.baseUrl + "/api/templateActivities/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateActivityCategory(_response);
        });
    }

    protected processUpdateTemplateActivityCategory(response: Response): Promise<TemplateActivityCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityCategoryItem>(null as any);
    }

    deleteTemplateActivityCategory(id: number): Promise<TemplateActivityCategoryItem> {
        let url_ = this.baseUrl + "/api/templateActivities/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateActivityCategory(_response);
        });
    }

    protected processDeleteTemplateActivityCategory(response: Response): Promise<TemplateActivityCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityCategoryItem>(null as any);
    }

    getTemplateActivityCategory(id: number): Promise<TemplateActivityCategoryItem> {
        let url_ = this.baseUrl + "/api/templateActivities/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateActivityCategory(_response);
        });
    }

    protected processGetTemplateActivityCategory(response: Response): Promise<TemplateActivityCategoryItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateActivityCategoryItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateActivityCategoryItem>(null as any);
    }

    hasTemplateActivityCategoryConnectedToTemplateActivity(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/templateActivities/{id}/category/exists";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasTemplateActivityCategoryConnectedToTemplateActivity(_response);
        });
    }

    protected processHasTemplateActivityCategoryConnectedToTemplateActivity(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    changePasswordUsingCurrentPassword(userId: number, model: ChangePasswordUsingCurrentPasswordItem): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/changePasswordUsingCurrentPassword";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordUsingCurrentPassword(_response);
        });
    }

    protected processChangePasswordUsingCurrentPassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changePasswordUsingToken(userId: number, model: ChangePasswordUsingTokenItem): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/changePasswordUsingToken";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordUsingToken(_response);
        });
    }

    protected processChangePasswordUsingToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changePinCodeUsingToken(userId: number, model: ChangePinCodeUsingTokenItem): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/changePinCodeUsingToken";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePinCodeUsingToken(_response);
        });
    }

    protected processChangePinCodeUsingToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(model: UserCreateItem): Promise<UserItem> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }

    list(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfUserListItem> {
        let url_ = this.baseUrl + "/api/users?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PageResultOfUserListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfUserListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfUserListItem>(null as any);
    }

    requestChangePasswordToken(userId: number, sendToAdmin: boolean): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/requestChangePasswordToken/{userId}/{sendToAdmin}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (sendToAdmin === undefined || sendToAdmin === null)
            throw new Error("The parameter 'sendToAdmin' must be defined.");
        url_ = url_.replace("{sendToAdmin}", encodeURIComponent("" + sendToAdmin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestChangePasswordToken(_response);
        });
    }

    protected processRequestChangePasswordToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listPersonnelOnOtherAreas(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfUserListItem> {
        let url_ = this.baseUrl + "/api/users/list/personnel/organization?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListPersonnelOnOtherAreas(_response);
        });
    }

    protected processListPersonnelOnOtherAreas(response: Response): Promise<PageResultOfUserListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfUserListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfUserListItem>(null as any);
    }

    listActiveUsersByAreaId(areaId: number): Promise<UserListItem[]> {
        let url_ = this.baseUrl + "/api/users/area/{areaId}";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListActiveUsersByAreaId(_response);
        });
    }

    protected processListActiveUsersByAreaId(response: Response): Promise<UserListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserListItem[]>(null as any);
    }

    updateUser(model: UserUpdateItem): Promise<UserItem> {
        let url_ = this.baseUrl + "/api/users/updateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }

    getUser(userId: number): Promise<UserItem> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }

    remove(userId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    activate(userId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/activate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deactivate(userId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/deactivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isEmailUnique(email: string, userId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/IsEmailUnique/{email}/{userId}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsEmailUnique(_response);
        });
    }

    protected processIsEmailUnique(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isValidToActivate(userId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/{userId}/IsValidToActivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsValidToActivate(_response);
        });
    }

    protected processIsValidToActivate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    fakeChangePasswordError(userId: number): Promise<ChangePasswordError> {
        let url_ = this.baseUrl + "/api/users/{userId}/nope/none/what/so/ever";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFakeChangePasswordError(_response);
        });
    }

    protected processFakeChangePasswordError(response: Response): Promise<ChangePasswordError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordError>(null as any);
    }

    sendMultipleEmails(model: SendEmailToUsersItem[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/sendmultipleemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMultipleEmails(_response);
        });
    }

    protected processSendMultipleEmails(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDbUserAreas(userId: number): Promise<UserAreaItem[]> {
        let url_ = this.baseUrl + "/api/users/{userId}/getuserareas";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDbUserAreas(_response);
        });
    }

    protected processGetDbUserAreas(response: Response): Promise<UserAreaItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAreaItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAreaItem[]>(null as any);
    }

    removeUserAreasOnUserPrincipalHasAccessTo(userId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/removeuserareas/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUserAreasOnUserPrincipalHasAccessTo(_response);
        });
    }

    protected processRemoveUserAreasOnUserPrincipalHasAccessTo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateUserSettings(userId: number, model: UserSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/updateusersettings/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserSettings(_response);
        });
    }

    protected processUpdateUserSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppVersion(): Promise<string> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ActivityItem implements IActivityItem {
    id!: number;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId!: SeverityLevelEnum;
    startDate!: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId!: RecurrenceEnum;
    recurrenceInterval!: number;
    activityRows?: ActivityRowItem[] | undefined;
    activityAreas?: ActivityAreaItem[] | undefined;
    activityParticipants?: ActivityParticipantItem[] | undefined;
    createdById!: number;
    createdOn!: Date;
    modifiedById!: number;
    modifiedOn!: Date;
    isPlanned!: boolean;
    alertFromStartInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;
    expectedAmount?: number | undefined;
    templateActivityUnitId?: number | undefined;
    templateActivityUnitTitle?: string | undefined;
    templateActivityUnitAbbreviation?: string | undefined;

    constructor(data?: IActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateActivityId = _data["templateActivityId"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.title = _data["title"];
            this.severityLevelId = _data["severityLevelId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.recurrenceId = _data["recurrenceId"];
            this.recurrenceInterval = _data["recurrenceInterval"];
            if (Array.isArray(_data["activityRows"])) {
                this.activityRows = [] as any;
                for (let item of _data["activityRows"])
                    this.activityRows!.push(ActivityRowItem.fromJS(item));
            }
            if (Array.isArray(_data["activityAreas"])) {
                this.activityAreas = [] as any;
                for (let item of _data["activityAreas"])
                    this.activityAreas!.push(ActivityAreaItem.fromJS(item));
            }
            if (Array.isArray(_data["activityParticipants"])) {
                this.activityParticipants = [] as any;
                for (let item of _data["activityParticipants"])
                    this.activityParticipants!.push(ActivityParticipantItem.fromJS(item));
            }
            this.createdById = _data["createdById"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isPlanned = _data["isPlanned"];
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityCategoryTitle = _data["templateActivityCategoryTitle"];
            this.templateActivityLegislationId = _data["templateActivityLegislationId"];
            this.templateActivityLegislationTitle = _data["templateActivityLegislationTitle"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            this.expectedAmount = _data["expectedAmount"];
            this.templateActivityUnitId = _data["templateActivityUnitId"];
            this.templateActivityUnitTitle = _data["templateActivityUnitTitle"];
            this.templateActivityUnitAbbreviation = _data["templateActivityUnitAbbreviation"];
        }
    }

    static fromJS(data: any): ActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateActivityId"] = this.templateActivityId;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["title"] = this.title;
        data["severityLevelId"] = this.severityLevelId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["recurrenceId"] = this.recurrenceId;
        data["recurrenceInterval"] = this.recurrenceInterval;
        if (Array.isArray(this.activityRows)) {
            data["activityRows"] = [];
            for (let item of this.activityRows)
                data["activityRows"].push(item.toJSON());
        }
        if (Array.isArray(this.activityAreas)) {
            data["activityAreas"] = [];
            for (let item of this.activityAreas)
                data["activityAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.activityParticipants)) {
            data["activityParticipants"] = [];
            for (let item of this.activityParticipants)
                data["activityParticipants"].push(item.toJSON());
        }
        data["createdById"] = this.createdById;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isPlanned"] = this.isPlanned;
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityCategoryTitle"] = this.templateActivityCategoryTitle;
        data["templateActivityLegislationId"] = this.templateActivityLegislationId;
        data["templateActivityLegislationTitle"] = this.templateActivityLegislationTitle;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        data["expectedAmount"] = this.expectedAmount;
        data["templateActivityUnitId"] = this.templateActivityUnitId;
        data["templateActivityUnitTitle"] = this.templateActivityUnitTitle;
        data["templateActivityUnitAbbreviation"] = this.templateActivityUnitAbbreviation;
        return data;
    }
}

export interface IActivityItem {
    id: number;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId: SeverityLevelEnum;
    startDate: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId: RecurrenceEnum;
    recurrenceInterval: number;
    activityRows?: ActivityRowItem[] | undefined;
    activityAreas?: ActivityAreaItem[] | undefined;
    activityParticipants?: ActivityParticipantItem[] | undefined;
    createdById: number;
    createdOn: Date;
    modifiedById: number;
    modifiedOn: Date;
    isPlanned: boolean;
    alertFromStartInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
    expectedAmount?: number | undefined;
    templateActivityUnitId?: number | undefined;
    templateActivityUnitTitle?: string | undefined;
    templateActivityUnitAbbreviation?: string | undefined;
}

export enum SeverityLevelEnum {
    Critical = "Critical",
    Normal = "Normal",
    Low = "Low",
}

export enum RecurrenceEnum {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    OneTime = "OneTime",
}

export class ActivityRowItem implements IActivityRowItem {
    id!: number;
    activityId!: number;
    description?: string | undefined;
    visitLengthInMinutes!: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour!: number;
    fromTimeMinute!: number;
    toTimeHour!: number;
    toTimeMinute!: number;
    createdById!: number;
    createdOn!: Date;
    modifiedById!: number;
    modifiedOn!: Date;

    constructor(data?: IActivityRowItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.description = _data["description"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.weeklyDayId = _data["weeklyDayId"];
            this.monthlyDayId = _data["monthlyDayId"];
            this.fromTimeHour = _data["fromTimeHour"];
            this.fromTimeMinute = _data["fromTimeMinute"];
            this.toTimeHour = _data["toTimeHour"];
            this.toTimeMinute = _data["toTimeMinute"];
            this.createdById = _data["createdById"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityRowItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRowItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["description"] = this.description;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["weeklyDayId"] = this.weeklyDayId;
        data["monthlyDayId"] = this.monthlyDayId;
        data["fromTimeHour"] = this.fromTimeHour;
        data["fromTimeMinute"] = this.fromTimeMinute;
        data["toTimeHour"] = this.toTimeHour;
        data["toTimeMinute"] = this.toTimeMinute;
        data["createdById"] = this.createdById;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivityRowItem {
    id: number;
    activityId: number;
    description?: string | undefined;
    visitLengthInMinutes: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour: number;
    fromTimeMinute: number;
    toTimeHour: number;
    toTimeMinute: number;
    createdById: number;
    createdOn: Date;
    modifiedById: number;
    modifiedOn: Date;
}

export enum WeeklyDayEnum {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export enum MonthlyDayEnum {
    MonthlyDateInterval = "MonthlyDateInterval",
    MonthlyDayInterval = "MonthlyDayInterval",
}

export class ActivityAreaItem implements IActivityAreaItem {
    id!: number;
    activityId!: number;
    areaId!: number;

    constructor(data?: IActivityAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): ActivityAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IActivityAreaItem {
    id: number;
    activityId: number;
    areaId: number;
}

export class ActivityParticipantItem implements IActivityParticipantItem {
    id!: number;
    activityId!: number;
    customerId!: number;
    customerFullName?: string | undefined;

    constructor(data?: IActivityParticipantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.customerId = _data["customerId"];
            this.customerFullName = _data["customerFullName"];
        }
    }

    static fromJS(data: any): ActivityParticipantItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityParticipantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["customerId"] = this.customerId;
        data["customerFullName"] = this.customerFullName;
        return data;
    }
}

export interface IActivityParticipantItem {
    id: number;
    activityId: number;
    customerId: number;
    customerFullName?: string | undefined;
}

export enum TemplateActivityTypeEnum {
    CustomerTemplate = "CustomerTemplate",
    AreaTemplate = "AreaTemplate",
}

export class ActivityUpdateItem implements IActivityUpdateItem {
    id!: number;
    templateActivityId?: number | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId!: SeverityLevelEnum;
    startDate!: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId!: RecurrenceEnum;
    recurrenceInterval!: number;
    activityRows?: ActivityRowItem[] | undefined;
    activityAreas?: ActivityAreaItem[] | undefined;
    alertFromStartInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityTypeId?: TemplateActivityTypeEnum | undefined;
    expectedAmount?: number | undefined;
    activityParticipants?: ActivityParticipantUpdateItem[] | undefined;

    constructor(data?: IActivityUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateActivityId = _data["templateActivityId"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.title = _data["title"];
            this.severityLevelId = _data["severityLevelId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.recurrenceId = _data["recurrenceId"];
            this.recurrenceInterval = _data["recurrenceInterval"];
            if (Array.isArray(_data["activityRows"])) {
                this.activityRows = [] as any;
                for (let item of _data["activityRows"])
                    this.activityRows!.push(ActivityRowItem.fromJS(item));
            }
            if (Array.isArray(_data["activityAreas"])) {
                this.activityAreas = [] as any;
                for (let item of _data["activityAreas"])
                    this.activityAreas!.push(ActivityAreaItem.fromJS(item));
            }
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            this.expectedAmount = _data["expectedAmount"];
            if (Array.isArray(_data["activityParticipants"])) {
                this.activityParticipants = [] as any;
                for (let item of _data["activityParticipants"])
                    this.activityParticipants!.push(ActivityParticipantUpdateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateActivityId"] = this.templateActivityId;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["title"] = this.title;
        data["severityLevelId"] = this.severityLevelId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["recurrenceId"] = this.recurrenceId;
        data["recurrenceInterval"] = this.recurrenceInterval;
        if (Array.isArray(this.activityRows)) {
            data["activityRows"] = [];
            for (let item of this.activityRows)
                data["activityRows"].push(item.toJSON());
        }
        if (Array.isArray(this.activityAreas)) {
            data["activityAreas"] = [];
            for (let item of this.activityAreas)
                data["activityAreas"].push(item.toJSON());
        }
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        data["expectedAmount"] = this.expectedAmount;
        if (Array.isArray(this.activityParticipants)) {
            data["activityParticipants"] = [];
            for (let item of this.activityParticipants)
                data["activityParticipants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityUpdateItem {
    id: number;
    templateActivityId?: number | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId: SeverityLevelEnum;
    startDate: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId: RecurrenceEnum;
    recurrenceInterval: number;
    activityRows?: ActivityRowItem[] | undefined;
    activityAreas?: ActivityAreaItem[] | undefined;
    alertFromStartInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityTypeId?: TemplateActivityTypeEnum | undefined;
    expectedAmount?: number | undefined;
    activityParticipants?: ActivityParticipantUpdateItem[] | undefined;
}

export class ActivityParticipantUpdateItem implements IActivityParticipantUpdateItem {
    id?: number | undefined;
    customerId!: number;

    constructor(data?: IActivityParticipantUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): ActivityParticipantUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityParticipantUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IActivityParticipantUpdateItem {
    id?: number | undefined;
    customerId: number;
}

export class ActivityCreateItem implements IActivityCreateItem {
    templateActivityId?: number | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId!: SeverityLevelEnum;
    startDate!: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId!: RecurrenceEnum;
    recurrenceInterval!: number;
    activityRows?: ActivityRowCreateItem[] | undefined;
    activityAreas?: ActivityAreaCreateItem[] | undefined;
    alertFromStartInMinutes!: number;
    showColorOnDevice!: boolean;
    expectedAmount?: number | undefined;
    activityParticipants?: ActivityParticipantCreateItem[] | undefined;

    constructor(data?: IActivityCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateActivityId = _data["templateActivityId"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.title = _data["title"];
            this.severityLevelId = _data["severityLevelId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.recurrenceId = _data["recurrenceId"];
            this.recurrenceInterval = _data["recurrenceInterval"];
            if (Array.isArray(_data["activityRows"])) {
                this.activityRows = [] as any;
                for (let item of _data["activityRows"])
                    this.activityRows!.push(ActivityRowCreateItem.fromJS(item));
            }
            if (Array.isArray(_data["activityAreas"])) {
                this.activityAreas = [] as any;
                for (let item of _data["activityAreas"])
                    this.activityAreas!.push(ActivityAreaCreateItem.fromJS(item));
            }
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.expectedAmount = _data["expectedAmount"];
            if (Array.isArray(_data["activityParticipants"])) {
                this.activityParticipants = [] as any;
                for (let item of _data["activityParticipants"])
                    this.activityParticipants!.push(ActivityParticipantCreateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateActivityId"] = this.templateActivityId;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["title"] = this.title;
        data["severityLevelId"] = this.severityLevelId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["recurrenceId"] = this.recurrenceId;
        data["recurrenceInterval"] = this.recurrenceInterval;
        if (Array.isArray(this.activityRows)) {
            data["activityRows"] = [];
            for (let item of this.activityRows)
                data["activityRows"].push(item.toJSON());
        }
        if (Array.isArray(this.activityAreas)) {
            data["activityAreas"] = [];
            for (let item of this.activityAreas)
                data["activityAreas"].push(item.toJSON());
        }
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["expectedAmount"] = this.expectedAmount;
        if (Array.isArray(this.activityParticipants)) {
            data["activityParticipants"] = [];
            for (let item of this.activityParticipants)
                data["activityParticipants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityCreateItem {
    templateActivityId?: number | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId: SeverityLevelEnum;
    startDate: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId: RecurrenceEnum;
    recurrenceInterval: number;
    activityRows?: ActivityRowCreateItem[] | undefined;
    activityAreas?: ActivityAreaCreateItem[] | undefined;
    alertFromStartInMinutes: number;
    showColorOnDevice: boolean;
    expectedAmount?: number | undefined;
    activityParticipants?: ActivityParticipantCreateItem[] | undefined;
}

export class ActivityRowCreateItem implements IActivityRowCreateItem {
    description?: string | undefined;
    visitLengthInMinutes!: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour!: number;
    fromTimeMinute!: number;
    toTimeHour!: number;
    toTimeMinute!: number;

    constructor(data?: IActivityRowCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.weeklyDayId = _data["weeklyDayId"];
            this.monthlyDayId = _data["monthlyDayId"];
            this.fromTimeHour = _data["fromTimeHour"];
            this.fromTimeMinute = _data["fromTimeMinute"];
            this.toTimeHour = _data["toTimeHour"];
            this.toTimeMinute = _data["toTimeMinute"];
        }
    }

    static fromJS(data: any): ActivityRowCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRowCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["weeklyDayId"] = this.weeklyDayId;
        data["monthlyDayId"] = this.monthlyDayId;
        data["fromTimeHour"] = this.fromTimeHour;
        data["fromTimeMinute"] = this.fromTimeMinute;
        data["toTimeHour"] = this.toTimeHour;
        data["toTimeMinute"] = this.toTimeMinute;
        return data;
    }
}

export interface IActivityRowCreateItem {
    description?: string | undefined;
    visitLengthInMinutes: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour: number;
    fromTimeMinute: number;
    toTimeHour: number;
    toTimeMinute: number;
}

export class ActivityAreaCreateItem implements IActivityAreaCreateItem {
    areaId!: number;

    constructor(data?: IActivityAreaCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): ActivityAreaCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAreaCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IActivityAreaCreateItem {
    areaId: number;
}

export class ActivityParticipantCreateItem implements IActivityParticipantCreateItem {
    customerId!: number;

    constructor(data?: IActivityParticipantCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): ActivityParticipantCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityParticipantCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IActivityParticipantCreateItem {
    customerId: number;
}

export class ActivityListItem implements IActivityListItem {
    id!: number;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId!: SeverityLevelEnum;
    startDate!: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId!: RecurrenceEnum;
    recurrenceInterval!: number;
    activityRows?: ActivityRowListItem[] | undefined;
    alertFromStartInMinutes!: number;

    constructor(data?: IActivityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateActivityId = _data["templateActivityId"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.title = _data["title"];
            this.severityLevelId = _data["severityLevelId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.recurrenceId = _data["recurrenceId"];
            this.recurrenceInterval = _data["recurrenceInterval"];
            if (Array.isArray(_data["activityRows"])) {
                this.activityRows = [] as any;
                for (let item of _data["activityRows"])
                    this.activityRows!.push(ActivityRowListItem.fromJS(item));
            }
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
        }
    }

    static fromJS(data: any): ActivityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateActivityId"] = this.templateActivityId;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["title"] = this.title;
        data["severityLevelId"] = this.severityLevelId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["recurrenceId"] = this.recurrenceId;
        data["recurrenceInterval"] = this.recurrenceInterval;
        if (Array.isArray(this.activityRows)) {
            data["activityRows"] = [];
            for (let item of this.activityRows)
                data["activityRows"].push(item.toJSON());
        }
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        return data;
    }
}

export interface IActivityListItem {
    id: number;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    title?: string | undefined;
    severityLevelId: SeverityLevelEnum;
    startDate: Date;
    endDate?: Date | undefined;
    color?: string | undefined;
    recurrenceId: RecurrenceEnum;
    recurrenceInterval: number;
    activityRows?: ActivityRowListItem[] | undefined;
    alertFromStartInMinutes: number;
}

export class ActivityRowListItem implements IActivityRowListItem {
    id!: number;
    activityId!: number;
    description?: string | undefined;
    visitLengthInMinutes!: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour!: number;
    fromTimeMinute!: number;
    toTimeHour!: number;
    toTimeMinute!: number;

    constructor(data?: IActivityRowListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.description = _data["description"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.weeklyDayId = _data["weeklyDayId"];
            this.monthlyDayId = _data["monthlyDayId"];
            this.fromTimeHour = _data["fromTimeHour"];
            this.fromTimeMinute = _data["fromTimeMinute"];
            this.toTimeHour = _data["toTimeHour"];
            this.toTimeMinute = _data["toTimeMinute"];
        }
    }

    static fromJS(data: any): ActivityRowListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRowListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["description"] = this.description;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["weeklyDayId"] = this.weeklyDayId;
        data["monthlyDayId"] = this.monthlyDayId;
        data["fromTimeHour"] = this.fromTimeHour;
        data["fromTimeMinute"] = this.fromTimeMinute;
        data["toTimeHour"] = this.toTimeHour;
        data["toTimeMinute"] = this.toTimeMinute;
        return data;
    }
}

export interface IActivityRowListItem {
    id: number;
    activityId: number;
    description?: string | undefined;
    visitLengthInMinutes: number;
    weeklyDayId?: WeeklyDayEnum | undefined;
    monthlyDayId?: MonthlyDayEnum | undefined;
    fromTimeHour: number;
    fromTimeMinute: number;
    toTimeHour: number;
    toTimeMinute: number;
}

export class PlannedActivityRowPlanningViewItem implements IPlannedActivityRowPlanningViewItem {
    id!: number;
    activityRowId!: number;
    activityReccurrenceId!: number;
    activityRowHasFutureChanges!: boolean;
    comment?: string | undefined;
    startTime!: Date;
    endTime!: Date;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedRouteId!: number;
    activityColor?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerId?: number | undefined;
    activityName?: string | undefined;
    detachedFromSeries!: boolean;
    detachedBy?: string | undefined;
    detachedTime?: Date | undefined;
    routeName?: string | undefined;
    routeColor?: string | undefined;
    activityShowColorOnDevice!: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations!: boolean;
    activity_SeverityLevelId!: SeverityLevelEnum;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    createdOn!: Date;
    useParticipantList!: boolean;

    constructor(data?: IPlannedActivityRowPlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.activityReccurrenceId = _data["activityReccurrenceId"];
            this.activityRowHasFutureChanges = _data["activityRowHasFutureChanges"];
            this.comment = _data["comment"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.activityColor = _data["activityColor"];
            this.ownerCustomerFirstName = _data["ownerCustomerFirstName"];
            this.ownerCustomerLastName = _data["ownerCustomerLastName"];
            this.ownerCustomerRoomNumber = _data["ownerCustomerRoomNumber"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.activityName = _data["activityName"];
            this.detachedFromSeries = _data["detachedFromSeries"];
            this.detachedBy = _data["detachedBy"];
            this.detachedTime = _data["detachedTime"] ? new Date(_data["detachedTime"].toString()) : <any>undefined;
            this.routeName = _data["routeName"];
            this.routeColor = _data["routeColor"];
            this.activityShowColorOnDevice = _data["activityShowColorOnDevice"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.hasUnfulfilledDelegations = _data["hasUnfulfilledDelegations"];
            this.activity_SeverityLevelId = _data["activity_SeverityLevelId"];
            if (Array.isArray(_data["plannedActivityParticipants"])) {
                this.plannedActivityParticipants = [] as any;
                for (let item of _data["plannedActivityParticipants"])
                    this.plannedActivityParticipants!.push(PlannedActivityParticipantItem.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): PlannedActivityRowPlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowPlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["activityReccurrenceId"] = this.activityReccurrenceId;
        data["activityRowHasFutureChanges"] = this.activityRowHasFutureChanges;
        data["comment"] = this.comment;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedRouteId"] = this.plannedRouteId;
        data["activityColor"] = this.activityColor;
        data["ownerCustomerFirstName"] = this.ownerCustomerFirstName;
        data["ownerCustomerLastName"] = this.ownerCustomerLastName;
        data["ownerCustomerRoomNumber"] = this.ownerCustomerRoomNumber;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["activityName"] = this.activityName;
        data["detachedFromSeries"] = this.detachedFromSeries;
        data["detachedBy"] = this.detachedBy;
        data["detachedTime"] = this.detachedTime ? this.detachedTime.toISOString() : <any>undefined;
        data["routeName"] = this.routeName;
        data["routeColor"] = this.routeColor;
        data["activityShowColorOnDevice"] = this.activityShowColorOnDevice;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["hasUnfulfilledDelegations"] = this.hasUnfulfilledDelegations;
        data["activity_SeverityLevelId"] = this.activity_SeverityLevelId;
        if (Array.isArray(this.plannedActivityParticipants)) {
            data["plannedActivityParticipants"] = [];
            for (let item of this.plannedActivityParticipants)
                data["plannedActivityParticipants"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface IPlannedActivityRowPlanningViewItem {
    id: number;
    activityRowId: number;
    activityReccurrenceId: number;
    activityRowHasFutureChanges: boolean;
    comment?: string | undefined;
    startTime: Date;
    endTime: Date;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedRouteId: number;
    activityColor?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerId?: number | undefined;
    activityName?: string | undefined;
    detachedFromSeries: boolean;
    detachedBy?: string | undefined;
    detachedTime?: Date | undefined;
    routeName?: string | undefined;
    routeColor?: string | undefined;
    activityShowColorOnDevice: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations: boolean;
    activity_SeverityLevelId: SeverityLevelEnum;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    createdOn: Date;
    useParticipantList: boolean;
}

export enum PlannedActivityStatusEnum {
    NotCompleted = "NotCompleted",
    Completed = "Completed",
    CompletedWithoutAction = "CompletedWithoutAction",
    Delayed = "Delayed",
    Given = "Given",
    PartiallyGiven = "PartiallyGiven",
    NotGiven = "NotGiven",
    CannotTake = "CannotTake",
    SentAlong = "SentAlong",
    SelfGiven = "SelfGiven",
    RelativeGiven = "RelativeGiven",
    PartiallyComplete = "PartiallyComplete",
    Started = "Started",
}

export class PlannedActivityParticipantItem implements IPlannedActivityParticipantItem {
    id!: number;
    plannedActivityRowId!: number;
    customerId!: number;
    customerFullName?: string | undefined;

    constructor(data?: IPlannedActivityParticipantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.customerId = _data["customerId"];
            this.customerFullName = _data["customerFullName"];
        }
    }

    static fromJS(data: any): PlannedActivityParticipantItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityParticipantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["customerId"] = this.customerId;
        data["customerFullName"] = this.customerFullName;
        return data;
    }
}

export interface IPlannedActivityParticipantItem {
    id: number;
    plannedActivityRowId: number;
    customerId: number;
    customerFullName?: string | undefined;
}

export class FutureRouteActivityRowItem implements IFutureRouteActivityRowItem {
    routeActivityRowId!: number;
    startDate!: Date;
    endDate?: Date | undefined;
    duration!: string;
    offsetFromStartOfDay!: string;
    color?: string | undefined;
    unplannedContainerRoute!: boolean;
    name?: string | undefined;
    startTimeHHMM?: string | undefined;
    endTimeHHMM?: string | undefined;
    durationMinutes!: number;

    constructor(data?: IFutureRouteActivityRowItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeActivityRowId = _data["routeActivityRowId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.offsetFromStartOfDay = _data["offsetFromStartOfDay"];
            this.color = _data["color"];
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
            this.name = _data["name"];
            this.startTimeHHMM = _data["startTimeHHMM"];
            this.endTimeHHMM = _data["endTimeHHMM"];
            this.durationMinutes = _data["durationMinutes"];
        }
    }

    static fromJS(data: any): FutureRouteActivityRowItem {
        data = typeof data === 'object' ? data : {};
        let result = new FutureRouteActivityRowItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeActivityRowId"] = this.routeActivityRowId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["offsetFromStartOfDay"] = this.offsetFromStartOfDay;
        data["color"] = this.color;
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        data["name"] = this.name;
        data["startTimeHHMM"] = this.startTimeHHMM;
        data["endTimeHHMM"] = this.endTimeHHMM;
        data["durationMinutes"] = this.durationMinutes;
        return data;
    }
}

export interface IFutureRouteActivityRowItem {
    routeActivityRowId: number;
    startDate: Date;
    endDate?: Date | undefined;
    duration: string;
    offsetFromStartOfDay: string;
    color?: string | undefined;
    unplannedContainerRoute: boolean;
    name?: string | undefined;
    startTimeHHMM?: string | undefined;
    endTimeHHMM?: string | undefined;
    durationMinutes: number;
}

export class RecentPerformedSigningItem implements IRecentPerformedSigningItem {
    plannedActivityRowSigningId!: number;
    performedByFullName?: string | undefined;
    performedOn!: Date;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    comment?: string | undefined;
    signingComment?: string | undefined;
    activityFullName?: string | undefined;
    recurranceType!: RecurrenceEnum;
    useParticipantList!: boolean;
    declined!: boolean;

    constructor(data?: IRecentPerformedSigningItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityRowSigningId = _data["plannedActivityRowSigningId"];
            this.performedByFullName = _data["performedByFullName"];
            this.performedOn = _data["performedOn"] ? new Date(_data["performedOn"].toString()) : <any>undefined;
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.comment = _data["comment"];
            this.signingComment = _data["signingComment"];
            this.activityFullName = _data["activityFullName"];
            this.recurranceType = _data["recurranceType"];
            this.useParticipantList = _data["useParticipantList"];
            this.declined = _data["declined"];
        }
    }

    static fromJS(data: any): RecentPerformedSigningItem {
        data = typeof data === 'object' ? data : {};
        let result = new RecentPerformedSigningItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityRowSigningId"] = this.plannedActivityRowSigningId;
        data["performedByFullName"] = this.performedByFullName;
        data["performedOn"] = this.performedOn ? this.performedOn.toISOString() : <any>undefined;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["comment"] = this.comment;
        data["signingComment"] = this.signingComment;
        data["activityFullName"] = this.activityFullName;
        data["recurranceType"] = this.recurranceType;
        data["useParticipantList"] = this.useParticipantList;
        data["declined"] = this.declined;
        return data;
    }
}

export interface IRecentPerformedSigningItem {
    plannedActivityRowSigningId: number;
    performedByFullName?: string | undefined;
    performedOn: Date;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    comment?: string | undefined;
    signingComment?: string | undefined;
    activityFullName?: string | undefined;
    recurranceType: RecurrenceEnum;
    useParticipantList: boolean;
    declined: boolean;
}

export class FuturePlannedActivityItem implements IFuturePlannedActivityItem {
    plannedActivityId!: number;
    plannedStartTime!: Date;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    comment?: string | undefined;
    activityFullName?: string | undefined;
    recurranceType!: RecurrenceEnum;
    routeName?: string | undefined;
    routeColor?: string | undefined;
    useParticipantList!: boolean;

    constructor(data?: IFuturePlannedActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityId = _data["plannedActivityId"];
            this.plannedStartTime = _data["plannedStartTime"] ? new Date(_data["plannedStartTime"].toString()) : <any>undefined;
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.comment = _data["comment"];
            this.activityFullName = _data["activityFullName"];
            this.recurranceType = _data["recurranceType"];
            this.routeName = _data["routeName"];
            this.routeColor = _data["routeColor"];
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): FuturePlannedActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new FuturePlannedActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityId"] = this.plannedActivityId;
        data["plannedStartTime"] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["comment"] = this.comment;
        data["activityFullName"] = this.activityFullName;
        data["recurranceType"] = this.recurranceType;
        data["routeName"] = this.routeName;
        data["routeColor"] = this.routeColor;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface IFuturePlannedActivityItem {
    plannedActivityId: number;
    plannedStartTime: Date;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    comment?: string | undefined;
    activityFullName?: string | undefined;
    recurranceType: RecurrenceEnum;
    routeName?: string | undefined;
    routeColor?: string | undefined;
    useParticipantList: boolean;
}

export class RoutePlanningViewItem implements IRoutePlanningViewItem {
    plannedRoutesActivitiesPlanningViewItem?: PlannedRoutesActivitiesPlanningViewItem[] | undefined;
    sidePanelActivitiesPlanningViewItem?: SidePanelActivitiesPlanningViewItem[] | undefined;
    sidePanelUsersWorkSchedulesItems?: SidePanelUsersWorkSchedulesItem[] | undefined;
    unplannedRouteId?: number | undefined;

    constructor(data?: IRoutePlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plannedRoutesActivitiesPlanningViewItem"])) {
                this.plannedRoutesActivitiesPlanningViewItem = [] as any;
                for (let item of _data["plannedRoutesActivitiesPlanningViewItem"])
                    this.plannedRoutesActivitiesPlanningViewItem!.push(PlannedRoutesActivitiesPlanningViewItem.fromJS(item));
            }
            if (Array.isArray(_data["sidePanelActivitiesPlanningViewItem"])) {
                this.sidePanelActivitiesPlanningViewItem = [] as any;
                for (let item of _data["sidePanelActivitiesPlanningViewItem"])
                    this.sidePanelActivitiesPlanningViewItem!.push(SidePanelActivitiesPlanningViewItem.fromJS(item));
            }
            if (Array.isArray(_data["sidePanelUsersWorkSchedulesItems"])) {
                this.sidePanelUsersWorkSchedulesItems = [] as any;
                for (let item of _data["sidePanelUsersWorkSchedulesItems"])
                    this.sidePanelUsersWorkSchedulesItems!.push(SidePanelUsersWorkSchedulesItem.fromJS(item));
            }
            this.unplannedRouteId = _data["unplannedRouteId"];
        }
    }

    static fromJS(data: any): RoutePlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedRoutesActivitiesPlanningViewItem)) {
            data["plannedRoutesActivitiesPlanningViewItem"] = [];
            for (let item of this.plannedRoutesActivitiesPlanningViewItem)
                data["plannedRoutesActivitiesPlanningViewItem"].push(item.toJSON());
        }
        if (Array.isArray(this.sidePanelActivitiesPlanningViewItem)) {
            data["sidePanelActivitiesPlanningViewItem"] = [];
            for (let item of this.sidePanelActivitiesPlanningViewItem)
                data["sidePanelActivitiesPlanningViewItem"].push(item.toJSON());
        }
        if (Array.isArray(this.sidePanelUsersWorkSchedulesItems)) {
            data["sidePanelUsersWorkSchedulesItems"] = [];
            for (let item of this.sidePanelUsersWorkSchedulesItems)
                data["sidePanelUsersWorkSchedulesItems"].push(item.toJSON());
        }
        data["unplannedRouteId"] = this.unplannedRouteId;
        return data;
    }
}

export interface IRoutePlanningViewItem {
    plannedRoutesActivitiesPlanningViewItem?: PlannedRoutesActivitiesPlanningViewItem[] | undefined;
    sidePanelActivitiesPlanningViewItem?: SidePanelActivitiesPlanningViewItem[] | undefined;
    sidePanelUsersWorkSchedulesItems?: SidePanelUsersWorkSchedulesItem[] | undefined;
    unplannedRouteId?: number | undefined;
}

export class PlannedRoutesActivitiesPlanningViewItem implements IPlannedRoutesActivitiesPlanningViewItem {
    id!: number;
    name!: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId!: number;
    plannedRoutes?: PlannedRoutePlanningViewItem[] | undefined;
    unplannedContainerRoute!: boolean;
    startDate!: Date;
    endDate?: Date | undefined;
    hasFuturePlannedActivities!: boolean;
    hidden!: boolean;

    constructor(data?: IPlannedRoutesActivitiesPlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            if (Array.isArray(_data["plannedRoutes"])) {
                this.plannedRoutes = [] as any;
                for (let item of _data["plannedRoutes"])
                    this.plannedRoutes!.push(PlannedRoutePlanningViewItem.fromJS(item));
            }
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hasFuturePlannedActivities = _data["hasFuturePlannedActivities"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any): PlannedRoutesActivitiesPlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRoutesActivitiesPlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        if (Array.isArray(this.plannedRoutes)) {
            data["plannedRoutes"] = [];
            for (let item of this.plannedRoutes)
                data["plannedRoutes"].push(item.toJSON());
        }
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hasFuturePlannedActivities"] = this.hasFuturePlannedActivities;
        data["hidden"] = this.hidden;
        return data;
    }
}

export interface IPlannedRoutesActivitiesPlanningViewItem {
    id: number;
    name: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId: number;
    plannedRoutes?: PlannedRoutePlanningViewItem[] | undefined;
    unplannedContainerRoute: boolean;
    startDate: Date;
    endDate?: Date | undefined;
    hasFuturePlannedActivities: boolean;
    hidden: boolean;
}

export class PlannedRoutePlanningViewItem implements IPlannedRoutePlanningViewItem {
    id!: number;
    routeId!: number;
    plannedActivityRows?: PlannedActivityRowPlanningViewItem[] | undefined;
    plannedRouteUserWorkSchedules?: PlannedRouteUserWorkSchedulePlanningViewItem[] | undefined;
    calendarDay!: Date;

    constructor(data?: IPlannedRoutePlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["plannedActivityRows"])) {
                this.plannedActivityRows = [] as any;
                for (let item of _data["plannedActivityRows"])
                    this.plannedActivityRows!.push(PlannedActivityRowPlanningViewItem.fromJS(item));
            }
            if (Array.isArray(_data["plannedRouteUserWorkSchedules"])) {
                this.plannedRouteUserWorkSchedules = [] as any;
                for (let item of _data["plannedRouteUserWorkSchedules"])
                    this.plannedRouteUserWorkSchedules!.push(PlannedRouteUserWorkSchedulePlanningViewItem.fromJS(item));
            }
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedRoutePlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRoutePlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeId"] = this.routeId;
        if (Array.isArray(this.plannedActivityRows)) {
            data["plannedActivityRows"] = [];
            for (let item of this.plannedActivityRows)
                data["plannedActivityRows"].push(item.toJSON());
        }
        if (Array.isArray(this.plannedRouteUserWorkSchedules)) {
            data["plannedRouteUserWorkSchedules"] = [];
            for (let item of this.plannedRouteUserWorkSchedules)
                data["plannedRouteUserWorkSchedules"].push(item.toJSON());
        }
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedRoutePlanningViewItem {
    id: number;
    routeId: number;
    plannedActivityRows?: PlannedActivityRowPlanningViewItem[] | undefined;
    plannedRouteUserWorkSchedules?: PlannedRouteUserWorkSchedulePlanningViewItem[] | undefined;
    calendarDay: Date;
}

export class PlannedRouteUserWorkSchedulePlanningViewItem implements IPlannedRouteUserWorkSchedulePlanningViewItem {
    id!: number;
    userId!: number;
    userFullName?: string | undefined;
    plannedRouteId!: number;
    routeId!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;

    constructor(data?: IPlannedRouteUserWorkSchedulePlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.routeId = _data["routeId"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.substituteUserId = _data["substituteUserId"];
            this.substituteUserFullName = _data["substituteUserFullName"];
        }
    }

    static fromJS(data: any): PlannedRouteUserWorkSchedulePlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteUserWorkSchedulePlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["plannedRouteId"] = this.plannedRouteId;
        data["routeId"] = this.routeId;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["substituteUserId"] = this.substituteUserId;
        data["substituteUserFullName"] = this.substituteUserFullName;
        return data;
    }
}

export interface IPlannedRouteUserWorkSchedulePlanningViewItem {
    id: number;
    userId: number;
    userFullName?: string | undefined;
    plannedRouteId: number;
    routeId: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;
}

export class SidePanelActivitiesPlanningViewItem implements ISidePanelActivitiesPlanningViewItem {
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    sidePanelPlannedActivityRowsPlanningViewItems?: SidePanelPlannedActivityRowsPlanningViewItem[] | undefined;

    constructor(data?: ISidePanelActivitiesPlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerCustomerFirstName = _data["ownerCustomerFirstName"];
            this.ownerCustomerLastName = _data["ownerCustomerLastName"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerAreaId = _data["ownerAreaId"];
            if (Array.isArray(_data["sidePanelPlannedActivityRowsPlanningViewItems"])) {
                this.sidePanelPlannedActivityRowsPlanningViewItems = [] as any;
                for (let item of _data["sidePanelPlannedActivityRowsPlanningViewItems"])
                    this.sidePanelPlannedActivityRowsPlanningViewItems!.push(SidePanelPlannedActivityRowsPlanningViewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SidePanelActivitiesPlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new SidePanelActivitiesPlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerCustomerFirstName"] = this.ownerCustomerFirstName;
        data["ownerCustomerLastName"] = this.ownerCustomerLastName;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerAreaId"] = this.ownerAreaId;
        if (Array.isArray(this.sidePanelPlannedActivityRowsPlanningViewItems)) {
            data["sidePanelPlannedActivityRowsPlanningViewItems"] = [];
            for (let item of this.sidePanelPlannedActivityRowsPlanningViewItems)
                data["sidePanelPlannedActivityRowsPlanningViewItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISidePanelActivitiesPlanningViewItem {
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    sidePanelPlannedActivityRowsPlanningViewItems?: SidePanelPlannedActivityRowsPlanningViewItem[] | undefined;
}

export class SidePanelPlannedActivityRowsPlanningViewItem implements ISidePanelPlannedActivityRowsPlanningViewItem {
    id!: number;
    activityRowId!: number;
    activityRowHasFutureChanges!: boolean;
    activityReccurrenceId!: number;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    color?: string | undefined;
    activityShowColorOnDevice!: boolean;
    activityId!: number;
    activityTitle?: string | undefined;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    plannedRouteId!: number;
    isPlanned!: boolean;
    detachedFromSeries!: boolean;
    fromTimeHour!: number;
    fromTimeMinute!: number;
    toTimeHour!: number;
    toTimeMinute!: number;
    visitLengthInMinutes!: number;
    fromFullTimeString?: string | undefined;
    toFullTimeString?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    calendarDay!: Date;
    comment?: string | undefined;
    activitySeverityLevelId!: SeverityLevelEnum;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    useParticipantList!: boolean;
    createdOn!: Date;

    constructor(data?: ISidePanelPlannedActivityRowsPlanningViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.activityRowHasFutureChanges = _data["activityRowHasFutureChanges"];
            this.activityReccurrenceId = _data["activityReccurrenceId"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.color = _data["color"];
            this.activityShowColorOnDevice = _data["activityShowColorOnDevice"];
            this.activityId = _data["activityId"];
            this.activityTitle = _data["activityTitle"];
            this.templateActivityId = _data["templateActivityId"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.isPlanned = _data["isPlanned"];
            this.detachedFromSeries = _data["detachedFromSeries"];
            this.fromTimeHour = _data["fromTimeHour"];
            this.fromTimeMinute = _data["fromTimeMinute"];
            this.toTimeHour = _data["toTimeHour"];
            this.toTimeMinute = _data["toTimeMinute"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.fromFullTimeString = _data["fromFullTimeString"];
            this.toFullTimeString = _data["toFullTimeString"];
            this.ownerCustomerFirstName = _data["ownerCustomerFirstName"];
            this.ownerCustomerLastName = _data["ownerCustomerLastName"];
            this.ownerCustomerRoomNumber = _data["ownerCustomerRoomNumber"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.activitySeverityLevelId = _data["activitySeverityLevelId"];
            if (Array.isArray(_data["plannedActivityParticipants"])) {
                this.plannedActivityParticipants = [] as any;
                for (let item of _data["plannedActivityParticipants"])
                    this.plannedActivityParticipants!.push(PlannedActivityParticipantItem.fromJS(item));
            }
            this.useParticipantList = _data["useParticipantList"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SidePanelPlannedActivityRowsPlanningViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new SidePanelPlannedActivityRowsPlanningViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["activityRowHasFutureChanges"] = this.activityRowHasFutureChanges;
        data["activityReccurrenceId"] = this.activityReccurrenceId;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["color"] = this.color;
        data["activityShowColorOnDevice"] = this.activityShowColorOnDevice;
        data["activityId"] = this.activityId;
        data["activityTitle"] = this.activityTitle;
        data["templateActivityId"] = this.templateActivityId;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["plannedRouteId"] = this.plannedRouteId;
        data["isPlanned"] = this.isPlanned;
        data["detachedFromSeries"] = this.detachedFromSeries;
        data["fromTimeHour"] = this.fromTimeHour;
        data["fromTimeMinute"] = this.fromTimeMinute;
        data["toTimeHour"] = this.toTimeHour;
        data["toTimeMinute"] = this.toTimeMinute;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["fromFullTimeString"] = this.fromFullTimeString;
        data["toFullTimeString"] = this.toFullTimeString;
        data["ownerCustomerFirstName"] = this.ownerCustomerFirstName;
        data["ownerCustomerLastName"] = this.ownerCustomerLastName;
        data["ownerCustomerRoomNumber"] = this.ownerCustomerRoomNumber;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerAreaId"] = this.ownerAreaId;
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["activitySeverityLevelId"] = this.activitySeverityLevelId;
        if (Array.isArray(this.plannedActivityParticipants)) {
            data["plannedActivityParticipants"] = [];
            for (let item of this.plannedActivityParticipants)
                data["plannedActivityParticipants"].push(item.toJSON());
        }
        data["useParticipantList"] = this.useParticipantList;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISidePanelPlannedActivityRowsPlanningViewItem {
    id: number;
    activityRowId: number;
    activityRowHasFutureChanges: boolean;
    activityReccurrenceId: number;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    color?: string | undefined;
    activityShowColorOnDevice: boolean;
    activityId: number;
    activityTitle?: string | undefined;
    templateActivityId?: number | undefined;
    templateActivityTitle?: string | undefined;
    plannedRouteId: number;
    isPlanned: boolean;
    detachedFromSeries: boolean;
    fromTimeHour: number;
    fromTimeMinute: number;
    toTimeHour: number;
    toTimeMinute: number;
    visitLengthInMinutes: number;
    fromFullTimeString?: string | undefined;
    toFullTimeString?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaId?: number | undefined;
    calendarDay: Date;
    comment?: string | undefined;
    activitySeverityLevelId: SeverityLevelEnum;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    useParticipantList: boolean;
    createdOn: Date;
}

export class SidePanelUsersWorkSchedulesItem implements ISidePanelUsersWorkSchedulesItem {
    userId!: number;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    sidePanelPlannedRouteUserWorkScheduleItems?: SidePanelPlannedRouteUserWorkScheduleItem[] | undefined;

    constructor(data?: ISidePanelUsersWorkSchedulesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            if (Array.isArray(_data["sidePanelPlannedRouteUserWorkScheduleItems"])) {
                this.sidePanelPlannedRouteUserWorkScheduleItems = [] as any;
                for (let item of _data["sidePanelPlannedRouteUserWorkScheduleItems"])
                    this.sidePanelPlannedRouteUserWorkScheduleItems!.push(SidePanelPlannedRouteUserWorkScheduleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SidePanelUsersWorkSchedulesItem {
        data = typeof data === 'object' ? data : {};
        let result = new SidePanelUsersWorkSchedulesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        if (Array.isArray(this.sidePanelPlannedRouteUserWorkScheduleItems)) {
            data["sidePanelPlannedRouteUserWorkScheduleItems"] = [];
            for (let item of this.sidePanelPlannedRouteUserWorkScheduleItems)
                data["sidePanelPlannedRouteUserWorkScheduleItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISidePanelUsersWorkSchedulesItem {
    userId: number;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    sidePanelPlannedRouteUserWorkScheduleItems?: SidePanelPlannedRouteUserWorkScheduleItem[] | undefined;
}

export class SidePanelPlannedRouteUserWorkScheduleItem implements ISidePanelPlannedRouteUserWorkScheduleItem {
    id!: number;
    scheduledStart!: Date;
    scheduledEnd!: Date;
    plannedRouteId!: number;
    routeId!: number;
    userId!: number;
    userFullName?: string | undefined;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;
    isPlanned!: boolean;

    constructor(data?: ISidePanelPlannedRouteUserWorkScheduleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledStart = _data["scheduledStart"] ? new Date(_data["scheduledStart"].toString()) : <any>undefined;
            this.scheduledEnd = _data["scheduledEnd"] ? new Date(_data["scheduledEnd"].toString()) : <any>undefined;
            this.plannedRouteId = _data["plannedRouteId"];
            this.routeId = _data["routeId"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.substituteUserId = _data["substituteUserId"];
            this.substituteUserFullName = _data["substituteUserFullName"];
            this.isPlanned = _data["isPlanned"];
        }
    }

    static fromJS(data: any): SidePanelPlannedRouteUserWorkScheduleItem {
        data = typeof data === 'object' ? data : {};
        let result = new SidePanelPlannedRouteUserWorkScheduleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : <any>undefined;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : <any>undefined;
        data["plannedRouteId"] = this.plannedRouteId;
        data["routeId"] = this.routeId;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["substituteUserId"] = this.substituteUserId;
        data["substituteUserFullName"] = this.substituteUserFullName;
        data["isPlanned"] = this.isPlanned;
        return data;
    }
}

export interface ISidePanelPlannedRouteUserWorkScheduleItem {
    id: number;
    scheduledStart: Date;
    scheduledEnd: Date;
    plannedRouteId: number;
    routeId: number;
    userId: number;
    userFullName?: string | undefined;
    substituteUserId?: number | undefined;
    substituteUserFullName?: string | undefined;
    isPlanned: boolean;
}

export class UnplanAllPlannedActivityRowSeriesItem implements IUnplanAllPlannedActivityRowSeriesItem {
    plannedActivityRowId!: number;
    includePenMarked!: boolean;
    implementChangesUntil!: boolean;
    implementChangesUntilDate?: Date | undefined;

    constructor(data?: IUnplanAllPlannedActivityRowSeriesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.includePenMarked = _data["includePenMarked"];
            this.implementChangesUntil = _data["implementChangesUntil"];
            this.implementChangesUntilDate = _data["implementChangesUntilDate"] ? new Date(_data["implementChangesUntilDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnplanAllPlannedActivityRowSeriesItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnplanAllPlannedActivityRowSeriesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["includePenMarked"] = this.includePenMarked;
        data["implementChangesUntil"] = this.implementChangesUntil;
        data["implementChangesUntilDate"] = this.implementChangesUntilDate ? this.implementChangesUntilDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnplanAllPlannedActivityRowSeriesItem {
    plannedActivityRowId: number;
    includePenMarked: boolean;
    implementChangesUntil: boolean;
    implementChangesUntilDate?: Date | undefined;
}

export class MovePlannedActivityRowSeriesItem implements IMovePlannedActivityRowSeriesItem {
    plannedActivityRowId!: number;
    newRouteId?: number | undefined;
    startTime!: Date;
    endTime!: Date;
    forceOverwriteOfFutureChanges!: boolean;
    includePenMarked!: boolean;
    implementChangesUntil!: boolean;
    implementChangesUntilDate?: Date | undefined;

    constructor(data?: IMovePlannedActivityRowSeriesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.newRouteId = _data["newRouteId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.forceOverwriteOfFutureChanges = _data["forceOverwriteOfFutureChanges"];
            this.includePenMarked = _data["includePenMarked"];
            this.implementChangesUntil = _data["implementChangesUntil"];
            this.implementChangesUntilDate = _data["implementChangesUntilDate"] ? new Date(_data["implementChangesUntilDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MovePlannedActivityRowSeriesItem {
        data = typeof data === 'object' ? data : {};
        let result = new MovePlannedActivityRowSeriesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["newRouteId"] = this.newRouteId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["forceOverwriteOfFutureChanges"] = this.forceOverwriteOfFutureChanges;
        data["includePenMarked"] = this.includePenMarked;
        data["implementChangesUntil"] = this.implementChangesUntil;
        data["implementChangesUntilDate"] = this.implementChangesUntilDate ? this.implementChangesUntilDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMovePlannedActivityRowSeriesItem {
    plannedActivityRowId: number;
    newRouteId?: number | undefined;
    startTime: Date;
    endTime: Date;
    forceOverwriteOfFutureChanges: boolean;
    includePenMarked: boolean;
    implementChangesUntil: boolean;
    implementChangesUntilDate?: Date | undefined;
}

export class PlannedActivityRowItem implements IPlannedActivityRowItem {
    id!: number;
    activityRowId!: number;
    comment?: string | undefined;
    activityRow?: ActivityRowListItem | undefined;
    plannedRoute?: PlannedRouteItem | undefined;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedRouteId!: number;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    createdOn!: Date;
    activity_Comment?: string | undefined;
    activity_OwnerCustomerFirstName?: string | undefined;
    activity_OwnerCustomerLastName?: string | undefined;
    activity_OwnerCustomerRoomNumber?: string | undefined;
    activity_OwnerCustomerDescription?: string | undefined;
    activity_OwnerAreaName?: string | undefined;
    activity_OwnerAreaId?: number | undefined;
    activity_OwnerCustomerId?: number | undefined;
    activity_Title?: string | undefined;
    activity_Color?: string | undefined;
    activity_ExpectedAmount?: number | undefined;
    activity_StartDate!: Date;
    activity_EndDate?: Date | undefined;
    activity_RecurrenceId!: RecurrenceEnum;
    activity_SeverityLevelId!: SeverityLevelEnum;
    activity_ActivityRows?: ActivityRowListItem[] | undefined;
    activity_RecurrenceInterval!: number;
    signing_LatestSigningUser?: UserListItem | undefined;
    signing_LatestSigningDate?: Date | undefined;
    signing_LatestSigningComment?: string | undefined;
    signing_LatestSignedParticipants?: PlannedActivitySignedParticipantItem[] | undefined;
    detachedFromSeries!: boolean;
    startTime!: Date;
    endTime!: Date;
    activity_AlertFromStartInMinutes!: number;
    plannedActivityRowSignings?: PlannedActivityRowSigningItem[] | undefined;
    hasFutureDetachedFromSeries?: boolean | undefined;
    hasFutureDetachedFromDaySeries?: boolean | undefined;
    hasFutureActivityRowChanges?: boolean | undefined;
    hasFutureChanges?: boolean | undefined;
    isPlanned!: boolean;
    activity_ShowColorOnDevice!: boolean;
    templateActivityTitle?: string | undefined;
    templateActivityUnitId?: number | undefined;
    templateActivityUnitAbbreviation?: string | undefined;
    templateActivityUnitTypeEnumId?: UnitTypeEnum | undefined;
    templateActivityDescription?: string | undefined;
    useTemplateActivityDescription!: boolean;
    useParticipantList!: boolean;
    templateActivityInheritanceDescription?: string | undefined;
    isAreaTemplateActivity!: boolean;
    organization_AllowCommentOnSigning!: boolean;
    organization_AllowSigningWhenDelegationsIsNotFulfilled!: boolean;

    constructor(data?: IPlannedActivityRowItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.comment = _data["comment"];
            this.activityRow = _data["activityRow"] ? ActivityRowListItem.fromJS(_data["activityRow"]) : <any>undefined;
            this.plannedRoute = _data["plannedRoute"] ? PlannedRouteItem.fromJS(_data["plannedRoute"]) : <any>undefined;
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedRouteId = _data["plannedRouteId"];
            if (Array.isArray(_data["plannedActivityParticipants"])) {
                this.plannedActivityParticipants = [] as any;
                for (let item of _data["plannedActivityParticipants"])
                    this.plannedActivityParticipants!.push(PlannedActivityParticipantItem.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.activity_Comment = _data["activity_Comment"];
            this.activity_OwnerCustomerFirstName = _data["activity_OwnerCustomerFirstName"];
            this.activity_OwnerCustomerLastName = _data["activity_OwnerCustomerLastName"];
            this.activity_OwnerCustomerRoomNumber = _data["activity_OwnerCustomerRoomNumber"];
            this.activity_OwnerCustomerDescription = _data["activity_OwnerCustomerDescription"];
            this.activity_OwnerAreaName = _data["activity_OwnerAreaName"];
            this.activity_OwnerAreaId = _data["activity_OwnerAreaId"];
            this.activity_OwnerCustomerId = _data["activity_OwnerCustomerId"];
            this.activity_Title = _data["activity_Title"];
            this.activity_Color = _data["activity_Color"];
            this.activity_ExpectedAmount = _data["activity_ExpectedAmount"];
            this.activity_StartDate = _data["activity_StartDate"] ? new Date(_data["activity_StartDate"].toString()) : <any>undefined;
            this.activity_EndDate = _data["activity_EndDate"] ? new Date(_data["activity_EndDate"].toString()) : <any>undefined;
            this.activity_RecurrenceId = _data["activity_RecurrenceId"];
            this.activity_SeverityLevelId = _data["activity_SeverityLevelId"];
            if (Array.isArray(_data["activity_ActivityRows"])) {
                this.activity_ActivityRows = [] as any;
                for (let item of _data["activity_ActivityRows"])
                    this.activity_ActivityRows!.push(ActivityRowListItem.fromJS(item));
            }
            this.activity_RecurrenceInterval = _data["activity_RecurrenceInterval"];
            this.signing_LatestSigningUser = _data["signing_LatestSigningUser"] ? UserListItem.fromJS(_data["signing_LatestSigningUser"]) : <any>undefined;
            this.signing_LatestSigningDate = _data["signing_LatestSigningDate"] ? new Date(_data["signing_LatestSigningDate"].toString()) : <any>undefined;
            this.signing_LatestSigningComment = _data["signing_LatestSigningComment"];
            if (Array.isArray(_data["signing_LatestSignedParticipants"])) {
                this.signing_LatestSignedParticipants = [] as any;
                for (let item of _data["signing_LatestSignedParticipants"])
                    this.signing_LatestSignedParticipants!.push(PlannedActivitySignedParticipantItem.fromJS(item));
            }
            this.detachedFromSeries = _data["detachedFromSeries"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.activity_AlertFromStartInMinutes = _data["activity_AlertFromStartInMinutes"];
            if (Array.isArray(_data["plannedActivityRowSignings"])) {
                this.plannedActivityRowSignings = [] as any;
                for (let item of _data["plannedActivityRowSignings"])
                    this.plannedActivityRowSignings!.push(PlannedActivityRowSigningItem.fromJS(item));
            }
            this.hasFutureDetachedFromSeries = _data["hasFutureDetachedFromSeries"];
            this.hasFutureDetachedFromDaySeries = _data["hasFutureDetachedFromDaySeries"];
            this.hasFutureActivityRowChanges = _data["hasFutureActivityRowChanges"];
            this.hasFutureChanges = _data["hasFutureChanges"];
            this.isPlanned = _data["isPlanned"];
            this.activity_ShowColorOnDevice = _data["activity_ShowColorOnDevice"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.templateActivityUnitId = _data["templateActivityUnitId"];
            this.templateActivityUnitAbbreviation = _data["templateActivityUnitAbbreviation"];
            this.templateActivityUnitTypeEnumId = _data["templateActivityUnitTypeEnumId"];
            this.templateActivityDescription = _data["templateActivityDescription"];
            this.useTemplateActivityDescription = _data["useTemplateActivityDescription"];
            this.useParticipantList = _data["useParticipantList"];
            this.templateActivityInheritanceDescription = _data["templateActivityInheritanceDescription"];
            this.isAreaTemplateActivity = _data["isAreaTemplateActivity"];
            this.organization_AllowCommentOnSigning = _data["organization_AllowCommentOnSigning"];
            this.organization_AllowSigningWhenDelegationsIsNotFulfilled = _data["organization_AllowSigningWhenDelegationsIsNotFulfilled"];
        }
    }

    static fromJS(data: any): PlannedActivityRowItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["comment"] = this.comment;
        data["activityRow"] = this.activityRow ? this.activityRow.toJSON() : <any>undefined;
        data["plannedRoute"] = this.plannedRoute ? this.plannedRoute.toJSON() : <any>undefined;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedRouteId"] = this.plannedRouteId;
        if (Array.isArray(this.plannedActivityParticipants)) {
            data["plannedActivityParticipants"] = [];
            for (let item of this.plannedActivityParticipants)
                data["plannedActivityParticipants"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["activity_Comment"] = this.activity_Comment;
        data["activity_OwnerCustomerFirstName"] = this.activity_OwnerCustomerFirstName;
        data["activity_OwnerCustomerLastName"] = this.activity_OwnerCustomerLastName;
        data["activity_OwnerCustomerRoomNumber"] = this.activity_OwnerCustomerRoomNumber;
        data["activity_OwnerCustomerDescription"] = this.activity_OwnerCustomerDescription;
        data["activity_OwnerAreaName"] = this.activity_OwnerAreaName;
        data["activity_OwnerAreaId"] = this.activity_OwnerAreaId;
        data["activity_OwnerCustomerId"] = this.activity_OwnerCustomerId;
        data["activity_Title"] = this.activity_Title;
        data["activity_Color"] = this.activity_Color;
        data["activity_ExpectedAmount"] = this.activity_ExpectedAmount;
        data["activity_StartDate"] = this.activity_StartDate ? this.activity_StartDate.toISOString() : <any>undefined;
        data["activity_EndDate"] = this.activity_EndDate ? this.activity_EndDate.toISOString() : <any>undefined;
        data["activity_RecurrenceId"] = this.activity_RecurrenceId;
        data["activity_SeverityLevelId"] = this.activity_SeverityLevelId;
        if (Array.isArray(this.activity_ActivityRows)) {
            data["activity_ActivityRows"] = [];
            for (let item of this.activity_ActivityRows)
                data["activity_ActivityRows"].push(item.toJSON());
        }
        data["activity_RecurrenceInterval"] = this.activity_RecurrenceInterval;
        data["signing_LatestSigningUser"] = this.signing_LatestSigningUser ? this.signing_LatestSigningUser.toJSON() : <any>undefined;
        data["signing_LatestSigningDate"] = this.signing_LatestSigningDate ? this.signing_LatestSigningDate.toISOString() : <any>undefined;
        data["signing_LatestSigningComment"] = this.signing_LatestSigningComment;
        if (Array.isArray(this.signing_LatestSignedParticipants)) {
            data["signing_LatestSignedParticipants"] = [];
            for (let item of this.signing_LatestSignedParticipants)
                data["signing_LatestSignedParticipants"].push(item.toJSON());
        }
        data["detachedFromSeries"] = this.detachedFromSeries;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["activity_AlertFromStartInMinutes"] = this.activity_AlertFromStartInMinutes;
        if (Array.isArray(this.plannedActivityRowSignings)) {
            data["plannedActivityRowSignings"] = [];
            for (let item of this.plannedActivityRowSignings)
                data["plannedActivityRowSignings"].push(item.toJSON());
        }
        data["hasFutureDetachedFromSeries"] = this.hasFutureDetachedFromSeries;
        data["hasFutureDetachedFromDaySeries"] = this.hasFutureDetachedFromDaySeries;
        data["hasFutureActivityRowChanges"] = this.hasFutureActivityRowChanges;
        data["hasFutureChanges"] = this.hasFutureChanges;
        data["isPlanned"] = this.isPlanned;
        data["activity_ShowColorOnDevice"] = this.activity_ShowColorOnDevice;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["templateActivityUnitId"] = this.templateActivityUnitId;
        data["templateActivityUnitAbbreviation"] = this.templateActivityUnitAbbreviation;
        data["templateActivityUnitTypeEnumId"] = this.templateActivityUnitTypeEnumId;
        data["templateActivityDescription"] = this.templateActivityDescription;
        data["useTemplateActivityDescription"] = this.useTemplateActivityDescription;
        data["useParticipantList"] = this.useParticipantList;
        data["templateActivityInheritanceDescription"] = this.templateActivityInheritanceDescription;
        data["isAreaTemplateActivity"] = this.isAreaTemplateActivity;
        data["organization_AllowCommentOnSigning"] = this.organization_AllowCommentOnSigning;
        data["organization_AllowSigningWhenDelegationsIsNotFulfilled"] = this.organization_AllowSigningWhenDelegationsIsNotFulfilled;
        return data;
    }
}

export interface IPlannedActivityRowItem {
    id: number;
    activityRowId: number;
    comment?: string | undefined;
    activityRow?: ActivityRowListItem | undefined;
    plannedRoute?: PlannedRouteItem | undefined;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedRouteId: number;
    plannedActivityParticipants?: PlannedActivityParticipantItem[] | undefined;
    createdOn: Date;
    activity_Comment?: string | undefined;
    activity_OwnerCustomerFirstName?: string | undefined;
    activity_OwnerCustomerLastName?: string | undefined;
    activity_OwnerCustomerRoomNumber?: string | undefined;
    activity_OwnerCustomerDescription?: string | undefined;
    activity_OwnerAreaName?: string | undefined;
    activity_OwnerAreaId?: number | undefined;
    activity_OwnerCustomerId?: number | undefined;
    activity_Title?: string | undefined;
    activity_Color?: string | undefined;
    activity_ExpectedAmount?: number | undefined;
    activity_StartDate: Date;
    activity_EndDate?: Date | undefined;
    activity_RecurrenceId: RecurrenceEnum;
    activity_SeverityLevelId: SeverityLevelEnum;
    activity_ActivityRows?: ActivityRowListItem[] | undefined;
    activity_RecurrenceInterval: number;
    signing_LatestSigningUser?: UserListItem | undefined;
    signing_LatestSigningDate?: Date | undefined;
    signing_LatestSigningComment?: string | undefined;
    signing_LatestSignedParticipants?: PlannedActivitySignedParticipantItem[] | undefined;
    detachedFromSeries: boolean;
    startTime: Date;
    endTime: Date;
    activity_AlertFromStartInMinutes: number;
    plannedActivityRowSignings?: PlannedActivityRowSigningItem[] | undefined;
    hasFutureDetachedFromSeries?: boolean | undefined;
    hasFutureDetachedFromDaySeries?: boolean | undefined;
    hasFutureActivityRowChanges?: boolean | undefined;
    hasFutureChanges?: boolean | undefined;
    isPlanned: boolean;
    activity_ShowColorOnDevice: boolean;
    templateActivityTitle?: string | undefined;
    templateActivityUnitId?: number | undefined;
    templateActivityUnitAbbreviation?: string | undefined;
    templateActivityUnitTypeEnumId?: UnitTypeEnum | undefined;
    templateActivityDescription?: string | undefined;
    useTemplateActivityDescription: boolean;
    useParticipantList: boolean;
    templateActivityInheritanceDescription?: string | undefined;
    isAreaTemplateActivity: boolean;
    organization_AllowCommentOnSigning: boolean;
    organization_AllowSigningWhenDelegationsIsNotFulfilled: boolean;
}

export class PlannedRouteItem implements IPlannedRouteItem {
    id!: number;
    routeId!: number;
    calendarDay!: Date;

    constructor(data?: IPlannedRouteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeId = _data["routeId"];
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedRouteItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeId"] = this.routeId;
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedRouteItem {
    id: number;
    routeId: number;
    calendarDay: Date;
}

export class UserListItem implements IUserListItem {
    id!: number;
    active!: boolean;
    userType!: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    emailSentDate?: Date | undefined;
    userAreas?: UserAreaItem[] | undefined;

    constructor(data?: IUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userType = _data["userType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.emailSentDate = _data["emailSentDate"] ? new Date(_data["emailSentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userType"] = this.userType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["emailSentDate"] = this.emailSentDate ? this.emailSentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserListItem {
    id: number;
    active: boolean;
    userType: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    emailSentDate?: Date | undefined;
    userAreas?: UserAreaItem[] | undefined;
}

export enum UserTypeEnum {
    SystemAdmin = "SystemAdmin",
    OrganizationMember = "OrganizationMember",
    OrganizationAdmin = "OrganizationAdmin",
    TeniloSupport = "TeniloSupport",
}

export class UserAreaItem implements IUserAreaItem {
    id!: number;
    userId!: number;
    areaId!: number;
    areaName?: string | undefined;
    roleId!: RoleEnum;
    hasRoutes!: boolean;
    hasChildAreas!: boolean;
    organizationParentsName?: string | undefined;

    constructor(data?: IUserAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.roleId = _data["roleId"];
            this.hasRoutes = _data["hasRoutes"];
            this.hasChildAreas = _data["hasChildAreas"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): UserAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["roleId"] = this.roleId;
        data["hasRoutes"] = this.hasRoutes;
        data["hasChildAreas"] = this.hasChildAreas;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface IUserAreaItem {
    id: number;
    userId: number;
    areaId: number;
    areaName?: string | undefined;
    roleId: RoleEnum;
    hasRoutes: boolean;
    hasChildAreas: boolean;
    organizationParentsName?: string | undefined;
}

export enum RoleEnum {
    Admin = "Admin",
    Planner = "Planner",
    Caretaker = "Caretaker",
}

export class PlannedActivitySignedParticipantItem implements IPlannedActivitySignedParticipantItem {
    id!: number;
    customerId!: number;
    declined!: boolean;
    customerFullName?: string | undefined;

    constructor(data?: IPlannedActivitySignedParticipantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.declined = _data["declined"];
            this.customerFullName = _data["customerFullName"];
        }
    }

    static fromJS(data: any): PlannedActivitySignedParticipantItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivitySignedParticipantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["declined"] = this.declined;
        data["customerFullName"] = this.customerFullName;
        return data;
    }
}

export interface IPlannedActivitySignedParticipantItem {
    id: number;
    customerId: number;
    declined: boolean;
    customerFullName?: string | undefined;
}

export class PlannedActivityRowSigningItem implements IPlannedActivityRowSigningItem {
    id!: number;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerRoomNumber?: string | undefined;
    comment?: string | undefined;
    signingComment?: string | undefined;
    givenAmount?: number | undefined;
    expectedAmount?: number | undefined;
    unitTitle?: string | undefined;
    activityName?: string | undefined;
    templateActivityTitle?: string | undefined;
    templateActivityId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityCategoryId?: number | undefined;
    legislationTitle?: string | undefined;
    legislationId?: number | undefined;
    plannedCalendarDay!: Date;
    plannedActivityRowId!: number;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    createdBy?: UserListItem | undefined;
    createdOn!: Date;
    plannedStartTime!: Date;
    plannedActivitySignedParticipants?: PlannedActivitySignedParticipantItem[] | undefined;

    constructor(data?: IPlannedActivityRowSigningItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerRoomNumber = _data["customerRoomNumber"];
            this.comment = _data["comment"];
            this.signingComment = _data["signingComment"];
            this.givenAmount = _data["givenAmount"];
            this.expectedAmount = _data["expectedAmount"];
            this.unitTitle = _data["unitTitle"];
            this.activityName = _data["activityName"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.templateActivityId = _data["templateActivityId"];
            this.templateActivityCategoryTitle = _data["templateActivityCategoryTitle"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.legislationTitle = _data["legislationTitle"];
            this.legislationId = _data["legislationId"];
            this.plannedCalendarDay = _data["plannedCalendarDay"] ? new Date(_data["plannedCalendarDay"].toString()) : <any>undefined;
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.createdBy = _data["createdBy"] ? UserListItem.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.plannedStartTime = _data["plannedStartTime"] ? new Date(_data["plannedStartTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["plannedActivitySignedParticipants"])) {
                this.plannedActivitySignedParticipants = [] as any;
                for (let item of _data["plannedActivitySignedParticipants"])
                    this.plannedActivitySignedParticipants!.push(PlannedActivitySignedParticipantItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlannedActivityRowSigningItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowSigningItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerRoomNumber"] = this.customerRoomNumber;
        data["comment"] = this.comment;
        data["signingComment"] = this.signingComment;
        data["givenAmount"] = this.givenAmount;
        data["expectedAmount"] = this.expectedAmount;
        data["unitTitle"] = this.unitTitle;
        data["activityName"] = this.activityName;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["templateActivityId"] = this.templateActivityId;
        data["templateActivityCategoryTitle"] = this.templateActivityCategoryTitle;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["legislationTitle"] = this.legislationTitle;
        data["legislationId"] = this.legislationId;
        data["plannedCalendarDay"] = this.plannedCalendarDay ? this.plannedCalendarDay.toISOString() : <any>undefined;
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["plannedStartTime"] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        if (Array.isArray(this.plannedActivitySignedParticipants)) {
            data["plannedActivitySignedParticipants"] = [];
            for (let item of this.plannedActivitySignedParticipants)
                data["plannedActivitySignedParticipants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlannedActivityRowSigningItem {
    id: number;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerRoomNumber?: string | undefined;
    comment?: string | undefined;
    signingComment?: string | undefined;
    givenAmount?: number | undefined;
    expectedAmount?: number | undefined;
    unitTitle?: string | undefined;
    activityName?: string | undefined;
    templateActivityTitle?: string | undefined;
    templateActivityId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityCategoryId?: number | undefined;
    legislationTitle?: string | undefined;
    legislationId?: number | undefined;
    plannedCalendarDay: Date;
    plannedActivityRowId: number;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    createdBy?: UserListItem | undefined;
    createdOn: Date;
    plannedStartTime: Date;
    plannedActivitySignedParticipants?: PlannedActivitySignedParticipantItem[] | undefined;
}

export enum UnitTypeEnum {
    TimeUnit = "TimeUnit",
    MeasurementUnit = "MeasurementUnit",
}

export class PlannedActivityRowUpdateItem implements IPlannedActivityRowUpdateItem {
    id!: number;
    activityRowId!: number;
    comment?: string | undefined;
    activityRow?: ActivityRowListItem | undefined;
    plannedRoute?: PlannedRouteItem | undefined;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedRouteId!: number;
    plannedActivityParticipants?: PlannedActivityParticipantUpdateItem[] | undefined;
    detachedFromSeries!: boolean;
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IPlannedActivityRowUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.comment = _data["comment"];
            this.activityRow = _data["activityRow"] ? ActivityRowListItem.fromJS(_data["activityRow"]) : <any>undefined;
            this.plannedRoute = _data["plannedRoute"] ? PlannedRouteItem.fromJS(_data["plannedRoute"]) : <any>undefined;
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedRouteId = _data["plannedRouteId"];
            if (Array.isArray(_data["plannedActivityParticipants"])) {
                this.plannedActivityParticipants = [] as any;
                for (let item of _data["plannedActivityParticipants"])
                    this.plannedActivityParticipants!.push(PlannedActivityParticipantUpdateItem.fromJS(item));
            }
            this.detachedFromSeries = _data["detachedFromSeries"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedActivityRowUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["comment"] = this.comment;
        data["activityRow"] = this.activityRow ? this.activityRow.toJSON() : <any>undefined;
        data["plannedRoute"] = this.plannedRoute ? this.plannedRoute.toJSON() : <any>undefined;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedRouteId"] = this.plannedRouteId;
        if (Array.isArray(this.plannedActivityParticipants)) {
            data["plannedActivityParticipants"] = [];
            for (let item of this.plannedActivityParticipants)
                data["plannedActivityParticipants"].push(item.toJSON());
        }
        data["detachedFromSeries"] = this.detachedFromSeries;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedActivityRowUpdateItem {
    id: number;
    activityRowId: number;
    comment?: string | undefined;
    activityRow?: ActivityRowListItem | undefined;
    plannedRoute?: PlannedRouteItem | undefined;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedRouteId: number;
    plannedActivityParticipants?: PlannedActivityParticipantUpdateItem[] | undefined;
    detachedFromSeries: boolean;
    startTime: Date;
    endTime: Date;
}

export class PlannedActivityParticipantUpdateItem implements IPlannedActivityParticipantUpdateItem {
    id?: number | undefined;
    customerId!: number;

    constructor(data?: IPlannedActivityParticipantUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): PlannedActivityParticipantUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityParticipantUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IPlannedActivityParticipantUpdateItem {
    id?: number | undefined;
    customerId: number;
}

export class PlannedActivityRowSigningCreateItem implements IPlannedActivityRowSigningCreateItem {
    comment?: string | undefined;
    signingComment?: string | undefined;
    plannedActivityRowId!: number;
    givenAmount?: number | undefined;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedActivitySignedParticipants?: PlannedActivitySignedParticipantCreateItem[] | undefined;
    plannedActivitySignedDelegationViolations?: PlannedActivitySignedDelegationViolationsCreateItem[] | undefined;
    hasDelegationViolations!: boolean;

    constructor(data?: IPlannedActivityRowSigningCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.signingComment = _data["signingComment"];
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.givenAmount = _data["givenAmount"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            if (Array.isArray(_data["plannedActivitySignedParticipants"])) {
                this.plannedActivitySignedParticipants = [] as any;
                for (let item of _data["plannedActivitySignedParticipants"])
                    this.plannedActivitySignedParticipants!.push(PlannedActivitySignedParticipantCreateItem.fromJS(item));
            }
            if (Array.isArray(_data["plannedActivitySignedDelegationViolations"])) {
                this.plannedActivitySignedDelegationViolations = [] as any;
                for (let item of _data["plannedActivitySignedDelegationViolations"])
                    this.plannedActivitySignedDelegationViolations!.push(PlannedActivitySignedDelegationViolationsCreateItem.fromJS(item));
            }
            this.hasDelegationViolations = _data["hasDelegationViolations"];
        }
    }

    static fromJS(data: any): PlannedActivityRowSigningCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowSigningCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["signingComment"] = this.signingComment;
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["givenAmount"] = this.givenAmount;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        if (Array.isArray(this.plannedActivitySignedParticipants)) {
            data["plannedActivitySignedParticipants"] = [];
            for (let item of this.plannedActivitySignedParticipants)
                data["plannedActivitySignedParticipants"].push(item.toJSON());
        }
        if (Array.isArray(this.plannedActivitySignedDelegationViolations)) {
            data["plannedActivitySignedDelegationViolations"] = [];
            for (let item of this.plannedActivitySignedDelegationViolations)
                data["plannedActivitySignedDelegationViolations"].push(item.toJSON());
        }
        data["hasDelegationViolations"] = this.hasDelegationViolations;
        return data;
    }
}

export interface IPlannedActivityRowSigningCreateItem {
    comment?: string | undefined;
    signingComment?: string | undefined;
    plannedActivityRowId: number;
    givenAmount?: number | undefined;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedActivitySignedParticipants?: PlannedActivitySignedParticipantCreateItem[] | undefined;
    plannedActivitySignedDelegationViolations?: PlannedActivitySignedDelegationViolationsCreateItem[] | undefined;
    hasDelegationViolations: boolean;
}

export class PlannedActivitySignedParticipantCreateItem implements IPlannedActivitySignedParticipantCreateItem {
    customerId!: number;
    declined!: boolean;

    constructor(data?: IPlannedActivitySignedParticipantCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.declined = _data["declined"];
        }
    }

    static fromJS(data: any): PlannedActivitySignedParticipantCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivitySignedParticipantCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["declined"] = this.declined;
        return data;
    }
}

export interface IPlannedActivitySignedParticipantCreateItem {
    customerId: number;
    declined: boolean;
}

export class PlannedActivitySignedDelegationViolationsCreateItem implements IPlannedActivitySignedDelegationViolationsCreateItem {
    delegationId!: number;

    constructor(data?: IPlannedActivitySignedDelegationViolationsCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegationId = _data["delegationId"];
        }
    }

    static fromJS(data: any): PlannedActivitySignedDelegationViolationsCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivitySignedDelegationViolationsCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegationId"] = this.delegationId;
        return data;
    }
}

export interface IPlannedActivitySignedDelegationViolationsCreateItem {
    delegationId: number;
}

export class MultiSignItem implements IMultiSignItem {
    plannedActivityIds?: number[] | undefined;
    plannedActivityStatusId!: PlannedActivityStatusEnum;

    constructor(data?: IMultiSignItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plannedActivityIds"])) {
                this.plannedActivityIds = [] as any;
                for (let item of _data["plannedActivityIds"])
                    this.plannedActivityIds!.push(item);
            }
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
        }
    }

    static fromJS(data: any): MultiSignItem {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSignItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedActivityIds)) {
            data["plannedActivityIds"] = [];
            for (let item of this.plannedActivityIds)
                data["plannedActivityIds"].push(item);
        }
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        return data;
    }
}

export interface IMultiSignItem {
    plannedActivityIds?: number[] | undefined;
    plannedActivityStatusId: PlannedActivityStatusEnum;
}

export class MultiSignActivityItem implements IMultiSignActivityItem {
    plannedActivityId!: number;
    plannedStartTime!: Date;
    comment?: string | undefined;
    activityFullName?: string | undefined;
    ownerDescription?: string | undefined;
    recurranceType!: RecurrenceEnum;
    routeName?: string | undefined;
    routeColor?: string | undefined;

    constructor(data?: IMultiSignActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityId = _data["plannedActivityId"];
            this.plannedStartTime = _data["plannedStartTime"] ? new Date(_data["plannedStartTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.activityFullName = _data["activityFullName"];
            this.ownerDescription = _data["ownerDescription"];
            this.recurranceType = _data["recurranceType"];
            this.routeName = _data["routeName"];
            this.routeColor = _data["routeColor"];
        }
    }

    static fromJS(data: any): MultiSignActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSignActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityId"] = this.plannedActivityId;
        data["plannedStartTime"] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["activityFullName"] = this.activityFullName;
        data["ownerDescription"] = this.ownerDescription;
        data["recurranceType"] = this.recurranceType;
        data["routeName"] = this.routeName;
        data["routeColor"] = this.routeColor;
        return data;
    }
}

export interface IMultiSignActivityItem {
    plannedActivityId: number;
    plannedStartTime: Date;
    comment?: string | undefined;
    activityFullName?: string | undefined;
    ownerDescription?: string | undefined;
    recurranceType: RecurrenceEnum;
    routeName?: string | undefined;
    routeColor?: string | undefined;
}

export class FulfilledDelegationItem implements IFulfilledDelegationItem {
    id!: number;
    title!: string;
    isFulfilled!: boolean;
    requiredAtAreaId?: number | undefined;
    requiredAtCustomerId?: number | undefined;
    plannedActivityRowId!: number;
    plannedRouteId!: number;

    constructor(data?: IFulfilledDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.isFulfilled = _data["isFulfilled"];
            this.requiredAtAreaId = _data["requiredAtAreaId"];
            this.requiredAtCustomerId = _data["requiredAtCustomerId"];
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            this.plannedRouteId = _data["plannedRouteId"];
        }
    }

    static fromJS(data: any): FulfilledDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new FulfilledDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["isFulfilled"] = this.isFulfilled;
        data["requiredAtAreaId"] = this.requiredAtAreaId;
        data["requiredAtCustomerId"] = this.requiredAtCustomerId;
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        data["plannedRouteId"] = this.plannedRouteId;
        return data;
    }
}

export interface IFulfilledDelegationItem {
    id: number;
    title: string;
    isFulfilled: boolean;
    requiredAtAreaId?: number | undefined;
    requiredAtCustomerId?: number | undefined;
    plannedActivityRowId: number;
    plannedRouteId: number;
}

export class DailyActivityItem implements IDailyActivityItem {
    plannedActivityRow?: PlannedActivityRowItem | undefined;
    isTemporaryActivityCreatedToday!: boolean;
    notFullfilledDelegations?: FulfilledDelegationItem[] | undefined;
    recentActivitySignings?: RecentPerformedSigningItem[] | undefined;
    activityHasActiveDelayedOccurance!: boolean;
    activeDelayedSignings?: PlannedActivityRowSigningItem[] | undefined;

    constructor(data?: IDailyActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityRow = _data["plannedActivityRow"] ? PlannedActivityRowItem.fromJS(_data["plannedActivityRow"]) : <any>undefined;
            this.isTemporaryActivityCreatedToday = _data["isTemporaryActivityCreatedToday"];
            if (Array.isArray(_data["notFullfilledDelegations"])) {
                this.notFullfilledDelegations = [] as any;
                for (let item of _data["notFullfilledDelegations"])
                    this.notFullfilledDelegations!.push(FulfilledDelegationItem.fromJS(item));
            }
            if (Array.isArray(_data["recentActivitySignings"])) {
                this.recentActivitySignings = [] as any;
                for (let item of _data["recentActivitySignings"])
                    this.recentActivitySignings!.push(RecentPerformedSigningItem.fromJS(item));
            }
            this.activityHasActiveDelayedOccurance = _data["activityHasActiveDelayedOccurance"];
            if (Array.isArray(_data["activeDelayedSignings"])) {
                this.activeDelayedSignings = [] as any;
                for (let item of _data["activeDelayedSignings"])
                    this.activeDelayedSignings!.push(PlannedActivityRowSigningItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new DailyActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityRow"] = this.plannedActivityRow ? this.plannedActivityRow.toJSON() : <any>undefined;
        data["isTemporaryActivityCreatedToday"] = this.isTemporaryActivityCreatedToday;
        if (Array.isArray(this.notFullfilledDelegations)) {
            data["notFullfilledDelegations"] = [];
            for (let item of this.notFullfilledDelegations)
                data["notFullfilledDelegations"].push(item.toJSON());
        }
        if (Array.isArray(this.recentActivitySignings)) {
            data["recentActivitySignings"] = [];
            for (let item of this.recentActivitySignings)
                data["recentActivitySignings"].push(item.toJSON());
        }
        data["activityHasActiveDelayedOccurance"] = this.activityHasActiveDelayedOccurance;
        if (Array.isArray(this.activeDelayedSignings)) {
            data["activeDelayedSignings"] = [];
            for (let item of this.activeDelayedSignings)
                data["activeDelayedSignings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailyActivityItem {
    plannedActivityRow?: PlannedActivityRowItem | undefined;
    isTemporaryActivityCreatedToday: boolean;
    notFullfilledDelegations?: FulfilledDelegationItem[] | undefined;
    recentActivitySignings?: RecentPerformedSigningItem[] | undefined;
    activityHasActiveDelayedOccurance: boolean;
    activeDelayedSignings?: PlannedActivityRowSigningItem[] | undefined;
}

export class AreaItem implements IAreaItem {
    id!: number;
    name?: string | undefined;
    organizationParentsName?: string | undefined;
    internalInformation?: string | undefined;
    pwaAllowNavigateToPlanningPage!: boolean;
    pwaAllowUseMultiSigning!: boolean;
    suppressTimesOnKioskAndPwa!: boolean;

    constructor(data?: IAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationParentsName = _data["organizationParentsName"];
            this.internalInformation = _data["internalInformation"];
            this.pwaAllowNavigateToPlanningPage = _data["pwaAllowNavigateToPlanningPage"];
            this.pwaAllowUseMultiSigning = _data["pwaAllowUseMultiSigning"];
            this.suppressTimesOnKioskAndPwa = _data["suppressTimesOnKioskAndPwa"];
        }
    }

    static fromJS(data: any): AreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationParentsName"] = this.organizationParentsName;
        data["internalInformation"] = this.internalInformation;
        data["pwaAllowNavigateToPlanningPage"] = this.pwaAllowNavigateToPlanningPage;
        data["pwaAllowUseMultiSigning"] = this.pwaAllowUseMultiSigning;
        data["suppressTimesOnKioskAndPwa"] = this.suppressTimesOnKioskAndPwa;
        return data;
    }
}

export interface IAreaItem {
    id: number;
    name?: string | undefined;
    organizationParentsName?: string | undefined;
    internalInformation?: string | undefined;
    pwaAllowNavigateToPlanningPage: boolean;
    pwaAllowUseMultiSigning: boolean;
    suppressTimesOnKioskAndPwa: boolean;
}

export class AreaForUserListItem implements IAreaForUserListItem {
    id!: number;
    name?: string | undefined;
    organizationParentsName?: string | undefined;

    constructor(data?: IAreaForUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): AreaForUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaForUserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface IAreaForUserListItem {
    id: number;
    name?: string | undefined;
    organizationParentsName?: string | undefined;
}

export class AreaDropListItem implements IAreaDropListItem {
    id!: number;
    name?: string | undefined;
    areaId!: number;
    kioskMainArea!: boolean;

    constructor(data?: IAreaDropListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.areaId = _data["areaId"];
            this.kioskMainArea = _data["kioskMainArea"];
        }
    }

    static fromJS(data: any): AreaDropListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDropListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["kioskMainArea"] = this.kioskMainArea;
        return data;
    }
}

export interface IAreaDropListItem {
    id: number;
    name?: string | undefined;
    areaId: number;
    kioskMainArea: boolean;
}

export class AreaUpdateItem implements IAreaUpdateItem {
    id!: number;
    name?: string | undefined;
    internalInformation?: string | undefined;
    pwaAllowNavigateToPlanningPage!: boolean;
    pwaAllowUseMultiSigning!: boolean;
    suppressTimesOnKioskAndPwa!: boolean;

    constructor(data?: IAreaUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.internalInformation = _data["internalInformation"];
            this.pwaAllowNavigateToPlanningPage = _data["pwaAllowNavigateToPlanningPage"];
            this.pwaAllowUseMultiSigning = _data["pwaAllowUseMultiSigning"];
            this.suppressTimesOnKioskAndPwa = _data["suppressTimesOnKioskAndPwa"];
        }
    }

    static fromJS(data: any): AreaUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["internalInformation"] = this.internalInformation;
        data["pwaAllowNavigateToPlanningPage"] = this.pwaAllowNavigateToPlanningPage;
        data["pwaAllowUseMultiSigning"] = this.pwaAllowUseMultiSigning;
        data["suppressTimesOnKioskAndPwa"] = this.suppressTimesOnKioskAndPwa;
        return data;
    }
}

export interface IAreaUpdateItem {
    id: number;
    name?: string | undefined;
    internalInformation?: string | undefined;
    pwaAllowNavigateToPlanningPage: boolean;
    pwaAllowUseMultiSigning: boolean;
    suppressTimesOnKioskAndPwa: boolean;
}

export class JwtTokenGenerationResultItem implements IJwtTokenGenerationResultItem {
    token!: string;
    tokenExpiresOn!: Date;
    refreshToken!: string;
    refreshTokenExpiresOn!: Date;

    constructor(data?: IJwtTokenGenerationResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiresOn = _data["tokenExpiresOn"] ? new Date(_data["tokenExpiresOn"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiresOn = _data["refreshTokenExpiresOn"] ? new Date(_data["refreshTokenExpiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JwtTokenGenerationResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new JwtTokenGenerationResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiresOn"] = this.tokenExpiresOn ? this.tokenExpiresOn.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiresOn"] = this.refreshTokenExpiresOn ? this.refreshTokenExpiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJwtTokenGenerationResultItem {
    token: string;
    tokenExpiresOn: Date;
    refreshToken: string;
    refreshTokenExpiresOn: Date;
}

export class LoginAppModel implements ILoginAppModel {
    email!: string;
    password!: string;

    constructor(data?: ILoginAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginAppModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginAppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginAppModel {
    email: string;
    password: string;
}

export class LoginWithPinAppModel implements ILoginWithPinAppModel {
    userId!: number;
    pin!: string;
    deviceGuid!: string;

    constructor(data?: ILoginWithPinAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.pin = _data["pin"];
            this.deviceGuid = _data["deviceGuid"];
        }
    }

    static fromJS(data: any): LoginWithPinAppModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWithPinAppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["pin"] = this.pin;
        data["deviceGuid"] = this.deviceGuid;
        return data;
    }
}

export interface ILoginWithPinAppModel {
    userId: number;
    pin: string;
    deviceGuid: string;
}

export class AuthWithRefreshTokenAppModel implements IAuthWithRefreshTokenAppModel {
    token!: string;

    constructor(data?: IAuthWithRefreshTokenAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthWithRefreshTokenAppModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthWithRefreshTokenAppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IAuthWithRefreshTokenAppModel {
    token: string;
}

export class RevokeRefreshTokenAppModel implements IRevokeRefreshTokenAppModel {
    refreshToken!: string;

    constructor(data?: IRevokeRefreshTokenAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RevokeRefreshTokenAppModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeRefreshTokenAppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRevokeRefreshTokenAppModel {
    refreshToken: string;
}

export class FederatedLoginResponse implements IFederatedLoginResponse {
    sessionId?: string | undefined;
    redirectUrl?: string | undefined;

    constructor(data?: IFederatedLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): FederatedLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FederatedLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IFederatedLoginResponse {
    sessionId?: string | undefined;
    redirectUrl?: string | undefined;
}

export class GrandIdRequestModel implements IGrandIdRequestModel {
    sessionId?: string | undefined;
    organization?: string | undefined;
    serviceId?: GrandIdServiceEnum;

    constructor(data?: IGrandIdRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.organization = _data["organization"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): GrandIdRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GrandIdRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["organization"] = this.organization;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface IGrandIdRequestModel {
    sessionId?: string | undefined;
    organization?: string | undefined;
    serviceId?: GrandIdServiceEnum;
}

export enum GrandIdServiceEnum {
    Saml = "Saml",
    FrejaEId = "FrejaEId",
    BankId = "BankId",
}

export class RequestorValidityItem implements IRequestorValidityItem {
    requestValid!: boolean;
    kioskTokenData?: JwtTokenGenerationResultItem | undefined;

    constructor(data?: IRequestorValidityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestValid = _data["requestValid"];
            this.kioskTokenData = _data["kioskTokenData"] ? JwtTokenGenerationResultItem.fromJS(_data["kioskTokenData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestorValidityItem {
        data = typeof data === 'object' ? data : {};
        let result = new RequestorValidityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestValid"] = this.requestValid;
        data["kioskTokenData"] = this.kioskTokenData ? this.kioskTokenData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestorValidityItem {
    requestValid: boolean;
    kioskTokenData?: JwtTokenGenerationResultItem | undefined;
}

export class CustomerItem implements ICustomerItem {
    id!: number;
    statusId!: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    description?: string | undefined;
    organizationId!: number;
    organizationName?: string | undefined;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaItem[] | undefined;
    activities?: ActivityListItem[] | undefined;
    customerPausedPeriods?: CustomerPausedPeriodItem[] | undefined;
    extraInfo?: string | undefined;

    constructor(data?: ICustomerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.roomNumber = _data["roomNumber"];
            if (Array.isArray(_data["customerAreas"])) {
                this.customerAreas = [] as any;
                for (let item of _data["customerAreas"])
                    this.customerAreas!.push(CustomerAreaItem.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ActivityListItem.fromJS(item));
            }
            if (Array.isArray(_data["customerPausedPeriods"])) {
                this.customerPausedPeriods = [] as any;
                for (let item of _data["customerPausedPeriods"])
                    this.customerPausedPeriods!.push(CustomerPausedPeriodItem.fromJS(item));
            }
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): CustomerItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["roomNumber"] = this.roomNumber;
        if (Array.isArray(this.customerAreas)) {
            data["customerAreas"] = [];
            for (let item of this.customerAreas)
                data["customerAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        if (Array.isArray(this.customerPausedPeriods)) {
            data["customerPausedPeriods"] = [];
            for (let item of this.customerPausedPeriods)
                data["customerPausedPeriods"].push(item.toJSON());
        }
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface ICustomerItem {
    id: number;
    statusId: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    description?: string | undefined;
    organizationId: number;
    organizationName?: string | undefined;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaItem[] | undefined;
    activities?: ActivityListItem[] | undefined;
    customerPausedPeriods?: CustomerPausedPeriodItem[] | undefined;
    extraInfo?: string | undefined;
}

export enum CustomerStatusEnum {
    Active = "Active",
    Removed = "Removed",
    Inactive = "Inactive",
}

export class CustomerAreaItem implements ICustomerAreaItem {
    id!: number;
    customerId!: number;
    areaId!: number;
    areaName?: string | undefined;
    organizationParentsName?: string | undefined;

    constructor(data?: ICustomerAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): CustomerAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface ICustomerAreaItem {
    id: number;
    customerId: number;
    areaId: number;
    areaName?: string | undefined;
    organizationParentsName?: string | undefined;
}

export class CustomerPausedPeriodItem implements ICustomerPausedPeriodItem {
    id!: number;
    customerId!: number;
    comment?: string | undefined;
    startDateTime!: Date;
    endDateTime?: Date | undefined;

    constructor(data?: ICustomerPausedPeriodItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerPausedPeriodItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPausedPeriodItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerPausedPeriodItem {
    id: number;
    customerId: number;
    comment?: string | undefined;
    startDateTime: Date;
    endDateTime?: Date | undefined;
}

export abstract class PageResult implements IPageResult {
    page!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PageResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PageResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPageResult {
    page: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PageResultOfCustomerListItem extends PageResult implements IPageResultOfCustomerListItem {
    items!: CustomerListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfCustomerListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfCustomerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfCustomerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfCustomerListItem extends IPageResult {
    items: CustomerListItem[];
    searchOptions: PageSearchOptions;
}

export class CustomerListItem implements ICustomerListItem {
    id!: number;
    statusId!: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    organizationId!: number;
    roomNumber?: string | undefined;
    organizationName?: string | undefined;
    customerAreas?: CustomerAreaItem[] | undefined;

    constructor(data?: ICustomerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.organizationId = _data["organizationId"];
            this.roomNumber = _data["roomNumber"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["customerAreas"])) {
                this.customerAreas = [] as any;
                for (let item of _data["customerAreas"])
                    this.customerAreas!.push(CustomerAreaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["organizationId"] = this.organizationId;
        data["roomNumber"] = this.roomNumber;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.customerAreas)) {
            data["customerAreas"] = [];
            for (let item of this.customerAreas)
                data["customerAreas"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerListItem {
    id: number;
    statusId: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    organizationId: number;
    roomNumber?: string | undefined;
    organizationName?: string | undefined;
    customerAreas?: CustomerAreaItem[] | undefined;
}

export class PageSearchOptions implements IPageSearchOptions {
    page!: number;
    pageSize!: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;

    constructor(data?: IPageSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.organizationId = _data["organizationId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): PageSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["organizationId"] = this.organizationId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IPageSearchOptions {
    page: number;
    pageSize: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;
}

export class CustomerCreateItem implements ICustomerCreateItem {
    active!: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    organizationId!: number;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaCreateItem[] | undefined;
    extraInfo?: string | undefined;

    constructor(data?: ICustomerCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.roomNumber = _data["roomNumber"];
            if (Array.isArray(_data["customerAreas"])) {
                this.customerAreas = [] as any;
                for (let item of _data["customerAreas"])
                    this.customerAreas!.push(CustomerAreaCreateItem.fromJS(item));
            }
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): CustomerCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["roomNumber"] = this.roomNumber;
        if (Array.isArray(this.customerAreas)) {
            data["customerAreas"] = [];
            for (let item of this.customerAreas)
                data["customerAreas"].push(item.toJSON());
        }
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface ICustomerCreateItem {
    active: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    organizationId: number;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaCreateItem[] | undefined;
    extraInfo?: string | undefined;
}

export class CustomerAreaCreateItem implements ICustomerAreaCreateItem {
    areaId!: number;

    constructor(data?: ICustomerAreaCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): CustomerAreaCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAreaCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface ICustomerAreaCreateItem {
    areaId: number;
}

export class CustomerUpdateItem implements ICustomerUpdateItem {
    id!: number;
    statusId!: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaCreateItem[] | undefined;
    extraInfo?: string | undefined;

    constructor(data?: ICustomerUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.description = _data["description"];
            this.roomNumber = _data["roomNumber"];
            if (Array.isArray(_data["customerAreas"])) {
                this.customerAreas = [] as any;
                for (let item of _data["customerAreas"])
                    this.customerAreas!.push(CustomerAreaCreateItem.fromJS(item));
            }
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): CustomerUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["description"] = this.description;
        data["roomNumber"] = this.roomNumber;
        if (Array.isArray(this.customerAreas)) {
            data["customerAreas"] = [];
            for (let item of this.customerAreas)
                data["customerAreas"].push(item.toJSON());
        }
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface ICustomerUpdateItem {
    id: number;
    statusId: CustomerStatusEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    roomNumber?: string | undefined;
    customerAreas?: CustomerAreaCreateItem[] | undefined;
    extraInfo?: string | undefined;
}

export class CustomerPausedPeriodCreateItem implements ICustomerPausedPeriodCreateItem {
    customerId!: number;
    comment?: string | undefined;
    startDateTime!: Date;
    endDateTime?: Date | undefined;

    constructor(data?: ICustomerPausedPeriodCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerPausedPeriodCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPausedPeriodCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerPausedPeriodCreateItem {
    customerId: number;
    comment?: string | undefined;
    startDateTime: Date;
    endDateTime?: Date | undefined;
}

export class DelegationItem implements IDelegationItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId!: number;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;

    constructor(data?: IDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.delegationCategoryId = _data["delegationCategoryId"];
            this.delegationCategoryTitle = _data["delegationCategoryTitle"];
        }
    }

    static fromJS(data: any): DelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["delegationCategoryId"] = this.delegationCategoryId;
        data["delegationCategoryTitle"] = this.delegationCategoryTitle;
        return data;
    }
}

export interface IDelegationItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId: number;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;
}

export class DelegationCreateItem implements IDelegationCreateItem {
    organizationId!: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;

    constructor(data?: IDelegationCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.delegationCategoryId = _data["delegationCategoryId"];
        }
    }

    static fromJS(data: any): DelegationCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["delegationCategoryId"] = this.delegationCategoryId;
        return data;
    }
}

export interface IDelegationCreateItem {
    organizationId: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;
}

export class DelegationListItem implements IDelegationListItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId!: number;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;

    constructor(data?: IDelegationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.delegationCategoryId = _data["delegationCategoryId"];
            this.delegationCategoryTitle = _data["delegationCategoryTitle"];
        }
    }

    static fromJS(data: any): DelegationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["delegationCategoryId"] = this.delegationCategoryId;
        data["delegationCategoryTitle"] = this.delegationCategoryTitle;
        return data;
    }
}

export interface IDelegationListItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId: number;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;
}

export class ExpiringDelegationItem implements IExpiringDelegationItem {
    delegationTitle?: string | undefined;
    userFullName?: string | undefined;
    delegatedForCustomerFullName?: string | undefined;
    delegatedForAreaName?: string | undefined;
    delegatedByUserFullName?: string | undefined;
    delegationStartTime!: Date;
    delegationEndTime!: Date;
    id!: number;

    constructor(data?: IExpiringDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegationTitle = _data["delegationTitle"];
            this.userFullName = _data["userFullName"];
            this.delegatedForCustomerFullName = _data["delegatedForCustomerFullName"];
            this.delegatedForAreaName = _data["delegatedForAreaName"];
            this.delegatedByUserFullName = _data["delegatedByUserFullName"];
            this.delegationStartTime = _data["delegationStartTime"] ? new Date(_data["delegationStartTime"].toString()) : <any>undefined;
            this.delegationEndTime = _data["delegationEndTime"] ? new Date(_data["delegationEndTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExpiringDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegationTitle"] = this.delegationTitle;
        data["userFullName"] = this.userFullName;
        data["delegatedForCustomerFullName"] = this.delegatedForCustomerFullName;
        data["delegatedForAreaName"] = this.delegatedForAreaName;
        data["delegatedByUserFullName"] = this.delegatedByUserFullName;
        data["delegationStartTime"] = this.delegationStartTime ? this.delegationStartTime.toISOString() : <any>undefined;
        data["delegationEndTime"] = this.delegationEndTime ? this.delegationEndTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IExpiringDelegationItem {
    delegationTitle?: string | undefined;
    userFullName?: string | undefined;
    delegatedForCustomerFullName?: string | undefined;
    delegatedForAreaName?: string | undefined;
    delegatedByUserFullName?: string | undefined;
    delegationStartTime: Date;
    delegationEndTime: Date;
    id: number;
}

export class DelegationUpdateItem implements IDelegationUpdateItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;

    constructor(data?: IDelegationUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.delegationCategoryId = _data["delegationCategoryId"];
        }
    }

    static fromJS(data: any): DelegationUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["delegationCategoryId"] = this.delegationCategoryId;
        return data;
    }
}

export interface IDelegationUpdateItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;
}

export class DelegationCategoryListItem implements IDelegationCategoryListItem {
    id!: number;
    title?: string | undefined;

    constructor(data?: IDelegationCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DelegationCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IDelegationCategoryListItem {
    id: number;
    title?: string | undefined;
}

export class DelegationAvailableItem implements IDelegationAvailableItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;

    constructor(data?: IDelegationAvailableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.delegationCategoryId = _data["delegationCategoryId"];
            this.delegationCategoryTitle = _data["delegationCategoryTitle"];
        }
    }

    static fromJS(data: any): DelegationAvailableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationAvailableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["delegationCategoryId"] = this.delegationCategoryId;
        data["delegationCategoryTitle"] = this.delegationCategoryTitle;
        return data;
    }
}

export interface IDelegationAvailableItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    delegationCategoryId?: number | undefined;
    delegationCategoryTitle?: string | undefined;
}

export class UserDelegationAvailablePlacementsItem implements IUserDelegationAvailablePlacementsItem {
    customers?: CustomerAvailableItem[] | undefined;
    areas?: AreaItem[] | undefined;
    users?: UserAvailableItem[] | undefined;

    constructor(data?: IUserDelegationAvailablePlacementsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerAvailableItem.fromJS(item));
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaItem.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserAvailableItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDelegationAvailablePlacementsItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationAvailablePlacementsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDelegationAvailablePlacementsItem {
    customers?: CustomerAvailableItem[] | undefined;
    areas?: AreaItem[] | undefined;
    users?: UserAvailableItem[] | undefined;
}

export class CustomerAvailableItem implements ICustomerAvailableItem {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICustomerAvailableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CustomerAvailableItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAvailableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICustomerAvailableItem {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class UserAvailableItem implements IUserAvailableItem {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IUserAvailableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserAvailableItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvailableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserAvailableItem {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class DelegationCategoryItem implements IDelegationCategoryItem {
    id!: number;
    title?: string | undefined;
    organizationId!: number;

    constructor(data?: IDelegationCategoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): DelegationCategoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationCategoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IDelegationCategoryItem {
    id: number;
    title?: string | undefined;
    organizationId: number;
}

export class DelegationCategoryCreateItem implements IDelegationCategoryCreateItem {
    title?: string | undefined;
    organizationId!: number;

    constructor(data?: IDelegationCategoryCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): DelegationCategoryCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationCategoryCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IDelegationCategoryCreateItem {
    title?: string | undefined;
    organizationId: number;
}

export class DelegationCategoryUpdateItem implements IDelegationCategoryUpdateItem {
    id!: number;
    title?: string | undefined;

    constructor(data?: IDelegationCategoryUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DelegationCategoryUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationCategoryUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IDelegationCategoryUpdateItem {
    id: number;
    title?: string | undefined;
}

export class PlannedActivityRequiredDelegationsItem implements IPlannedActivityRequiredDelegationsItem {
    plannedActivityRowId!: number;
    delegationItems?: RequiredDelegationItem[] | undefined;

    constructor(data?: IPlannedActivityRequiredDelegationsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedActivityRowId = _data["plannedActivityRowId"];
            if (Array.isArray(_data["delegationItems"])) {
                this.delegationItems = [] as any;
                for (let item of _data["delegationItems"])
                    this.delegationItems!.push(RequiredDelegationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlannedActivityRequiredDelegationsItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRequiredDelegationsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedActivityRowId"] = this.plannedActivityRowId;
        if (Array.isArray(this.delegationItems)) {
            data["delegationItems"] = [];
            for (let item of this.delegationItems)
                data["delegationItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlannedActivityRequiredDelegationsItem {
    plannedActivityRowId: number;
    delegationItems?: RequiredDelegationItem[] | undefined;
}

export class RequiredDelegationItem implements IRequiredDelegationItem {
    id!: number;
    title?: string | undefined;

    constructor(data?: IRequiredDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): RequiredDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IRequiredDelegationItem {
    id: number;
    title?: string | undefined;
}

export class UnitItem implements IUnitItem {
    id!: number;
    organizationId!: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId!: UnitTypeEnum;
    unitType?: UnitType | undefined;

    constructor(data?: IUnitItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.title = _data["title"];
            this.abbreviation = _data["abbreviation"];
            this.unitTypeId = _data["unitTypeId"];
            this.unitType = _data["unitType"] ? UnitType.fromJS(_data["unitType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UnitItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnitItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["title"] = this.title;
        data["abbreviation"] = this.abbreviation;
        data["unitTypeId"] = this.unitTypeId;
        data["unitType"] = this.unitType ? this.unitType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUnitItem {
    id: number;
    organizationId: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId: UnitTypeEnum;
    unitType?: UnitType | undefined;
}

export class UnitType implements IUnitType {
    id!: UnitTypeEnum;
    value!: string;

    constructor(data?: IUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UnitType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IUnitType {
    id: UnitTypeEnum;
    value: string;
}

export class UnitCreateItem implements IUnitCreateItem {
    organizationId!: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId!: UnitTypeEnum;

    constructor(data?: IUnitCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.title = _data["title"];
            this.abbreviation = _data["abbreviation"];
            this.unitTypeId = _data["unitTypeId"];
        }
    }

    static fromJS(data: any): UnitCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnitCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["title"] = this.title;
        data["abbreviation"] = this.abbreviation;
        data["unitTypeId"] = this.unitTypeId;
        return data;
    }
}

export interface IUnitCreateItem {
    organizationId: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId: UnitTypeEnum;
}

export class UnitUpdateItem implements IUnitUpdateItem {
    id!: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId!: UnitTypeEnum;

    constructor(data?: IUnitUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.abbreviation = _data["abbreviation"];
            this.unitTypeId = _data["unitTypeId"];
        }
    }

    static fromJS(data: any): UnitUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnitUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["abbreviation"] = this.abbreviation;
        data["unitTypeId"] = this.unitTypeId;
        return data;
    }
}

export interface IUnitUpdateItem {
    id: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
    unitTypeId: UnitTypeEnum;
}

export class UnitListItem implements IUnitListItem {
    id!: number;
    organizationId!: number;
    title?: string | undefined;
    abbreviation?: string | undefined;

    constructor(data?: IUnitListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.title = _data["title"];
            this.abbreviation = _data["abbreviation"];
        }
    }

    static fromJS(data: any): UnitListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnitListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["title"] = this.title;
        data["abbreviation"] = this.abbreviation;
        return data;
    }
}

export interface IUnitListItem {
    id: number;
    organizationId: number;
    title?: string | undefined;
    abbreviation?: string | undefined;
}

export class OrganizationPlannedActivityStatusItem implements IOrganizationPlannedActivityStatusItem {
    id!: number;
    organizationId!: number;
    plannedActivityStatusId?: PlannedActivityStatusEnum | undefined;
    plannedActivityStatus?: PlannedActivityStatusItem | undefined;
    organizationTitle?: string | undefined;
    disable!: boolean;

    constructor(data?: IOrganizationPlannedActivityStatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedActivityStatus = _data["plannedActivityStatus"] ? PlannedActivityStatusItem.fromJS(_data["plannedActivityStatus"]) : <any>undefined;
            this.organizationTitle = _data["organizationTitle"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): OrganizationPlannedActivityStatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPlannedActivityStatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedActivityStatus"] = this.plannedActivityStatus ? this.plannedActivityStatus.toJSON() : <any>undefined;
        data["organizationTitle"] = this.organizationTitle;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IOrganizationPlannedActivityStatusItem {
    id: number;
    organizationId: number;
    plannedActivityStatusId?: PlannedActivityStatusEnum | undefined;
    plannedActivityStatus?: PlannedActivityStatusItem | undefined;
    organizationTitle?: string | undefined;
    disable: boolean;
}

export class PlannedActivityStatusItem implements IPlannedActivityStatusItem {
    id!: PlannedActivityStatusEnum;
    value?: string | undefined;
    partial!: boolean;

    constructor(data?: IPlannedActivityStatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.partial = _data["partial"];
        }
    }

    static fromJS(data: any): PlannedActivityStatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityStatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["partial"] = this.partial;
        return data;
    }
}

export interface IPlannedActivityStatusItem {
    id: PlannedActivityStatusEnum;
    value?: string | undefined;
    partial: boolean;
}

export class OrganizationPlannedActivityStatusCreateItem implements IOrganizationPlannedActivityStatusCreateItem {
    organizationId!: number;
    plannedActivityStatusId?: PlannedActivityStatusEnum | undefined;
    organizationTitle?: string | undefined;
    disable!: boolean;

    constructor(data?: IOrganizationPlannedActivityStatusCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.organizationTitle = _data["organizationTitle"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): OrganizationPlannedActivityStatusCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPlannedActivityStatusCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["organizationTitle"] = this.organizationTitle;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IOrganizationPlannedActivityStatusCreateItem {
    organizationId: number;
    plannedActivityStatusId?: PlannedActivityStatusEnum | undefined;
    organizationTitle?: string | undefined;
    disable: boolean;
}

export class OrganizationPlannedActivityStatusUpdateItem implements IOrganizationPlannedActivityStatusUpdateItem {
    id!: number;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    organizationTitle?: string | undefined;
    disable!: boolean;

    constructor(data?: IOrganizationPlannedActivityStatusUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.organizationTitle = _data["organizationTitle"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): OrganizationPlannedActivityStatusUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPlannedActivityStatusUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["organizationTitle"] = this.organizationTitle;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IOrganizationPlannedActivityStatusUpdateItem {
    id: number;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    organizationTitle?: string | undefined;
    disable: boolean;
}

export class OrganizationSigningStatusesItem implements IOrganizationSigningStatusesItem {
    organizationPlannedActivityStatusItems?: OrganizationPlannedActivityStatusItem[] | undefined;
    plannedActivityStatusItems?: PlannedActivityStatusItem[] | undefined;

    constructor(data?: IOrganizationSigningStatusesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationPlannedActivityStatusItems"])) {
                this.organizationPlannedActivityStatusItems = [] as any;
                for (let item of _data["organizationPlannedActivityStatusItems"])
                    this.organizationPlannedActivityStatusItems!.push(OrganizationPlannedActivityStatusItem.fromJS(item));
            }
            if (Array.isArray(_data["plannedActivityStatusItems"])) {
                this.plannedActivityStatusItems = [] as any;
                for (let item of _data["plannedActivityStatusItems"])
                    this.plannedActivityStatusItems!.push(PlannedActivityStatusItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationSigningStatusesItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSigningStatusesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationPlannedActivityStatusItems)) {
            data["organizationPlannedActivityStatusItems"] = [];
            for (let item of this.organizationPlannedActivityStatusItems)
                data["organizationPlannedActivityStatusItems"].push(item.toJSON());
        }
        if (Array.isArray(this.plannedActivityStatusItems)) {
            data["plannedActivityStatusItems"] = [];
            for (let item of this.plannedActivityStatusItems)
                data["plannedActivityStatusItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationSigningStatusesItem {
    organizationPlannedActivityStatusItems?: OrganizationPlannedActivityStatusItem[] | undefined;
    plannedActivityStatusItems?: PlannedActivityStatusItem[] | undefined;
}

export class KioskRequestItem implements IKioskRequestItem {
    comment?: string | undefined;
    name!: string;
    mainArea!: KioskAreaCreateItem;
    allowNavigateToPlanningPage!: boolean;
    allowUseMultiSigning!: boolean;
    useManualSessionExpiration!: boolean;
    manualSessionExpirationMinutes!: number;

    constructor(data?: IKioskRequestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mainArea = new KioskAreaCreateItem();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.name = _data["name"];
            this.mainArea = _data["mainArea"] ? KioskAreaCreateItem.fromJS(_data["mainArea"]) : new KioskAreaCreateItem();
            this.allowNavigateToPlanningPage = _data["allowNavigateToPlanningPage"];
            this.allowUseMultiSigning = _data["allowUseMultiSigning"];
            this.useManualSessionExpiration = _data["useManualSessionExpiration"];
            this.manualSessionExpirationMinutes = _data["manualSessionExpirationMinutes"];
        }
    }

    static fromJS(data: any): KioskRequestItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskRequestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["name"] = this.name;
        data["mainArea"] = this.mainArea ? this.mainArea.toJSON() : <any>undefined;
        data["allowNavigateToPlanningPage"] = this.allowNavigateToPlanningPage;
        data["allowUseMultiSigning"] = this.allowUseMultiSigning;
        data["useManualSessionExpiration"] = this.useManualSessionExpiration;
        data["manualSessionExpirationMinutes"] = this.manualSessionExpirationMinutes;
        return data;
    }
}

export interface IKioskRequestItem {
    comment?: string | undefined;
    name: string;
    mainArea: KioskAreaCreateItem;
    allowNavigateToPlanningPage: boolean;
    allowUseMultiSigning: boolean;
    useManualSessionExpiration: boolean;
    manualSessionExpirationMinutes: number;
}

export class KioskAreaCreateItem implements IKioskAreaCreateItem {
    kioskId?: number | undefined;
    areaId!: number;
    kioskMainArea!: boolean;

    constructor(data?: IKioskAreaCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kioskId = _data["kioskId"];
            this.areaId = _data["areaId"];
            this.kioskMainArea = _data["kioskMainArea"];
        }
    }

    static fromJS(data: any): KioskAreaCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskAreaCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kioskId"] = this.kioskId;
        data["areaId"] = this.areaId;
        data["kioskMainArea"] = this.kioskMainArea;
        return data;
    }
}

export interface IKioskAreaCreateItem {
    kioskId?: number | undefined;
    areaId: number;
    kioskMainArea: boolean;
}

export class KioskListItem implements IKioskListItem {
    id!: number;
    deviceGuid?: string | undefined;
    kioskName?: string | undefined;
    comment?: string | undefined;
    kioskStatusId!: KioskStatusEnum;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    createdBy?: string | undefined;
    createdOn!: Date;

    constructor(data?: IKioskListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceGuid = _data["deviceGuid"];
            this.kioskName = _data["kioskName"];
            this.comment = _data["comment"];
            this.kioskStatusId = _data["kioskStatusId"];
            this.nightFromHour = _data["nightFromHour"];
            this.nightFromMinute = _data["nightFromMinute"];
            this.nightToHour = _data["nightToHour"];
            this.nightToMinute = _data["nightToMinute"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KioskListItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceGuid"] = this.deviceGuid;
        data["kioskName"] = this.kioskName;
        data["comment"] = this.comment;
        data["kioskStatusId"] = this.kioskStatusId;
        data["nightFromHour"] = this.nightFromHour;
        data["nightFromMinute"] = this.nightFromMinute;
        data["nightToHour"] = this.nightToHour;
        data["nightToMinute"] = this.nightToMinute;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IKioskListItem {
    id: number;
    deviceGuid?: string | undefined;
    kioskName?: string | undefined;
    comment?: string | undefined;
    kioskStatusId: KioskStatusEnum;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    createdBy?: string | undefined;
    createdOn: Date;
}

export enum KioskStatusEnum {
    Requsted = "Requsted",
    Approved = "Approved",
    Declined = "Declined",
    Revoked = "Revoked",
}

export class KioskItem implements IKioskItem {
    id!: number;
    kioskName?: string | undefined;
    comment?: string | undefined;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    kioskStatusId!: KioskStatusEnum;
    requestingDeviceIP?: string | undefined;
    approvedBy?: UserListItem | undefined;
    kioskAreas?: KioskAreaItem[] | undefined;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;
    kioskRequestUser?: UserItem | undefined;
    createdBy?: string | undefined;
    createdOn!: Date;

    constructor(data?: IKioskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kioskName = _data["kioskName"];
            this.comment = _data["comment"];
            this.nightFromHour = _data["nightFromHour"];
            this.nightFromMinute = _data["nightFromMinute"];
            this.nightToHour = _data["nightToHour"];
            this.nightToMinute = _data["nightToMinute"];
            this.kioskStatusId = _data["kioskStatusId"];
            this.requestingDeviceIP = _data["requestingDeviceIP"];
            this.approvedBy = _data["approvedBy"] ? UserListItem.fromJS(_data["approvedBy"]) : <any>undefined;
            if (Array.isArray(_data["kioskAreas"])) {
                this.kioskAreas = [] as any;
                for (let item of _data["kioskAreas"])
                    this.kioskAreas!.push(KioskAreaItem.fromJS(item));
            }
            if (Array.isArray(_data["timeBasedRouteContainers"])) {
                this.timeBasedRouteContainers = [] as any;
                for (let item of _data["timeBasedRouteContainers"])
                    this.timeBasedRouteContainers!.push(TimeBasedRouteContainerItem.fromJS(item));
            }
            this.kioskRequestUser = _data["kioskRequestUser"] ? UserItem.fromJS(_data["kioskRequestUser"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KioskItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kioskName"] = this.kioskName;
        data["comment"] = this.comment;
        data["nightFromHour"] = this.nightFromHour;
        data["nightFromMinute"] = this.nightFromMinute;
        data["nightToHour"] = this.nightToHour;
        data["nightToMinute"] = this.nightToMinute;
        data["kioskStatusId"] = this.kioskStatusId;
        data["requestingDeviceIP"] = this.requestingDeviceIP;
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : <any>undefined;
        if (Array.isArray(this.kioskAreas)) {
            data["kioskAreas"] = [];
            for (let item of this.kioskAreas)
                data["kioskAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.timeBasedRouteContainers)) {
            data["timeBasedRouteContainers"] = [];
            for (let item of this.timeBasedRouteContainers)
                data["timeBasedRouteContainers"].push(item.toJSON());
        }
        data["kioskRequestUser"] = this.kioskRequestUser ? this.kioskRequestUser.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IKioskItem {
    id: number;
    kioskName?: string | undefined;
    comment?: string | undefined;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    kioskStatusId: KioskStatusEnum;
    requestingDeviceIP?: string | undefined;
    approvedBy?: UserListItem | undefined;
    kioskAreas?: KioskAreaItem[] | undefined;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;
    kioskRequestUser?: UserItem | undefined;
    createdBy?: string | undefined;
    createdOn: Date;
}

export class KioskAreaItem implements IKioskAreaItem {
    id!: number;
    kioskId!: number;
    areaId!: number;
    kioskMainArea!: boolean;
    area_Name?: string | undefined;
    area_Routes?: RouteKioskTimeBasedPlanningItem[] | undefined;

    constructor(data?: IKioskAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kioskId = _data["kioskId"];
            this.areaId = _data["areaId"];
            this.kioskMainArea = _data["kioskMainArea"];
            this.area_Name = _data["area_Name"];
            if (Array.isArray(_data["area_Routes"])) {
                this.area_Routes = [] as any;
                for (let item of _data["area_Routes"])
                    this.area_Routes!.push(RouteKioskTimeBasedPlanningItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KioskAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kioskId"] = this.kioskId;
        data["areaId"] = this.areaId;
        data["kioskMainArea"] = this.kioskMainArea;
        data["area_Name"] = this.area_Name;
        if (Array.isArray(this.area_Routes)) {
            data["area_Routes"] = [];
            for (let item of this.area_Routes)
                data["area_Routes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKioskAreaItem {
    id: number;
    kioskId: number;
    areaId: number;
    kioskMainArea: boolean;
    area_Name?: string | undefined;
    area_Routes?: RouteKioskTimeBasedPlanningItem[] | undefined;
}

export class RouteKioskTimeBasedPlanningItem implements IRouteKioskTimeBasedPlanningItem {
    id!: number;
    name?: string | undefined;

    constructor(data?: IRouteKioskTimeBasedPlanningItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RouteKioskTimeBasedPlanningItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteKioskTimeBasedPlanningItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRouteKioskTimeBasedPlanningItem {
    id: number;
    name?: string | undefined;
}

export class TimeBasedRouteContainerItem implements ITimeBasedRouteContainerItem {
    id!: number;
    name!: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    kioskId!: number;
    timeBasedRoutes?: TimeBasedRouteItem[] | undefined;

    constructor(data?: ITimeBasedRouteContainerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.kioskId = _data["kioskId"];
            if (Array.isArray(_data["timeBasedRoutes"])) {
                this.timeBasedRoutes = [] as any;
                for (let item of _data["timeBasedRoutes"])
                    this.timeBasedRoutes!.push(TimeBasedRouteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeBasedRouteContainerItem {
        data = typeof data === 'object' ? data : {};
        let result = new TimeBasedRouteContainerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["kioskId"] = this.kioskId;
        if (Array.isArray(this.timeBasedRoutes)) {
            data["timeBasedRoutes"] = [];
            for (let item of this.timeBasedRoutes)
                data["timeBasedRoutes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeBasedRouteContainerItem {
    id: number;
    name: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    kioskId: number;
    timeBasedRoutes?: TimeBasedRouteItem[] | undefined;
}

export class TimeBasedRouteItem implements ITimeBasedRouteItem {
    id!: number;
    timeBasedRouteContainerId!: number;
    routeId!: number;
    area_Id!: number;

    constructor(data?: ITimeBasedRouteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeBasedRouteContainerId = _data["timeBasedRouteContainerId"];
            this.routeId = _data["routeId"];
            this.area_Id = _data["area_Id"];
        }
    }

    static fromJS(data: any): TimeBasedRouteItem {
        data = typeof data === 'object' ? data : {};
        let result = new TimeBasedRouteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeBasedRouteContainerId"] = this.timeBasedRouteContainerId;
        data["routeId"] = this.routeId;
        data["area_Id"] = this.area_Id;
        return data;
    }
}

export interface ITimeBasedRouteItem {
    id: number;
    timeBasedRouteContainerId: number;
    routeId: number;
    area_Id: number;
}

export class UserItem implements IUserItem {
    id!: number;
    active!: boolean;
    userType!: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    isAllowedToCommentOnSigning!: boolean;
    createdById?: number | undefined;
    userAreas?: UserAreaItem[] | undefined;
    userDelegations?: UserDelegationItem[] | undefined;
    createdByFullName?: string | undefined;
    createdOn!: Date;
    modifiedById?: number | undefined;
    modifiedByFullName?: string | undefined;
    modifiedOn!: Date;
    hasSavedPinCode!: boolean;
    expectedEmailDomain?: string | undefined;
    expiringDelegationsWeeksHorizon!: number;
    useDelegations!: boolean;
    allowSigningWhenDelegationsIsNotFulfilled!: boolean;
    hasExpiringDelegations!: boolean;
    expiringDelegations?: UserExpiringDelegationItem[] | undefined;
    forceTemplateActivity!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;
    allowStartedActivityStatus!: boolean;
    openAssignedRoute!: boolean;
    futureActivityTimeInHours?: number | undefined;
    showExactTimeOnKioskActivity!: boolean;
    showCustomerMode!: boolean;
    allowAreaTemplateActivities!: boolean;
    organizationUsesIpFilterOnDevice!: boolean;
    extraInfo?: string | undefined;

    constructor(data?: IUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userType = _data["userType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.isAllowedToCommentOnSigning = _data["isAllowedToCommentOnSigning"];
            this.createdById = _data["createdById"];
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaItem.fromJS(item));
            }
            if (Array.isArray(_data["userDelegations"])) {
                this.userDelegations = [] as any;
                for (let item of _data["userDelegations"])
                    this.userDelegations!.push(UserDelegationItem.fromJS(item));
            }
            this.createdByFullName = _data["createdByFullName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedByFullName = _data["modifiedByFullName"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.hasSavedPinCode = _data["hasSavedPinCode"];
            this.expectedEmailDomain = _data["expectedEmailDomain"];
            this.expiringDelegationsWeeksHorizon = _data["expiringDelegationsWeeksHorizon"];
            this.useDelegations = _data["useDelegations"];
            this.allowSigningWhenDelegationsIsNotFulfilled = _data["allowSigningWhenDelegationsIsNotFulfilled"];
            this.hasExpiringDelegations = _data["hasExpiringDelegations"];
            if (Array.isArray(_data["expiringDelegations"])) {
                this.expiringDelegations = [] as any;
                for (let item of _data["expiringDelegations"])
                    this.expiringDelegations!.push(UserExpiringDelegationItem.fromJS(item));
            }
            this.forceTemplateActivity = _data["forceTemplateActivity"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
            this.allowStartedActivityStatus = _data["allowStartedActivityStatus"];
            this.openAssignedRoute = _data["openAssignedRoute"];
            this.futureActivityTimeInHours = _data["futureActivityTimeInHours"];
            this.showExactTimeOnKioskActivity = _data["showExactTimeOnKioskActivity"];
            this.showCustomerMode = _data["showCustomerMode"];
            this.allowAreaTemplateActivities = _data["allowAreaTemplateActivities"];
            this.organizationUsesIpFilterOnDevice = _data["organizationUsesIpFilterOnDevice"];
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): UserItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userType"] = this.userType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["isAllowedToCommentOnSigning"] = this.isAllowedToCommentOnSigning;
        data["createdById"] = this.createdById;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.userDelegations)) {
            data["userDelegations"] = [];
            for (let item of this.userDelegations)
                data["userDelegations"].push(item.toJSON());
        }
        data["createdByFullName"] = this.createdByFullName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedByFullName"] = this.modifiedByFullName;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["hasSavedPinCode"] = this.hasSavedPinCode;
        data["expectedEmailDomain"] = this.expectedEmailDomain;
        data["expiringDelegationsWeeksHorizon"] = this.expiringDelegationsWeeksHorizon;
        data["useDelegations"] = this.useDelegations;
        data["allowSigningWhenDelegationsIsNotFulfilled"] = this.allowSigningWhenDelegationsIsNotFulfilled;
        data["hasExpiringDelegations"] = this.hasExpiringDelegations;
        if (Array.isArray(this.expiringDelegations)) {
            data["expiringDelegations"] = [];
            for (let item of this.expiringDelegations)
                data["expiringDelegations"].push(item.toJSON());
        }
        data["forceTemplateActivity"] = this.forceTemplateActivity;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        data["allowStartedActivityStatus"] = this.allowStartedActivityStatus;
        data["openAssignedRoute"] = this.openAssignedRoute;
        data["futureActivityTimeInHours"] = this.futureActivityTimeInHours;
        data["showExactTimeOnKioskActivity"] = this.showExactTimeOnKioskActivity;
        data["showCustomerMode"] = this.showCustomerMode;
        data["allowAreaTemplateActivities"] = this.allowAreaTemplateActivities;
        data["organizationUsesIpFilterOnDevice"] = this.organizationUsesIpFilterOnDevice;
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface IUserItem {
    id: number;
    active: boolean;
    userType: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    isAllowedToCommentOnSigning: boolean;
    createdById?: number | undefined;
    userAreas?: UserAreaItem[] | undefined;
    userDelegations?: UserDelegationItem[] | undefined;
    createdByFullName?: string | undefined;
    createdOn: Date;
    modifiedById?: number | undefined;
    modifiedByFullName?: string | undefined;
    modifiedOn: Date;
    hasSavedPinCode: boolean;
    expectedEmailDomain?: string | undefined;
    expiringDelegationsWeeksHorizon: number;
    useDelegations: boolean;
    allowSigningWhenDelegationsIsNotFulfilled: boolean;
    hasExpiringDelegations: boolean;
    expiringDelegations?: UserExpiringDelegationItem[] | undefined;
    forceTemplateActivity: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
    allowStartedActivityStatus: boolean;
    openAssignedRoute: boolean;
    futureActivityTimeInHours?: number | undefined;
    showExactTimeOnKioskActivity: boolean;
    showCustomerMode: boolean;
    allowAreaTemplateActivities: boolean;
    organizationUsesIpFilterOnDevice: boolean;
    extraInfo?: string | undefined;
}

export class UserDelegationItem implements IUserDelegationItem {
    id!: number;
    delegationId!: number;
    delegationTitle?: string | undefined;
    userId!: number;
    userDelegationPlacements?: UserDelegationPlacementItem[] | undefined;

    constructor(data?: IUserDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegationId = _data["delegationId"];
            this.delegationTitle = _data["delegationTitle"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["userDelegationPlacements"])) {
                this.userDelegationPlacements = [] as any;
                for (let item of _data["userDelegationPlacements"])
                    this.userDelegationPlacements!.push(UserDelegationPlacementItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegationId"] = this.delegationId;
        data["delegationTitle"] = this.delegationTitle;
        data["userId"] = this.userId;
        if (Array.isArray(this.userDelegationPlacements)) {
            data["userDelegationPlacements"] = [];
            for (let item of this.userDelegationPlacements)
                data["userDelegationPlacements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDelegationItem {
    id: number;
    delegationId: number;
    delegationTitle?: string | undefined;
    userId: number;
    userDelegationPlacements?: UserDelegationPlacementItem[] | undefined;
}

export class UserDelegationPlacementItem implements IUserDelegationPlacementItem {
    id!: number;
    active!: boolean;
    description?: string | undefined;
    areaId?: number | undefined;
    areaName?: string | undefined;
    customerId?: number | undefined;
    customerName?: string | undefined;
    delegationStartTime!: Date;
    delegationEndTime!: Date;
    delegatedById!: number;
    delegatedBy?: string | undefined;

    constructor(data?: IUserDelegationPlacementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.delegationStartTime = _data["delegationStartTime"] ? new Date(_data["delegationStartTime"].toString()) : <any>undefined;
            this.delegationEndTime = _data["delegationEndTime"] ? new Date(_data["delegationEndTime"].toString()) : <any>undefined;
            this.delegatedById = _data["delegatedById"];
            this.delegatedBy = _data["delegatedBy"];
        }
    }

    static fromJS(data: any): UserDelegationPlacementItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationPlacementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["delegationStartTime"] = this.delegationStartTime ? this.delegationStartTime.toISOString() : <any>undefined;
        data["delegationEndTime"] = this.delegationEndTime ? this.delegationEndTime.toISOString() : <any>undefined;
        data["delegatedById"] = this.delegatedById;
        data["delegatedBy"] = this.delegatedBy;
        return data;
    }
}

export interface IUserDelegationPlacementItem {
    id: number;
    active: boolean;
    description?: string | undefined;
    areaId?: number | undefined;
    areaName?: string | undefined;
    customerId?: number | undefined;
    customerName?: string | undefined;
    delegationStartTime: Date;
    delegationEndTime: Date;
    delegatedById: number;
    delegatedBy?: string | undefined;
}

export class UserExpiringDelegationItem implements IUserExpiringDelegationItem {
    delegationTitle?: string | undefined;
    delegatedForCustomerFullName?: string | undefined;
    delegatedForAreaName?: string | undefined;
    delegatedByUserFullName?: string | undefined;
    delegationStartTime!: Date;
    delegationEndTime!: Date;
    id!: number;

    constructor(data?: IUserExpiringDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegationTitle = _data["delegationTitle"];
            this.delegatedForCustomerFullName = _data["delegatedForCustomerFullName"];
            this.delegatedForAreaName = _data["delegatedForAreaName"];
            this.delegatedByUserFullName = _data["delegatedByUserFullName"];
            this.delegationStartTime = _data["delegationStartTime"] ? new Date(_data["delegationStartTime"].toString()) : <any>undefined;
            this.delegationEndTime = _data["delegationEndTime"] ? new Date(_data["delegationEndTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserExpiringDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserExpiringDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegationTitle"] = this.delegationTitle;
        data["delegatedForCustomerFullName"] = this.delegatedForCustomerFullName;
        data["delegatedForAreaName"] = this.delegatedForAreaName;
        data["delegatedByUserFullName"] = this.delegatedByUserFullName;
        data["delegationStartTime"] = this.delegationStartTime ? this.delegationStartTime.toISOString() : <any>undefined;
        data["delegationEndTime"] = this.delegationEndTime ? this.delegationEndTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserExpiringDelegationItem {
    delegationTitle?: string | undefined;
    delegatedForCustomerFullName?: string | undefined;
    delegatedForAreaName?: string | undefined;
    delegatedByUserFullName?: string | undefined;
    delegationStartTime: Date;
    delegationEndTime: Date;
    id: number;
}

export class ManageKioskItem implements IManageKioskItem {
    id!: number;
    kioskName?: string | undefined;
    comment?: string | undefined;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    kioskStatusId!: KioskStatusEnum;
    kioskAreas?: KioskAreaCreateItem[] | undefined;
    allowNavigateToPlanningPage!: boolean;
    allowUseMultiSigning!: boolean;
    useManualSessionExpiration!: boolean;
    manualSessionExpirationMinutes!: number;
    showAdditionalAreas!: boolean;
    showAdditionalAreasAllDay!: boolean;
    showAdditionalAreasStartTimeTicks?: number | undefined;
    showAdditionalAreasEndTimeTicks?: number | undefined;

    constructor(data?: IManageKioskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kioskName = _data["kioskName"];
            this.comment = _data["comment"];
            this.nightFromHour = _data["nightFromHour"];
            this.nightFromMinute = _data["nightFromMinute"];
            this.nightToHour = _data["nightToHour"];
            this.nightToMinute = _data["nightToMinute"];
            this.kioskStatusId = _data["kioskStatusId"];
            if (Array.isArray(_data["kioskAreas"])) {
                this.kioskAreas = [] as any;
                for (let item of _data["kioskAreas"])
                    this.kioskAreas!.push(KioskAreaCreateItem.fromJS(item));
            }
            this.allowNavigateToPlanningPage = _data["allowNavigateToPlanningPage"];
            this.allowUseMultiSigning = _data["allowUseMultiSigning"];
            this.useManualSessionExpiration = _data["useManualSessionExpiration"];
            this.manualSessionExpirationMinutes = _data["manualSessionExpirationMinutes"];
            this.showAdditionalAreas = _data["showAdditionalAreas"];
            this.showAdditionalAreasAllDay = _data["showAdditionalAreasAllDay"];
            this.showAdditionalAreasStartTimeTicks = _data["showAdditionalAreasStartTimeTicks"];
            this.showAdditionalAreasEndTimeTicks = _data["showAdditionalAreasEndTimeTicks"];
        }
    }

    static fromJS(data: any): ManageKioskItem {
        data = typeof data === 'object' ? data : {};
        let result = new ManageKioskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kioskName"] = this.kioskName;
        data["comment"] = this.comment;
        data["nightFromHour"] = this.nightFromHour;
        data["nightFromMinute"] = this.nightFromMinute;
        data["nightToHour"] = this.nightToHour;
        data["nightToMinute"] = this.nightToMinute;
        data["kioskStatusId"] = this.kioskStatusId;
        if (Array.isArray(this.kioskAreas)) {
            data["kioskAreas"] = [];
            for (let item of this.kioskAreas)
                data["kioskAreas"].push(item.toJSON());
        }
        data["allowNavigateToPlanningPage"] = this.allowNavigateToPlanningPage;
        data["allowUseMultiSigning"] = this.allowUseMultiSigning;
        data["useManualSessionExpiration"] = this.useManualSessionExpiration;
        data["manualSessionExpirationMinutes"] = this.manualSessionExpirationMinutes;
        data["showAdditionalAreas"] = this.showAdditionalAreas;
        data["showAdditionalAreasAllDay"] = this.showAdditionalAreasAllDay;
        data["showAdditionalAreasStartTimeTicks"] = this.showAdditionalAreasStartTimeTicks;
        data["showAdditionalAreasEndTimeTicks"] = this.showAdditionalAreasEndTimeTicks;
        return data;
    }
}

export interface IManageKioskItem {
    id: number;
    kioskName?: string | undefined;
    comment?: string | undefined;
    nightFromHour?: number | undefined;
    nightFromMinute?: number | undefined;
    nightToHour?: number | undefined;
    nightToMinute?: number | undefined;
    kioskStatusId: KioskStatusEnum;
    kioskAreas?: KioskAreaCreateItem[] | undefined;
    allowNavigateToPlanningPage: boolean;
    allowUseMultiSigning: boolean;
    useManualSessionExpiration: boolean;
    manualSessionExpirationMinutes: number;
    showAdditionalAreas: boolean;
    showAdditionalAreasAllDay: boolean;
    showAdditionalAreasStartTimeTicks?: number | undefined;
    showAdditionalAreasEndTimeTicks?: number | undefined;
}

export class DeactivateKioskItem implements IDeactivateKioskItem {
    id!: number;

    constructor(data?: IDeactivateKioskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeactivateKioskItem {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateKioskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeactivateKioskItem {
    id: number;
}

export class KioskRouteContainerItem implements IKioskRouteContainerItem {
    kioskId!: number;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;
    kioskAreas?: KioskAreaCreateItem[] | undefined;

    constructor(data?: IKioskRouteContainerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kioskId = _data["kioskId"];
            if (Array.isArray(_data["timeBasedRouteContainers"])) {
                this.timeBasedRouteContainers = [] as any;
                for (let item of _data["timeBasedRouteContainers"])
                    this.timeBasedRouteContainers!.push(TimeBasedRouteContainerItem.fromJS(item));
            }
            if (Array.isArray(_data["kioskAreas"])) {
                this.kioskAreas = [] as any;
                for (let item of _data["kioskAreas"])
                    this.kioskAreas!.push(KioskAreaCreateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KioskRouteContainerItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskRouteContainerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kioskId"] = this.kioskId;
        if (Array.isArray(this.timeBasedRouteContainers)) {
            data["timeBasedRouteContainers"] = [];
            for (let item of this.timeBasedRouteContainers)
                data["timeBasedRouteContainers"].push(item.toJSON());
        }
        if (Array.isArray(this.kioskAreas)) {
            data["kioskAreas"] = [];
            for (let item of this.kioskAreas)
                data["kioskAreas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKioskRouteContainerItem {
    kioskId: number;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;
    kioskAreas?: KioskAreaCreateItem[] | undefined;
}

export class KioskRouteContainerCreateUpdateItem implements IKioskRouteContainerCreateUpdateItem {
    kioskId!: number;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;

    constructor(data?: IKioskRouteContainerCreateUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kioskId = _data["kioskId"];
            if (Array.isArray(_data["timeBasedRouteContainers"])) {
                this.timeBasedRouteContainers = [] as any;
                for (let item of _data["timeBasedRouteContainers"])
                    this.timeBasedRouteContainers!.push(TimeBasedRouteContainerItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KioskRouteContainerCreateUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new KioskRouteContainerCreateUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kioskId"] = this.kioskId;
        if (Array.isArray(this.timeBasedRouteContainers)) {
            data["timeBasedRouteContainers"] = [];
            for (let item of this.timeBasedRouteContainers)
                data["timeBasedRouteContainers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKioskRouteContainerCreateUpdateItem {
    kioskId: number;
    timeBasedRouteContainers?: TimeBasedRouteContainerItem[] | undefined;
}

export class RouteKioskDailyActivitiesContainerItem implements IRouteKioskDailyActivitiesContainerItem {
    kioskAreaId!: number;
    kioskAreaName?: string | undefined;
    areaInternalInformation?: string | undefined;
    orgInternalInformation?: string | undefined;
    allowNavigateToPlanningPage!: boolean;
    allowUseMultiSigning!: boolean;
    useManualSessionExpiration!: boolean;
    manualSessionExpirationMinutes!: number;
    showAdditionalAreas!: boolean;
    showAdditionalAreasAllDay!: boolean;
    showAdditionalAreasStartTimeTicks?: number | undefined;
    showAdditionalAreasEndTimeTicks?: number | undefined;
    additionalAreas?: KioskAreaItem[] | undefined;
    items?: RouteKioskDailyActivitiesViewItem[] | undefined;
    lapsedLimitReached!: boolean;
    suppressTimesOnKioskAndPwa!: boolean;

    constructor(data?: IRouteKioskDailyActivitiesContainerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kioskAreaId = _data["kioskAreaId"];
            this.kioskAreaName = _data["kioskAreaName"];
            this.areaInternalInformation = _data["areaInternalInformation"];
            this.orgInternalInformation = _data["orgInternalInformation"];
            this.allowNavigateToPlanningPage = _data["allowNavigateToPlanningPage"];
            this.allowUseMultiSigning = _data["allowUseMultiSigning"];
            this.useManualSessionExpiration = _data["useManualSessionExpiration"];
            this.manualSessionExpirationMinutes = _data["manualSessionExpirationMinutes"];
            this.showAdditionalAreas = _data["showAdditionalAreas"];
            this.showAdditionalAreasAllDay = _data["showAdditionalAreasAllDay"];
            this.showAdditionalAreasStartTimeTicks = _data["showAdditionalAreasStartTimeTicks"];
            this.showAdditionalAreasEndTimeTicks = _data["showAdditionalAreasEndTimeTicks"];
            if (Array.isArray(_data["additionalAreas"])) {
                this.additionalAreas = [] as any;
                for (let item of _data["additionalAreas"])
                    this.additionalAreas!.push(KioskAreaItem.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RouteKioskDailyActivitiesViewItem.fromJS(item));
            }
            this.lapsedLimitReached = _data["lapsedLimitReached"];
            this.suppressTimesOnKioskAndPwa = _data["suppressTimesOnKioskAndPwa"];
        }
    }

    static fromJS(data: any): RouteKioskDailyActivitiesContainerItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteKioskDailyActivitiesContainerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kioskAreaId"] = this.kioskAreaId;
        data["kioskAreaName"] = this.kioskAreaName;
        data["areaInternalInformation"] = this.areaInternalInformation;
        data["orgInternalInformation"] = this.orgInternalInformation;
        data["allowNavigateToPlanningPage"] = this.allowNavigateToPlanningPage;
        data["allowUseMultiSigning"] = this.allowUseMultiSigning;
        data["useManualSessionExpiration"] = this.useManualSessionExpiration;
        data["manualSessionExpirationMinutes"] = this.manualSessionExpirationMinutes;
        data["showAdditionalAreas"] = this.showAdditionalAreas;
        data["showAdditionalAreasAllDay"] = this.showAdditionalAreasAllDay;
        data["showAdditionalAreasStartTimeTicks"] = this.showAdditionalAreasStartTimeTicks;
        data["showAdditionalAreasEndTimeTicks"] = this.showAdditionalAreasEndTimeTicks;
        if (Array.isArray(this.additionalAreas)) {
            data["additionalAreas"] = [];
            for (let item of this.additionalAreas)
                data["additionalAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["lapsedLimitReached"] = this.lapsedLimitReached;
        data["suppressTimesOnKioskAndPwa"] = this.suppressTimesOnKioskAndPwa;
        return data;
    }
}

export interface IRouteKioskDailyActivitiesContainerItem {
    kioskAreaId: number;
    kioskAreaName?: string | undefined;
    areaInternalInformation?: string | undefined;
    orgInternalInformation?: string | undefined;
    allowNavigateToPlanningPage: boolean;
    allowUseMultiSigning: boolean;
    useManualSessionExpiration: boolean;
    manualSessionExpirationMinutes: number;
    showAdditionalAreas: boolean;
    showAdditionalAreasAllDay: boolean;
    showAdditionalAreasStartTimeTicks?: number | undefined;
    showAdditionalAreasEndTimeTicks?: number | undefined;
    additionalAreas?: KioskAreaItem[] | undefined;
    items?: RouteKioskDailyActivitiesViewItem[] | undefined;
    lapsedLimitReached: boolean;
    suppressTimesOnKioskAndPwa: boolean;
}

export class RouteKioskDailyActivitiesViewItem implements IRouteKioskDailyActivitiesViewItem {
    id!: number;
    name!: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId!: number;
    plannedRoutes?: PlannedRouteKioskDailyActivitiesViewItem[] | undefined;
    unplannedContainerRoute!: boolean;
    startDate!: Date;
    endDate?: Date | undefined;

    constructor(data?: IRouteKioskDailyActivitiesViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            if (Array.isArray(_data["plannedRoutes"])) {
                this.plannedRoutes = [] as any;
                for (let item of _data["plannedRoutes"])
                    this.plannedRoutes!.push(PlannedRouteKioskDailyActivitiesViewItem.fromJS(item));
            }
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RouteKioskDailyActivitiesViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteKioskDailyActivitiesViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        if (Array.isArray(this.plannedRoutes)) {
            data["plannedRoutes"] = [];
            for (let item of this.plannedRoutes)
                data["plannedRoutes"].push(item.toJSON());
        }
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRouteKioskDailyActivitiesViewItem {
    id: number;
    name: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId: number;
    plannedRoutes?: PlannedRouteKioskDailyActivitiesViewItem[] | undefined;
    unplannedContainerRoute: boolean;
    startDate: Date;
    endDate?: Date | undefined;
}

export class PlannedRouteKioskDailyActivitiesViewItem implements IPlannedRouteKioskDailyActivitiesViewItem {
    id!: number;
    routeId!: number;
    plannedActivityRows?: PlannedActivityRowKioskDailyViewItem[] | undefined;
    calendarDay!: Date;

    constructor(data?: IPlannedRouteKioskDailyActivitiesViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["plannedActivityRows"])) {
                this.plannedActivityRows = [] as any;
                for (let item of _data["plannedActivityRows"])
                    this.plannedActivityRows!.push(PlannedActivityRowKioskDailyViewItem.fromJS(item));
            }
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedRouteKioskDailyActivitiesViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRouteKioskDailyActivitiesViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeId"] = this.routeId;
        if (Array.isArray(this.plannedActivityRows)) {
            data["plannedActivityRows"] = [];
            for (let item of this.plannedActivityRows)
                data["plannedActivityRows"].push(item.toJSON());
        }
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedRouteKioskDailyActivitiesViewItem {
    id: number;
    routeId: number;
    plannedActivityRows?: PlannedActivityRowKioskDailyViewItem[] | undefined;
    calendarDay: Date;
}

export class PlannedActivityRowKioskDailyViewItem implements IPlannedActivityRowKioskDailyViewItem {
    id!: number;
    activityRowId!: number;
    comment?: string | undefined;
    description?: string | undefined;
    startTime!: Date;
    endTime!: Date;
    activity_AlertFromStartInMinutes!: number;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedRouteId!: number;
    activityColor?: string | undefined;
    areaName?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    activityName?: string | undefined;
    lastSignedById?: number | undefined;
    lastSignedByFirstName?: string | undefined;
    lastSignedByLastName?: string | undefined;
    lastSignedOn?: Date | undefined;
    activity_ShowColorOnDevice!: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations!: boolean;
    activity_SeverityLevelId!: SeverityLevelEnum;
    activity_RecurranceId!: RecurrenceEnum;
    useParticipantList!: boolean;
    unitTypeId?: number | undefined;

    constructor(data?: IPlannedActivityRowKioskDailyViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.activity_AlertFromStartInMinutes = _data["activity_AlertFromStartInMinutes"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.activityColor = _data["activityColor"];
            this.areaName = _data["areaName"];
            this.ownerCustomerFirstName = _data["ownerCustomerFirstName"];
            this.ownerCustomerLastName = _data["ownerCustomerLastName"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerCustomerRoomNumber = _data["ownerCustomerRoomNumber"];
            this.activityName = _data["activityName"];
            this.lastSignedById = _data["lastSignedById"];
            this.lastSignedByFirstName = _data["lastSignedByFirstName"];
            this.lastSignedByLastName = _data["lastSignedByLastName"];
            this.lastSignedOn = _data["lastSignedOn"] ? new Date(_data["lastSignedOn"].toString()) : <any>undefined;
            this.activity_ShowColorOnDevice = _data["activity_ShowColorOnDevice"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.hasUnfulfilledDelegations = _data["hasUnfulfilledDelegations"];
            this.activity_SeverityLevelId = _data["activity_SeverityLevelId"];
            this.activity_RecurranceId = _data["activity_RecurranceId"];
            this.useParticipantList = _data["useParticipantList"];
            this.unitTypeId = _data["unitTypeId"];
        }
    }

    static fromJS(data: any): PlannedActivityRowKioskDailyViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowKioskDailyViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["activity_AlertFromStartInMinutes"] = this.activity_AlertFromStartInMinutes;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedRouteId"] = this.plannedRouteId;
        data["activityColor"] = this.activityColor;
        data["areaName"] = this.areaName;
        data["ownerCustomerFirstName"] = this.ownerCustomerFirstName;
        data["ownerCustomerLastName"] = this.ownerCustomerLastName;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerCustomerRoomNumber"] = this.ownerCustomerRoomNumber;
        data["activityName"] = this.activityName;
        data["lastSignedById"] = this.lastSignedById;
        data["lastSignedByFirstName"] = this.lastSignedByFirstName;
        data["lastSignedByLastName"] = this.lastSignedByLastName;
        data["lastSignedOn"] = this.lastSignedOn ? this.lastSignedOn.toISOString() : <any>undefined;
        data["activity_ShowColorOnDevice"] = this.activity_ShowColorOnDevice;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["hasUnfulfilledDelegations"] = this.hasUnfulfilledDelegations;
        data["activity_SeverityLevelId"] = this.activity_SeverityLevelId;
        data["activity_RecurranceId"] = this.activity_RecurranceId;
        data["useParticipantList"] = this.useParticipantList;
        data["unitTypeId"] = this.unitTypeId;
        return data;
    }
}

export interface IPlannedActivityRowKioskDailyViewItem {
    id: number;
    activityRowId: number;
    comment?: string | undefined;
    description?: string | undefined;
    startTime: Date;
    endTime: Date;
    activity_AlertFromStartInMinutes: number;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedRouteId: number;
    activityColor?: string | undefined;
    areaName?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    activityName?: string | undefined;
    lastSignedById?: number | undefined;
    lastSignedByFirstName?: string | undefined;
    lastSignedByLastName?: string | undefined;
    lastSignedOn?: Date | undefined;
    activity_ShowColorOnDevice: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations: boolean;
    activity_SeverityLevelId: SeverityLevelEnum;
    activity_RecurranceId: RecurrenceEnum;
    useParticipantList: boolean;
    unitTypeId?: number | undefined;
}

export class LegislationListItem implements ILegislationListItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILegislationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LegislationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LegislationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ILegislationListItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
}

export class LegislationItem implements ILegislationItem {
    id!: number;
    title?: string | undefined;
    active!: boolean;
    description?: string | undefined;
    organizationId!: number;

    constructor(data?: ILegislationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.active = _data["active"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): LegislationItem {
        data = typeof data === 'object' ? data : {};
        let result = new LegislationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["active"] = this.active;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ILegislationItem {
    id: number;
    title?: string | undefined;
    active: boolean;
    description?: string | undefined;
    organizationId: number;
}

export class LegislationCreateItem implements ILegislationCreateItem {
    title?: string | undefined;
    description?: string | undefined;
    organizationId!: number;

    constructor(data?: ILegislationCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): LegislationCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new LegislationCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ILegislationCreateItem {
    title?: string | undefined;
    description?: string | undefined;
    organizationId: number;
}

export class LegislationUpdateItem implements ILegislationUpdateItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId!: number;

    constructor(data?: ILegislationUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): LegislationUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new LegislationUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ILegislationUpdateItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    organizationId: number;
}

export class LoginMethodsItem implements ILoginMethodsItem {
    methodName?: string | undefined;

    constructor(data?: ILoginMethodsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodName = _data["methodName"];
        }
    }

    static fromJS(data: any): LoginMethodsItem {
        data = typeof data === 'object' ? data : {};
        let result = new LoginMethodsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodName"] = this.methodName;
        return data;
    }
}

export interface ILoginMethodsItem {
    methodName?: string | undefined;
}

export class CreatedNewAreaItem implements ICreatedNewAreaItem {
    newJwtToken?: JwtTokenGenerationResultItem | undefined;
    newlyCreatedAreaId!: number;

    constructor(data?: ICreatedNewAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newJwtToken = _data["newJwtToken"] ? JwtTokenGenerationResultItem.fromJS(_data["newJwtToken"]) : <any>undefined;
            this.newlyCreatedAreaId = _data["newlyCreatedAreaId"];
        }
    }

    static fromJS(data: any): CreatedNewAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedNewAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newJwtToken"] = this.newJwtToken ? this.newJwtToken.toJSON() : <any>undefined;
        data["newlyCreatedAreaId"] = this.newlyCreatedAreaId;
        return data;
    }
}

export interface ICreatedNewAreaItem {
    newJwtToken?: JwtTokenGenerationResultItem | undefined;
    newlyCreatedAreaId: number;
}

export class AreaCreateItem implements IAreaCreateItem {
    name?: string | undefined;
    organizationId?: number | undefined;
    parentAreaId?: number | undefined;

    constructor(data?: IAreaCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.parentAreaId = _data["parentAreaId"];
        }
    }

    static fromJS(data: any): AreaCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["parentAreaId"] = this.parentAreaId;
        return data;
    }
}

export interface IAreaCreateItem {
    name?: string | undefined;
    organizationId?: number | undefined;
    parentAreaId?: number | undefined;
}

export class AreaOrgTreeItem implements IAreaOrgTreeItem {
    id!: number;
    name?: string | undefined;
    parentName?: string | undefined;

    constructor(data?: IAreaOrgTreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentName = _data["parentName"];
        }
    }

    static fromJS(data: any): AreaOrgTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaOrgTreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        return data;
    }
}

export interface IAreaOrgTreeItem {
    id: number;
    name?: string | undefined;
    parentName?: string | undefined;
}

export class ChildAreaOrRoutesForParentAreaItem implements IChildAreaOrRoutesForParentAreaItem {
    routes?: RouteListItem[] | undefined;
    childAreas?: AreaListItem[] | undefined;

    constructor(data?: IChildAreaOrRoutesForParentAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(RouteListItem.fromJS(item));
            }
            if (Array.isArray(_data["childAreas"])) {
                this.childAreas = [] as any;
                for (let item of _data["childAreas"])
                    this.childAreas!.push(AreaListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChildAreaOrRoutesForParentAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChildAreaOrRoutesForParentAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item.toJSON());
        }
        if (Array.isArray(this.childAreas)) {
            data["childAreas"] = [];
            for (let item of this.childAreas)
                data["childAreas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChildAreaOrRoutesForParentAreaItem {
    routes?: RouteListItem[] | undefined;
    childAreas?: AreaListItem[] | undefined;
}

export class RouteListItem implements IRouteListItem {
    id!: number;
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId!: number;
    startDate!: Date;
    endDate?: Date | undefined;
    unplannedContainerRoute!: boolean;

    constructor(data?: IRouteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
        }
    }

    static fromJS(data: any): RouteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        return data;
    }
}

export interface IRouteListItem {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId: number;
    startDate: Date;
    endDate?: Date | undefined;
    unplannedContainerRoute: boolean;
}

export class AreaListItem implements IAreaListItem {
    id!: number;
    name?: string | undefined;
    organizationId?: number | undefined;
    parentAreaId?: number | undefined;
    areaOrRouteCount!: number;
    routeCount!: number;
    organizationParentsName?: string | undefined;

    constructor(data?: IAreaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.parentAreaId = _data["parentAreaId"];
            this.areaOrRouteCount = _data["areaOrRouteCount"];
            this.routeCount = _data["routeCount"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): AreaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["parentAreaId"] = this.parentAreaId;
        data["areaOrRouteCount"] = this.areaOrRouteCount;
        data["routeCount"] = this.routeCount;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface IAreaListItem {
    id: number;
    name?: string | undefined;
    organizationId?: number | undefined;
    parentAreaId?: number | undefined;
    areaOrRouteCount: number;
    routeCount: number;
    organizationParentsName?: string | undefined;
}

export class OrganizationItem implements IOrganizationItem {
    id!: number;
    active!: boolean;
    registrationNumber!: string;
    name!: string;
    areas?: AreaListItem[] | undefined;
    internalInformation?: string | undefined;

    constructor(data?: IOrganizationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.registrationNumber = _data["registrationNumber"];
            this.name = _data["name"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaListItem.fromJS(item));
            }
            this.internalInformation = _data["internalInformation"];
        }
    }

    static fromJS(data: any): OrganizationItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["registrationNumber"] = this.registrationNumber;
        data["name"] = this.name;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        data["internalInformation"] = this.internalInformation;
        return data;
    }
}

export interface IOrganizationItem {
    id: number;
    active: boolean;
    registrationNumber: string;
    name: string;
    areas?: AreaListItem[] | undefined;
    internalInformation?: string | undefined;
}

export class OrganizationListItem implements IOrganizationListItem {
    id!: number;
    active!: boolean;
    registrationNumber!: string;
    name!: string;

    constructor(data?: IOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.registrationNumber = _data["registrationNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["registrationNumber"] = this.registrationNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationListItem {
    id: number;
    active: boolean;
    registrationNumber: string;
    name: string;
}

export class OrganizationCreateItem implements IOrganizationCreateItem {
    active!: boolean;
    registrationNumber!: string;
    name!: string;

    constructor(data?: IOrganizationCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.registrationNumber = _data["registrationNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["registrationNumber"] = this.registrationNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationCreateItem {
    active: boolean;
    registrationNumber: string;
    name: string;
}

export class OrganizationUpdateinternalInformationItem implements IOrganizationUpdateinternalInformationItem {
    id!: number;
    internalInformation?: string | undefined;

    constructor(data?: IOrganizationUpdateinternalInformationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.internalInformation = _data["internalInformation"];
        }
    }

    static fromJS(data: any): OrganizationUpdateinternalInformationItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUpdateinternalInformationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["internalInformation"] = this.internalInformation;
        return data;
    }
}

export interface IOrganizationUpdateinternalInformationItem {
    id: number;
    internalInformation?: string | undefined;
}

export class RoutePwaDailyActivitiesContainerItem implements IRoutePwaDailyActivitiesContainerItem {
    areaId!: number;
    areaName?: string | undefined;
    areaInternalInformation?: string | undefined;
    orgInternalInformation?: string | undefined;
    allowNavigateToPlanningPage!: boolean;
    allowUseMultiSigning!: boolean;
    useManualSessionExpiration!: boolean;
    manualSessionExpirationMinutes?: number | undefined;
    items?: RoutePwaDailyActivitiesViewItem[] | undefined;
    lapsedLimitReached!: boolean;
    suppressTimesOnKioskAndPwa!: boolean;

    constructor(data?: IRoutePwaDailyActivitiesContainerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.areaInternalInformation = _data["areaInternalInformation"];
            this.orgInternalInformation = _data["orgInternalInformation"];
            this.allowNavigateToPlanningPage = _data["allowNavigateToPlanningPage"];
            this.allowUseMultiSigning = _data["allowUseMultiSigning"];
            this.useManualSessionExpiration = _data["useManualSessionExpiration"];
            this.manualSessionExpirationMinutes = _data["manualSessionExpirationMinutes"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoutePwaDailyActivitiesViewItem.fromJS(item));
            }
            this.lapsedLimitReached = _data["lapsedLimitReached"];
            this.suppressTimesOnKioskAndPwa = _data["suppressTimesOnKioskAndPwa"];
        }
    }

    static fromJS(data: any): RoutePwaDailyActivitiesContainerItem {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePwaDailyActivitiesContainerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["areaInternalInformation"] = this.areaInternalInformation;
        data["orgInternalInformation"] = this.orgInternalInformation;
        data["allowNavigateToPlanningPage"] = this.allowNavigateToPlanningPage;
        data["allowUseMultiSigning"] = this.allowUseMultiSigning;
        data["useManualSessionExpiration"] = this.useManualSessionExpiration;
        data["manualSessionExpirationMinutes"] = this.manualSessionExpirationMinutes;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["lapsedLimitReached"] = this.lapsedLimitReached;
        data["suppressTimesOnKioskAndPwa"] = this.suppressTimesOnKioskAndPwa;
        return data;
    }
}

export interface IRoutePwaDailyActivitiesContainerItem {
    areaId: number;
    areaName?: string | undefined;
    areaInternalInformation?: string | undefined;
    orgInternalInformation?: string | undefined;
    allowNavigateToPlanningPage: boolean;
    allowUseMultiSigning: boolean;
    useManualSessionExpiration: boolean;
    manualSessionExpirationMinutes?: number | undefined;
    items?: RoutePwaDailyActivitiesViewItem[] | undefined;
    lapsedLimitReached: boolean;
    suppressTimesOnKioskAndPwa: boolean;
}

export class RoutePwaDailyActivitiesViewItem implements IRoutePwaDailyActivitiesViewItem {
    id!: number;
    name!: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId!: number;
    plannedRoutes?: PlannedRoutePwaDailyActivitiesViewItem[] | undefined;
    unplannedContainerRoute!: boolean;
    startDate!: Date;
    endDate?: Date | undefined;

    constructor(data?: IRoutePwaDailyActivitiesViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            if (Array.isArray(_data["plannedRoutes"])) {
                this.plannedRoutes = [] as any;
                for (let item of _data["plannedRoutes"])
                    this.plannedRoutes!.push(PlannedRoutePwaDailyActivitiesViewItem.fromJS(item));
            }
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoutePwaDailyActivitiesViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePwaDailyActivitiesViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        if (Array.isArray(this.plannedRoutes)) {
            data["plannedRoutes"] = [];
            for (let item of this.plannedRoutes)
                data["plannedRoutes"].push(item.toJSON());
        }
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRoutePwaDailyActivitiesViewItem {
    id: number;
    name: string;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId: number;
    plannedRoutes?: PlannedRoutePwaDailyActivitiesViewItem[] | undefined;
    unplannedContainerRoute: boolean;
    startDate: Date;
    endDate?: Date | undefined;
}

export class PlannedRoutePwaDailyActivitiesViewItem implements IPlannedRoutePwaDailyActivitiesViewItem {
    id!: number;
    routeId!: number;
    plannedActivityRows?: PlannedActivityRowPwaDailyViewItem[] | undefined;
    calendarDay!: Date;

    constructor(data?: IPlannedRoutePwaDailyActivitiesViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["plannedActivityRows"])) {
                this.plannedActivityRows = [] as any;
                for (let item of _data["plannedActivityRows"])
                    this.plannedActivityRows!.push(PlannedActivityRowPwaDailyViewItem.fromJS(item));
            }
            this.calendarDay = _data["calendarDay"] ? new Date(_data["calendarDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedRoutePwaDailyActivitiesViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedRoutePwaDailyActivitiesViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeId"] = this.routeId;
        if (Array.isArray(this.plannedActivityRows)) {
            data["plannedActivityRows"] = [];
            for (let item of this.plannedActivityRows)
                data["plannedActivityRows"].push(item.toJSON());
        }
        data["calendarDay"] = this.calendarDay ? this.calendarDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlannedRoutePwaDailyActivitiesViewItem {
    id: number;
    routeId: number;
    plannedActivityRows?: PlannedActivityRowPwaDailyViewItem[] | undefined;
    calendarDay: Date;
}

export class PlannedActivityRowPwaDailyViewItem implements IPlannedActivityRowPwaDailyViewItem {
    id!: number;
    activityRowId!: number;
    comment?: string | undefined;
    description?: string | undefined;
    startTime!: Date;
    endTime!: Date;
    activity_AlertFromStartInMinutes!: number;
    plannedActivityStatusId!: PlannedActivityStatusEnum;
    plannedRouteId!: number;
    activityColor?: string | undefined;
    areaName?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    activityName?: string | undefined;
    lastSignedById?: number | undefined;
    lastSignedByFirstName?: string | undefined;
    lastSignedByLastName?: string | undefined;
    lastSignedOn?: Date | undefined;
    activity_ShowColorOnDevice!: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations!: boolean;
    activity_SeverityLevelId!: SeverityLevelEnum;
    activity_RecurranceId!: RecurrenceEnum;
    useParticipantList!: boolean;
    unitTypeId?: number | undefined;

    constructor(data?: IPlannedActivityRowPwaDailyViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityRowId = _data["activityRowId"];
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.activity_AlertFromStartInMinutes = _data["activity_AlertFromStartInMinutes"];
            this.plannedActivityStatusId = _data["plannedActivityStatusId"];
            this.plannedRouteId = _data["plannedRouteId"];
            this.activityColor = _data["activityColor"];
            this.areaName = _data["areaName"];
            this.ownerCustomerFirstName = _data["ownerCustomerFirstName"];
            this.ownerCustomerLastName = _data["ownerCustomerLastName"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerCustomerId = _data["ownerCustomerId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerCustomerRoomNumber = _data["ownerCustomerRoomNumber"];
            this.activityName = _data["activityName"];
            this.lastSignedById = _data["lastSignedById"];
            this.lastSignedByFirstName = _data["lastSignedByFirstName"];
            this.lastSignedByLastName = _data["lastSignedByLastName"];
            this.lastSignedOn = _data["lastSignedOn"] ? new Date(_data["lastSignedOn"].toString()) : <any>undefined;
            this.activity_ShowColorOnDevice = _data["activity_ShowColorOnDevice"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.hasUnfulfilledDelegations = _data["hasUnfulfilledDelegations"];
            this.activity_SeverityLevelId = _data["activity_SeverityLevelId"];
            this.activity_RecurranceId = _data["activity_RecurranceId"];
            this.useParticipantList = _data["useParticipantList"];
            this.unitTypeId = _data["unitTypeId"];
        }
    }

    static fromJS(data: any): PlannedActivityRowPwaDailyViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityRowPwaDailyViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityRowId"] = this.activityRowId;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["activity_AlertFromStartInMinutes"] = this.activity_AlertFromStartInMinutes;
        data["plannedActivityStatusId"] = this.plannedActivityStatusId;
        data["plannedRouteId"] = this.plannedRouteId;
        data["activityColor"] = this.activityColor;
        data["areaName"] = this.areaName;
        data["ownerCustomerFirstName"] = this.ownerCustomerFirstName;
        data["ownerCustomerLastName"] = this.ownerCustomerLastName;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerCustomerId"] = this.ownerCustomerId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerCustomerRoomNumber"] = this.ownerCustomerRoomNumber;
        data["activityName"] = this.activityName;
        data["lastSignedById"] = this.lastSignedById;
        data["lastSignedByFirstName"] = this.lastSignedByFirstName;
        data["lastSignedByLastName"] = this.lastSignedByLastName;
        data["lastSignedOn"] = this.lastSignedOn ? this.lastSignedOn.toISOString() : <any>undefined;
        data["activity_ShowColorOnDevice"] = this.activity_ShowColorOnDevice;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["hasUnfulfilledDelegations"] = this.hasUnfulfilledDelegations;
        data["activity_SeverityLevelId"] = this.activity_SeverityLevelId;
        data["activity_RecurranceId"] = this.activity_RecurranceId;
        data["useParticipantList"] = this.useParticipantList;
        data["unitTypeId"] = this.unitTypeId;
        return data;
    }
}

export interface IPlannedActivityRowPwaDailyViewItem {
    id: number;
    activityRowId: number;
    comment?: string | undefined;
    description?: string | undefined;
    startTime: Date;
    endTime: Date;
    activity_AlertFromStartInMinutes: number;
    plannedActivityStatusId: PlannedActivityStatusEnum;
    plannedRouteId: number;
    activityColor?: string | undefined;
    areaName?: string | undefined;
    ownerCustomerFirstName?: string | undefined;
    ownerCustomerLastName?: string | undefined;
    ownerAreaName?: string | undefined;
    ownerCustomerId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerCustomerRoomNumber?: string | undefined;
    activityName?: string | undefined;
    lastSignedById?: number | undefined;
    lastSignedByFirstName?: string | undefined;
    lastSignedByLastName?: string | undefined;
    lastSignedOn?: Date | undefined;
    activity_ShowColorOnDevice: boolean;
    templateActivityTitle?: string | undefined;
    hasUnfulfilledDelegations: boolean;
    activity_SeverityLevelId: SeverityLevelEnum;
    activity_RecurranceId: RecurrenceEnum;
    useParticipantList: boolean;
    unitTypeId?: number | undefined;
}

export class RouteItem implements IRouteItem {
    id!: number;
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId!: number;
    startDate!: Date;
    endDate?: Date | undefined;
    unplannedContainerRoute!: boolean;
    createdById!: number;
    createdOn!: Date;
    modifiedById!: number;
    modifiedOn!: Date;

    constructor(data?: IRouteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unplannedContainerRoute = _data["unplannedContainerRoute"];
            this.createdById = _data["createdById"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RouteItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unplannedContainerRoute"] = this.unplannedContainerRoute;
        data["createdById"] = this.createdById;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRouteItem {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex?: number | undefined;
    areaId: number;
    startDate: Date;
    endDate?: Date | undefined;
    unplannedContainerRoute: boolean;
    createdById: number;
    createdOn: Date;
    modifiedById: number;
    modifiedOn: Date;
}

export class RouteCreateItem implements IRouteCreateItem {
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex!: number;
    areaId!: number;
    startDate!: Date;
    endDate?: Date | undefined;

    constructor(data?: IRouteCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
            this.sortingIndex = _data["sortingIndex"];
            this.areaId = _data["areaId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RouteCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortingIndex"] = this.sortingIndex;
        data["areaId"] = this.areaId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRouteCreateItem {
    name?: string | undefined;
    color?: string | undefined;
    sortingIndex: number;
    areaId: number;
    startDate: Date;
    endDate?: Date | undefined;
}

export class RouteUpdateItem implements IRouteUpdateItem {
    id!: number;
    name?: string | undefined;
    color?: string | undefined;

    constructor(data?: IRouteUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): RouteUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new RouteUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}

export interface IRouteUpdateItem {
    id: number;
    name?: string | undefined;
    color?: string | undefined;
}

export class TemplateActivityListItem implements ITemplateActivityListItem {
    id!: number;
    title?: string | undefined;
    ownerAreaId?: number | undefined;
    ownerAreaName?: string | undefined;
    color?: string | undefined;
    alertFromStartInMinutes!: number;
    visitLengthInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;
    unitId?: number | undefined;
    unitTitle?: string | undefined;
    unitAbbreviation?: string | undefined;
    unitAmount?: number | undefined;
    severityLevelId!: SeverityLevelEnum;
    useParticipantList!: boolean;

    constructor(data?: ITemplateActivityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.color = _data["color"];
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityCategoryTitle = _data["templateActivityCategoryTitle"];
            this.templateActivityLegislationId = _data["templateActivityLegislationId"];
            this.templateActivityLegislationTitle = _data["templateActivityLegislationTitle"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            this.unitId = _data["unitId"];
            this.unitTitle = _data["unitTitle"];
            this.unitAbbreviation = _data["unitAbbreviation"];
            this.unitAmount = _data["unitAmount"];
            this.severityLevelId = _data["severityLevelId"];
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): TemplateActivityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerAreaName"] = this.ownerAreaName;
        data["color"] = this.color;
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityCategoryTitle"] = this.templateActivityCategoryTitle;
        data["templateActivityLegislationId"] = this.templateActivityLegislationId;
        data["templateActivityLegislationTitle"] = this.templateActivityLegislationTitle;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        data["unitId"] = this.unitId;
        data["unitTitle"] = this.unitTitle;
        data["unitAbbreviation"] = this.unitAbbreviation;
        data["unitAmount"] = this.unitAmount;
        data["severityLevelId"] = this.severityLevelId;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface ITemplateActivityListItem {
    id: number;
    title?: string | undefined;
    ownerAreaId?: number | undefined;
    ownerAreaName?: string | undefined;
    color?: string | undefined;
    alertFromStartInMinutes: number;
    visitLengthInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
    unitId?: number | undefined;
    unitTitle?: string | undefined;
    unitAbbreviation?: string | undefined;
    unitAmount?: number | undefined;
    severityLevelId: SeverityLevelEnum;
    useParticipantList: boolean;
}

export class TemplateActivityItem implements ITemplateActivityItem {
    id!: number;
    active!: boolean;
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaOrganizationParentsName?: string | undefined;
    color?: string | undefined;
    alertFromStartInMinutes!: number;
    visitLengthInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationItem[] | undefined;
    unitId?: number | undefined;
    unitTitle?: string | undefined;
    unitAbbreviation?: string | undefined;
    unitAmount?: number | undefined;
    severityLevelId!: SeverityLevelEnum;
    useParticipantList!: boolean;

    constructor(data?: ITemplateActivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerAreaName = _data["ownerAreaName"];
            this.ownerAreaOrganizationParentsName = _data["ownerAreaOrganizationParentsName"];
            this.color = _data["color"];
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityCategoryTitle = _data["templateActivityCategoryTitle"];
            this.templateActivityLegislationId = _data["templateActivityLegislationId"];
            this.templateActivityLegislationTitle = _data["templateActivityLegislationTitle"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            if (Array.isArray(_data["templateActivityDelegations"])) {
                this.templateActivityDelegations = [] as any;
                for (let item of _data["templateActivityDelegations"])
                    this.templateActivityDelegations!.push(TemplateActivityDelegationItem.fromJS(item));
            }
            this.unitId = _data["unitId"];
            this.unitTitle = _data["unitTitle"];
            this.unitAbbreviation = _data["unitAbbreviation"];
            this.unitAmount = _data["unitAmount"];
            this.severityLevelId = _data["severityLevelId"];
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): TemplateActivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["title"] = this.title;
        data["description"] = this.description;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerAreaName"] = this.ownerAreaName;
        data["ownerAreaOrganizationParentsName"] = this.ownerAreaOrganizationParentsName;
        data["color"] = this.color;
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityCategoryTitle"] = this.templateActivityCategoryTitle;
        data["templateActivityLegislationId"] = this.templateActivityLegislationId;
        data["templateActivityLegislationTitle"] = this.templateActivityLegislationTitle;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        if (Array.isArray(this.templateActivityDelegations)) {
            data["templateActivityDelegations"] = [];
            for (let item of this.templateActivityDelegations)
                data["templateActivityDelegations"].push(item.toJSON());
        }
        data["unitId"] = this.unitId;
        data["unitTitle"] = this.unitTitle;
        data["unitAbbreviation"] = this.unitAbbreviation;
        data["unitAmount"] = this.unitAmount;
        data["severityLevelId"] = this.severityLevelId;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface ITemplateActivityItem {
    id: number;
    active: boolean;
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    ownerAreaName?: string | undefined;
    ownerAreaOrganizationParentsName?: string | undefined;
    color?: string | undefined;
    alertFromStartInMinutes: number;
    visitLengthInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    templateActivityLegislationId?: number | undefined;
    templateActivityLegislationTitle?: string | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationItem[] | undefined;
    unitId?: number | undefined;
    unitTitle?: string | undefined;
    unitAbbreviation?: string | undefined;
    unitAmount?: number | undefined;
    severityLevelId: SeverityLevelEnum;
    useParticipantList: boolean;
}

export class TemplateActivityDelegationItem implements ITemplateActivityDelegationItem {
    id!: number;
    templateActivityId!: number;
    delegationId!: number;
    delegationTitle?: string | undefined;

    constructor(data?: ITemplateActivityDelegationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateActivityId = _data["templateActivityId"];
            this.delegationId = _data["delegationId"];
            this.delegationTitle = _data["delegationTitle"];
        }
    }

    static fromJS(data: any): TemplateActivityDelegationItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityDelegationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateActivityId"] = this.templateActivityId;
        data["delegationId"] = this.delegationId;
        data["delegationTitle"] = this.delegationTitle;
        return data;
    }
}

export interface ITemplateActivityDelegationItem {
    id: number;
    templateActivityId: number;
    delegationId: number;
    delegationTitle?: string | undefined;
}

export class TemplateActivityCreateItem implements ITemplateActivityCreateItem {
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    color?: string | undefined;
    alertFromStartInMinutes!: number;
    visitLengthInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationPersistItem[] | undefined;
    unitId?: number | undefined;
    unitAmount?: number | undefined;
    severityLevelId!: SeverityLevelEnum;
    useParticipantList!: boolean;

    constructor(data?: ITemplateActivityCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.color = _data["color"];
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            if (Array.isArray(_data["templateActivityDelegations"])) {
                this.templateActivityDelegations = [] as any;
                for (let item of _data["templateActivityDelegations"])
                    this.templateActivityDelegations!.push(TemplateActivityDelegationPersistItem.fromJS(item));
            }
            this.unitId = _data["unitId"];
            this.unitAmount = _data["unitAmount"];
            this.severityLevelId = _data["severityLevelId"];
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): TemplateActivityCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["color"] = this.color;
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        if (Array.isArray(this.templateActivityDelegations)) {
            data["templateActivityDelegations"] = [];
            for (let item of this.templateActivityDelegations)
                data["templateActivityDelegations"].push(item.toJSON());
        }
        data["unitId"] = this.unitId;
        data["unitAmount"] = this.unitAmount;
        data["severityLevelId"] = this.severityLevelId;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface ITemplateActivityCreateItem {
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    color?: string | undefined;
    alertFromStartInMinutes: number;
    visitLengthInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationPersistItem[] | undefined;
    unitId?: number | undefined;
    unitAmount?: number | undefined;
    severityLevelId: SeverityLevelEnum;
    useParticipantList: boolean;
}

export class TemplateActivityDelegationPersistItem implements ITemplateActivityDelegationPersistItem {
    id?: number | undefined;
    templateActivityId?: number | undefined;
    delegationId!: number;

    constructor(data?: ITemplateActivityDelegationPersistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateActivityId = _data["templateActivityId"];
            this.delegationId = _data["delegationId"];
        }
    }

    static fromJS(data: any): TemplateActivityDelegationPersistItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityDelegationPersistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateActivityId"] = this.templateActivityId;
        data["delegationId"] = this.delegationId;
        return data;
    }
}

export interface ITemplateActivityDelegationPersistItem {
    id?: number | undefined;
    templateActivityId?: number | undefined;
    delegationId: number;
}

export class TemplateActivityUpdateItem implements ITemplateActivityUpdateItem {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    color?: string | undefined;
    alertFromStartInMinutes!: number;
    visitLengthInMinutes!: number;
    showColorOnDevice!: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationPersistItem[] | undefined;
    unitId?: number | undefined;
    unitAmount?: number | undefined;
    severityLevelId!: SeverityLevelEnum;
    useParticipantList!: boolean;

    constructor(data?: ITemplateActivityUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.color = _data["color"];
            this.alertFromStartInMinutes = _data["alertFromStartInMinutes"];
            this.visitLengthInMinutes = _data["visitLengthInMinutes"];
            this.showColorOnDevice = _data["showColorOnDevice"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
            if (Array.isArray(_data["templateActivityDelegations"])) {
                this.templateActivityDelegations = [] as any;
                for (let item of _data["templateActivityDelegations"])
                    this.templateActivityDelegations!.push(TemplateActivityDelegationPersistItem.fromJS(item));
            }
            this.unitId = _data["unitId"];
            this.unitAmount = _data["unitAmount"];
            this.severityLevelId = _data["severityLevelId"];
            this.useParticipantList = _data["useParticipantList"];
        }
    }

    static fromJS(data: any): TemplateActivityUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerAreaId"] = this.ownerAreaId;
        data["color"] = this.color;
        data["alertFromStartInMinutes"] = this.alertFromStartInMinutes;
        data["visitLengthInMinutes"] = this.visitLengthInMinutes;
        data["showColorOnDevice"] = this.showColorOnDevice;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        if (Array.isArray(this.templateActivityDelegations)) {
            data["templateActivityDelegations"] = [];
            for (let item of this.templateActivityDelegations)
                data["templateActivityDelegations"].push(item.toJSON());
        }
        data["unitId"] = this.unitId;
        data["unitAmount"] = this.unitAmount;
        data["severityLevelId"] = this.severityLevelId;
        data["useParticipantList"] = this.useParticipantList;
        return data;
    }
}

export interface ITemplateActivityUpdateItem {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
    color?: string | undefined;
    alertFromStartInMinutes: number;
    visitLengthInMinutes: number;
    showColorOnDevice: boolean;
    templateActivityCategoryId?: number | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
    templateActivityDelegations?: TemplateActivityDelegationPersistItem[] | undefined;
    unitId?: number | undefined;
    unitAmount?: number | undefined;
    severityLevelId: SeverityLevelEnum;
    useParticipantList: boolean;
}

export class TemplateActivitiesToAreasItem implements ITemplateActivitiesToAreasItem {
    templateActivityIds?: number[] | undefined;
    areaIds?: number[] | undefined;

    constructor(data?: ITemplateActivitiesToAreasItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templateActivityIds"])) {
                this.templateActivityIds = [] as any;
                for (let item of _data["templateActivityIds"])
                    this.templateActivityIds!.push(item);
            }
            if (Array.isArray(_data["areaIds"])) {
                this.areaIds = [] as any;
                for (let item of _data["areaIds"])
                    this.areaIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TemplateActivitiesToAreasItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivitiesToAreasItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templateActivityIds)) {
            data["templateActivityIds"] = [];
            for (let item of this.templateActivityIds)
                data["templateActivityIds"].push(item);
        }
        if (Array.isArray(this.areaIds)) {
            data["areaIds"] = [];
            for (let item of this.areaIds)
                data["areaIds"].push(item);
        }
        return data;
    }
}

export interface ITemplateActivitiesToAreasItem {
    templateActivityIds?: number[] | undefined;
    areaIds?: number[] | undefined;
}

export class TemplateActivityInheritanceItem implements ITemplateActivityInheritanceItem {
    id!: number;
    description?: string | undefined;
    useTemplateDescription!: boolean;
    areaName?: string | undefined;
    areaOrganizationParentsName?: string | undefined;
    areaId!: number;
    templateActivityId!: number;
    templateActivityTitle?: string | undefined;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;
    templateActivityTypeId!: TemplateActivityTypeEnum;

    constructor(data?: ITemplateActivityInheritanceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.useTemplateDescription = _data["useTemplateDescription"];
            this.areaName = _data["areaName"];
            this.areaOrganizationParentsName = _data["areaOrganizationParentsName"];
            this.areaId = _data["areaId"];
            this.templateActivityId = _data["templateActivityId"];
            this.templateActivityTitle = _data["templateActivityTitle"];
            this.templateActivityCategoryId = _data["templateActivityCategoryId"];
            this.templateActivityCategoryTitle = _data["templateActivityCategoryTitle"];
            this.legislationId = _data["legislationId"];
            this.legislationTitle = _data["legislationTitle"];
            this.templateActivityTypeId = _data["templateActivityTypeId"];
        }
    }

    static fromJS(data: any): TemplateActivityInheritanceItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityInheritanceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["useTemplateDescription"] = this.useTemplateDescription;
        data["areaName"] = this.areaName;
        data["areaOrganizationParentsName"] = this.areaOrganizationParentsName;
        data["areaId"] = this.areaId;
        data["templateActivityId"] = this.templateActivityId;
        data["templateActivityTitle"] = this.templateActivityTitle;
        data["templateActivityCategoryId"] = this.templateActivityCategoryId;
        data["templateActivityCategoryTitle"] = this.templateActivityCategoryTitle;
        data["legislationId"] = this.legislationId;
        data["legislationTitle"] = this.legislationTitle;
        data["templateActivityTypeId"] = this.templateActivityTypeId;
        return data;
    }
}

export interface ITemplateActivityInheritanceItem {
    id: number;
    description?: string | undefined;
    useTemplateDescription: boolean;
    areaName?: string | undefined;
    areaOrganizationParentsName?: string | undefined;
    areaId: number;
    templateActivityId: number;
    templateActivityTitle?: string | undefined;
    templateActivityCategoryId?: number | undefined;
    templateActivityCategoryTitle?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;
    templateActivityTypeId: TemplateActivityTypeEnum;
}

export class TemplateActivityInheritanceCreateItem implements ITemplateActivityInheritanceCreateItem {
    useTemplateDescription!: boolean;
    description?: string | undefined;
    templateActivityId!: number;
    areaId!: number;

    constructor(data?: ITemplateActivityInheritanceCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useTemplateDescription = _data["useTemplateDescription"];
            this.description = _data["description"];
            this.templateActivityId = _data["templateActivityId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): TemplateActivityInheritanceCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityInheritanceCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useTemplateDescription"] = this.useTemplateDescription;
        data["description"] = this.description;
        data["templateActivityId"] = this.templateActivityId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface ITemplateActivityInheritanceCreateItem {
    useTemplateDescription: boolean;
    description?: string | undefined;
    templateActivityId: number;
    areaId: number;
}

export class TemplateActivityInheritanceUpdateItem implements ITemplateActivityInheritanceUpdateItem {
    id!: number;
    description?: string | undefined;
    useTemplateDescription!: boolean;
    templateActivityId!: number;
    areaId!: number;

    constructor(data?: ITemplateActivityInheritanceUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.useTemplateDescription = _data["useTemplateDescription"];
            this.templateActivityId = _data["templateActivityId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): TemplateActivityInheritanceUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityInheritanceUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["useTemplateDescription"] = this.useTemplateDescription;
        data["templateActivityId"] = this.templateActivityId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface ITemplateActivityInheritanceUpdateItem {
    id: number;
    description?: string | undefined;
    useTemplateDescription: boolean;
    templateActivityId: number;
    areaId: number;
}

export class TemplateActivityCategoryListItem implements ITemplateActivityCategoryListItem {
    id!: number;
    title?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;

    constructor(data?: ITemplateActivityCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.legislationId = _data["legislationId"];
            this.legislationTitle = _data["legislationTitle"];
        }
    }

    static fromJS(data: any): TemplateActivityCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["legislationId"] = this.legislationId;
        data["legislationTitle"] = this.legislationTitle;
        return data;
    }
}

export interface ITemplateActivityCategoryListItem {
    id: number;
    title?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;
}

export class TemplateActivityCategoryItem implements ITemplateActivityCategoryItem {
    id!: number;
    active!: boolean;
    title?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;
    ownerOrganizationId!: number;

    constructor(data?: ITemplateActivityCategoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.title = _data["title"];
            this.legislationId = _data["legislationId"];
            this.legislationTitle = _data["legislationTitle"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
        }
    }

    static fromJS(data: any): TemplateActivityCategoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityCategoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["title"] = this.title;
        data["legislationId"] = this.legislationId;
        data["legislationTitle"] = this.legislationTitle;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        return data;
    }
}

export interface ITemplateActivityCategoryItem {
    id: number;
    active: boolean;
    title?: string | undefined;
    legislationId?: number | undefined;
    legislationTitle?: string | undefined;
    ownerOrganizationId: number;
}

export class TemplateActivityCategoryCreateItem implements ITemplateActivityCategoryCreateItem {
    title!: string;
    ownerOrganizationId!: number;
    legislationId?: number | undefined;

    constructor(data?: ITemplateActivityCategoryCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.legislationId = _data["legislationId"];
        }
    }

    static fromJS(data: any): TemplateActivityCategoryCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityCategoryCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["legislationId"] = this.legislationId;
        return data;
    }
}

export interface ITemplateActivityCategoryCreateItem {
    title: string;
    ownerOrganizationId: number;
    legislationId?: number | undefined;
}

export class TemplateActivityCategoryUpdateItem implements ITemplateActivityCategoryUpdateItem {
    id!: number;
    title!: string;
    ownerOrganizationId!: number;
    legislationId?: number | undefined;

    constructor(data?: ITemplateActivityCategoryUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.legislationId = _data["legislationId"];
        }
    }

    static fromJS(data: any): TemplateActivityCategoryUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateActivityCategoryUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["legislationId"] = this.legislationId;
        return data;
    }
}

export interface ITemplateActivityCategoryUpdateItem {
    id: number;
    title: string;
    ownerOrganizationId: number;
    legislationId?: number | undefined;
}

export class ChangePasswordUsingCurrentPasswordItem implements IChangePasswordUsingCurrentPasswordItem {
    userId!: number;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordUsingCurrentPasswordItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordUsingCurrentPasswordItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordUsingCurrentPasswordItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordUsingCurrentPasswordItem {
    userId: number;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePasswordUsingTokenItem implements IChangePasswordUsingTokenItem {
    userId!: number;
    token?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordUsingTokenItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordUsingTokenItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordUsingTokenItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordUsingTokenItem {
    userId: number;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePinCodeUsingTokenItem implements IChangePinCodeUsingTokenItem {
    userId!: number;
    token?: string | undefined;
    newPinCode?: string | undefined;

    constructor(data?: IChangePinCodeUsingTokenItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.newPinCode = _data["newPinCode"];
        }
    }

    static fromJS(data: any): ChangePinCodeUsingTokenItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinCodeUsingTokenItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["newPinCode"] = this.newPinCode;
        return data;
    }
}

export interface IChangePinCodeUsingTokenItem {
    userId: number;
    token?: string | undefined;
    newPinCode?: string | undefined;
}

export class UserCreateItem implements IUserCreateItem {
    active!: boolean;
    userType!: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: number | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    userAreas?: UserAreaCreateItem[] | undefined;
    userDelegations?: UserDelegationPersistItem[] | undefined;
    pinCode?: string | undefined;
    extraInfo?: string | undefined;

    constructor(data?: IUserCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.userType = _data["userType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.phoneNumber = _data["phoneNumber"];
            this.description = _data["description"];
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaCreateItem.fromJS(item));
            }
            if (Array.isArray(_data["userDelegations"])) {
                this.userDelegations = [] as any;
                for (let item of _data["userDelegations"])
                    this.userDelegations!.push(UserDelegationPersistItem.fromJS(item));
            }
            this.pinCode = _data["pinCode"];
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): UserCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userType"] = this.userType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.userDelegations)) {
            data["userDelegations"] = [];
            for (let item of this.userDelegations)
                data["userDelegations"].push(item.toJSON());
        }
        data["pinCode"] = this.pinCode;
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface IUserCreateItem {
    active: boolean;
    userType: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organizationId?: number | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    userAreas?: UserAreaCreateItem[] | undefined;
    userDelegations?: UserDelegationPersistItem[] | undefined;
    pinCode?: string | undefined;
    extraInfo?: string | undefined;
}

export class UserAreaCreateItem implements IUserAreaCreateItem {
    areaId!: number;
    roleId!: RoleEnum;

    constructor(data?: IUserAreaCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserAreaCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserAreaCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserAreaCreateItem {
    areaId: number;
    roleId: RoleEnum;
}

export class UserDelegationPersistItem implements IUserDelegationPersistItem {
    id?: number | undefined;
    delegationId!: number;
    userId!: number;
    userDelegationPlacements?: UserDelegationPlacementPersistItem[] | undefined;

    constructor(data?: IUserDelegationPersistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegationId = _data["delegationId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["userDelegationPlacements"])) {
                this.userDelegationPlacements = [] as any;
                for (let item of _data["userDelegationPlacements"])
                    this.userDelegationPlacements!.push(UserDelegationPlacementPersistItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDelegationPersistItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationPersistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegationId"] = this.delegationId;
        data["userId"] = this.userId;
        if (Array.isArray(this.userDelegationPlacements)) {
            data["userDelegationPlacements"] = [];
            for (let item of this.userDelegationPlacements)
                data["userDelegationPlacements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDelegationPersistItem {
    id?: number | undefined;
    delegationId: number;
    userId: number;
    userDelegationPlacements?: UserDelegationPlacementPersistItem[] | undefined;
}

export class UserDelegationPlacementPersistItem implements IUserDelegationPlacementPersistItem {
    id?: number | undefined;
    active!: boolean;
    description?: string | undefined;
    areaId?: number | undefined;
    customerId?: number | undefined;
    delegationStartTime!: Date;
    delegationEndTime!: Date;
    delegatedById!: number;

    constructor(data?: IUserDelegationPlacementPersistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            this.customerId = _data["customerId"];
            this.delegationStartTime = _data["delegationStartTime"] ? new Date(_data["delegationStartTime"].toString()) : <any>undefined;
            this.delegationEndTime = _data["delegationEndTime"] ? new Date(_data["delegationEndTime"].toString()) : <any>undefined;
            this.delegatedById = _data["delegatedById"];
        }
    }

    static fromJS(data: any): UserDelegationPlacementPersistItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationPlacementPersistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["customerId"] = this.customerId;
        data["delegationStartTime"] = this.delegationStartTime ? this.delegationStartTime.toISOString() : <any>undefined;
        data["delegationEndTime"] = this.delegationEndTime ? this.delegationEndTime.toISOString() : <any>undefined;
        data["delegatedById"] = this.delegatedById;
        return data;
    }
}

export interface IUserDelegationPlacementPersistItem {
    id?: number | undefined;
    active: boolean;
    description?: string | undefined;
    areaId?: number | undefined;
    customerId?: number | undefined;
    delegationStartTime: Date;
    delegationEndTime: Date;
    delegatedById: number;
}

export class PageResultOfUserListItem extends PageResult implements IPageResultOfUserListItem {
    items!: UserListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfUserListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfUserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfUserListItem extends IPageResult {
    items: UserListItem[];
    searchOptions: PageSearchOptions;
}

export class UserUpdateItem implements IUserUpdateItem {
    id!: number;
    active!: boolean;
    userType!: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    userAreas?: UserAreaUpdateItem[] | undefined;
    userDelegations?: UserDelegationPersistItem[] | undefined;
    pinCode?: string | undefined;
    extraInfo?: string | undefined;

    constructor(data?: IUserUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userType = _data["userType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.description = _data["description"];
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaUpdateItem.fromJS(item));
            }
            if (Array.isArray(_data["userDelegations"])) {
                this.userDelegations = [] as any;
                for (let item of _data["userDelegations"])
                    this.userDelegations!.push(UserDelegationPersistItem.fromJS(item));
            }
            this.pinCode = _data["pinCode"];
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): UserUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userType"] = this.userType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.userDelegations)) {
            data["userDelegations"] = [];
            for (let item of this.userDelegations)
                data["userDelegations"].push(item.toJSON());
        }
        data["pinCode"] = this.pinCode;
        data["extraInfo"] = this.extraInfo;
        return data;
    }
}

export interface IUserUpdateItem {
    id: number;
    active: boolean;
    userType: UserTypeEnum;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    userAreas?: UserAreaUpdateItem[] | undefined;
    userDelegations?: UserDelegationPersistItem[] | undefined;
    pinCode?: string | undefined;
    extraInfo?: string | undefined;
}

export class UserAreaUpdateItem implements IUserAreaUpdateItem {
    areaId!: number;
    roleId!: RoleEnum;

    constructor(data?: IUserAreaUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserAreaUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserAreaUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserAreaUpdateItem {
    areaId: number;
    roleId: RoleEnum;
}

export abstract class ServiceError implements IServiceError {

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceError {
}

export class ChangePasswordError extends ServiceError implements IChangePasswordError {
    type!: ChangePasswordErrorType;
    minLength?: number | undefined;

    constructor(data?: IChangePasswordError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.minLength = _data["minLength"];
        }
    }

    static fromJS(data: any): ChangePasswordError {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minLength"] = this.minLength;
        super.toJSON(data);
        return data;
    }
}

export interface IChangePasswordError extends IServiceError {
    type: ChangePasswordErrorType;
    minLength?: number | undefined;
}

export enum ChangePasswordErrorType {
    PasswordContainsEmail = "PasswordContainsEmail",
    UserMissing = "UserMissing",
    UserInactive = "UserInactive",
    UserMissingLoginCredentials = "UserMissingLoginCredentials",
    PasswordIncorrect = "PasswordIncorrect",
    PasswordTooShort = "PasswordTooShort",
    IncorrectUserOrToken = "IncorrectUserOrToken",
}

export class SendEmailToUsersItem implements ISendEmailToUsersItem {
    userId!: number;
    sendWelcomeEmail!: boolean;
    sendResetPassword!: boolean;
    sendToPrincipal!: boolean;

    constructor(data?: ISendEmailToUsersItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sendWelcomeEmail = _data["sendWelcomeEmail"];
            this.sendResetPassword = _data["sendResetPassword"];
            this.sendToPrincipal = _data["sendToPrincipal"];
        }
    }

    static fromJS(data: any): SendEmailToUsersItem {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailToUsersItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sendWelcomeEmail"] = this.sendWelcomeEmail;
        data["sendResetPassword"] = this.sendResetPassword;
        data["sendToPrincipal"] = this.sendToPrincipal;
        return data;
    }
}

export interface ISendEmailToUsersItem {
    userId: number;
    sendWelcomeEmail: boolean;
    sendResetPassword: boolean;
    sendToPrincipal: boolean;
}

export class UserSettings implements IUserSettings {
    openAssignedRoute!: boolean;
    futureActivityTimeInHours?: number | undefined;
    showExactTimeOnKioskActivity!: boolean;
    showCustomerMode!: boolean;

    constructor(data?: IUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openAssignedRoute = _data["openAssignedRoute"];
            this.futureActivityTimeInHours = _data["futureActivityTimeInHours"];
            this.showExactTimeOnKioskActivity = _data["showExactTimeOnKioskActivity"];
            this.showCustomerMode = _data["showCustomerMode"];
        }
    }

    static fromJS(data: any): UserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openAssignedRoute"] = this.openAssignedRoute;
        data["futureActivityTimeInHours"] = this.futureActivityTimeInHours;
        data["showExactTimeOnKioskActivity"] = this.showExactTimeOnKioskActivity;
        data["showCustomerMode"] = this.showCustomerMode;
        return data;
    }
}

export interface IUserSettings {
    openAssignedRoute: boolean;
    futureActivityTimeInHours?: number | undefined;
    showExactTimeOnKioskActivity: boolean;
    showCustomerMode: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}